import ct, { useState as on, useCallback as Tn, createContext as Bu, forwardRef as sn, useContext as cn, memo as Br, useMemo as sr, Fragment as of, useEffect as Si, useRef as qe } from "react";
import $ from "prop-types";
import af from "react-dom";
var pn = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function yo(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var Mi = { exports: {} }, Jn = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var xa;
function uf() {
  if (xa)
    return Jn;
  xa = 1;
  var t = ct, n = Symbol.for("react.element"), e = Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, i = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function a(u, c, f) {
    var s, l = {}, h = null, p = null;
    f !== void 0 && (h = "" + f), c.key !== void 0 && (h = "" + c.key), c.ref !== void 0 && (p = c.ref);
    for (s in c)
      r.call(c, s) && !o.hasOwnProperty(s) && (l[s] = c[s]);
    if (u && u.defaultProps)
      for (s in c = u.defaultProps, c)
        l[s] === void 0 && (l[s] = c[s]);
    return { $$typeof: n, type: u, key: h, ref: p, props: l, _owner: i.current };
  }
  return Jn.Fragment = e, Jn.jsx = a, Jn.jsxs = a, Jn;
}
var Qn = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var _a;
function sf() {
  return _a || (_a = 1, process.env.NODE_ENV !== "production" && function() {
    var t = ct, n = Symbol.for("react.element"), e = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), i = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), a = Symbol.for("react.provider"), u = Symbol.for("react.context"), c = Symbol.for("react.forward_ref"), f = Symbol.for("react.suspense"), s = Symbol.for("react.suspense_list"), l = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), p = Symbol.for("react.offscreen"), g = Symbol.iterator, w = "@@iterator";
    function b(d) {
      if (d === null || typeof d != "object")
        return null;
      var N = g && d[g] || d[w];
      return typeof N == "function" ? N : null;
    }
    var _ = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function S(d) {
      {
        for (var N = arguments.length, T = new Array(N > 1 ? N - 1 : 0), G = 1; G < N; G++)
          T[G - 1] = arguments[G];
        y("error", d, T);
      }
    }
    function y(d, N, T) {
      {
        var G = _.ReactDebugCurrentFrame, J = G.getStackAddendum();
        J !== "" && (N += "%s", T = T.concat([J]));
        var et = T.map(function(K) {
          return String(K);
        });
        et.unshift("Warning: " + N), Function.prototype.apply.call(console[d], console, et);
      }
    }
    var E = !1, M = !1, R = !1, j = !1, I = !1, q;
    q = Symbol.for("react.module.reference");
    function W(d) {
      return !!(typeof d == "string" || typeof d == "function" || d === r || d === o || I || d === i || d === f || d === s || j || d === p || E || M || R || typeof d == "object" && d !== null && (d.$$typeof === h || d.$$typeof === l || d.$$typeof === a || d.$$typeof === u || d.$$typeof === c || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      d.$$typeof === q || d.getModuleId !== void 0));
    }
    function P(d, N, T) {
      var G = d.displayName;
      if (G)
        return G;
      var J = N.displayName || N.name || "";
      return J !== "" ? T + "(" + J + ")" : T;
    }
    function B(d) {
      return d.displayName || "Context";
    }
    function L(d) {
      if (d == null)
        return null;
      if (typeof d.tag == "number" && S("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof d == "function")
        return d.displayName || d.name || null;
      if (typeof d == "string")
        return d;
      switch (d) {
        case r:
          return "Fragment";
        case e:
          return "Portal";
        case o:
          return "Profiler";
        case i:
          return "StrictMode";
        case f:
          return "Suspense";
        case s:
          return "SuspenseList";
      }
      if (typeof d == "object")
        switch (d.$$typeof) {
          case u:
            var N = d;
            return B(N) + ".Consumer";
          case a:
            var T = d;
            return B(T._context) + ".Provider";
          case c:
            return P(d, d.render, "ForwardRef");
          case l:
            var G = d.displayName || null;
            return G !== null ? G : L(d.type) || "Memo";
          case h: {
            var J = d, et = J._payload, K = J._init;
            try {
              return L(K(et));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var v = Object.assign, m = 0, x, C, A, k, Y, H, V;
    function nt() {
    }
    nt.__reactDisabledLog = !0;
    function Q() {
      {
        if (m === 0) {
          x = console.log, C = console.info, A = console.warn, k = console.error, Y = console.group, H = console.groupCollapsed, V = console.groupEnd;
          var d = {
            configurable: !0,
            enumerable: !0,
            value: nt,
            writable: !0
          };
          Object.defineProperties(console, {
            info: d,
            log: d,
            warn: d,
            error: d,
            group: d,
            groupCollapsed: d,
            groupEnd: d
          });
        }
        m++;
      }
    }
    function it() {
      {
        if (m--, m === 0) {
          var d = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: v({}, d, {
              value: x
            }),
            info: v({}, d, {
              value: C
            }),
            warn: v({}, d, {
              value: A
            }),
            error: v({}, d, {
              value: k
            }),
            group: v({}, d, {
              value: Y
            }),
            groupCollapsed: v({}, d, {
              value: H
            }),
            groupEnd: v({}, d, {
              value: V
            })
          });
        }
        m < 0 && S("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var dt = _.ReactCurrentDispatcher, gt;
    function vt(d, N, T) {
      {
        if (gt === void 0)
          try {
            throw Error();
          } catch (J) {
            var G = J.stack.trim().match(/\n( *(at )?)/);
            gt = G && G[1] || "";
          }
        return `
` + gt + d;
      }
    }
    var ot = !1, Ct;
    {
      var dn = typeof WeakMap == "function" ? WeakMap : Map;
      Ct = new dn();
    }
    function Zn(d, N) {
      if (!d || ot)
        return "";
      {
        var T = Ct.get(d);
        if (T !== void 0)
          return T;
      }
      var G;
      ot = !0;
      var J = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var et;
      et = dt.current, dt.current = null, Q();
      try {
        if (N) {
          var K = function() {
            throw Error();
          };
          if (Object.defineProperty(K.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(K, []);
            } catch (tn) {
              G = tn;
            }
            Reflect.construct(d, [], K);
          } else {
            try {
              K.call();
            } catch (tn) {
              G = tn;
            }
            d.call(K.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (tn) {
            G = tn;
          }
          d();
        }
      } catch (tn) {
        if (tn && G && typeof tn.stack == "string") {
          for (var U = tn.stack.split(`
`), xt = G.stack.split(`
`), lt = U.length - 1, ht = xt.length - 1; lt >= 1 && ht >= 0 && U[lt] !== xt[ht]; )
            ht--;
          for (; lt >= 1 && ht >= 0; lt--, ht--)
            if (U[lt] !== xt[ht]) {
              if (lt !== 1 || ht !== 1)
                do
                  if (lt--, ht--, ht < 0 || U[lt] !== xt[ht]) {
                    var Ft = `
` + U[lt].replace(" at new ", " at ");
                    return d.displayName && Ft.includes("<anonymous>") && (Ft = Ft.replace("<anonymous>", d.displayName)), typeof d == "function" && Ct.set(d, Ft), Ft;
                  }
                while (lt >= 1 && ht >= 0);
              break;
            }
        }
      } finally {
        ot = !1, dt.current = et, it(), Error.prepareStackTrace = J;
      }
      var kn = d ? d.displayName || d.name : "", ya = kn ? vt(kn) : "";
      return typeof d == "function" && Ct.set(d, ya), ya;
    }
    function Fe(d, N, T) {
      return Zn(d, !1);
    }
    function Fc(d) {
      var N = d.prototype;
      return !!(N && N.isReactComponent);
    }
    function De(d, N, T) {
      if (d == null)
        return "";
      if (typeof d == "function")
        return Zn(d, Fc(d));
      if (typeof d == "string")
        return vt(d);
      switch (d) {
        case f:
          return vt("Suspense");
        case s:
          return vt("SuspenseList");
      }
      if (typeof d == "object")
        switch (d.$$typeof) {
          case c:
            return Fe(d.render);
          case l:
            return De(d.type, N, T);
          case h: {
            var G = d, J = G._payload, et = G._init;
            try {
              return De(et(J), N, T);
            } catch {
            }
          }
        }
      return "";
    }
    var Ie = Object.prototype.hasOwnProperty, aa = {}, ua = _.ReactDebugCurrentFrame;
    function Le(d) {
      if (d) {
        var N = d._owner, T = De(d.type, d._source, N ? N.type : null);
        ua.setExtraStackFrame(T);
      } else
        ua.setExtraStackFrame(null);
    }
    function Dc(d, N, T, G, J) {
      {
        var et = Function.call.bind(Ie);
        for (var K in d)
          if (et(d, K)) {
            var U = void 0;
            try {
              if (typeof d[K] != "function") {
                var xt = Error((G || "React class") + ": " + T + " type `" + K + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof d[K] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw xt.name = "Invariant Violation", xt;
              }
              U = d[K](N, K, G, T, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (lt) {
              U = lt;
            }
            U && !(U instanceof Error) && (Le(J), S("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", G || "React class", T, K, typeof U), Le(null)), U instanceof Error && !(U.message in aa) && (aa[U.message] = !0, Le(J), S("Failed %s type: %s", T, U.message), Le(null));
          }
      }
    }
    var Ic = Array.isArray;
    function ri(d) {
      return Ic(d);
    }
    function Lc(d) {
      {
        var N = typeof Symbol == "function" && Symbol.toStringTag, T = N && d[Symbol.toStringTag] || d.constructor.name || "Object";
        return T;
      }
    }
    function qc(d) {
      try {
        return sa(d), !1;
      } catch {
        return !0;
      }
    }
    function sa(d) {
      return "" + d;
    }
    function ca(d) {
      if (qc(d))
        return S("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Lc(d)), sa(d);
    }
    var Kn = _.ReactCurrentOwner, Yc = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, fa, la, ii;
    ii = {};
    function Gc(d) {
      if (Ie.call(d, "ref")) {
        var N = Object.getOwnPropertyDescriptor(d, "ref").get;
        if (N && N.isReactWarning)
          return !1;
      }
      return d.ref !== void 0;
    }
    function Wc(d) {
      if (Ie.call(d, "key")) {
        var N = Object.getOwnPropertyDescriptor(d, "key").get;
        if (N && N.isReactWarning)
          return !1;
      }
      return d.key !== void 0;
    }
    function Bc(d, N) {
      if (typeof d.ref == "string" && Kn.current && N && Kn.current.stateNode !== N) {
        var T = L(Kn.current.type);
        ii[T] || (S('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', L(Kn.current.type), d.ref), ii[T] = !0);
      }
    }
    function Hc(d, N) {
      {
        var T = function() {
          fa || (fa = !0, S("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", N));
        };
        T.isReactWarning = !0, Object.defineProperty(d, "key", {
          get: T,
          configurable: !0
        });
      }
    }
    function Xc(d, N) {
      {
        var T = function() {
          la || (la = !0, S("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", N));
        };
        T.isReactWarning = !0, Object.defineProperty(d, "ref", {
          get: T,
          configurable: !0
        });
      }
    }
    var Uc = function(d, N, T, G, J, et, K) {
      var U = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: n,
        // Built-in properties that belong on the element
        type: d,
        key: N,
        ref: T,
        props: K,
        // Record the component responsible for creating this element.
        _owner: et
      };
      return U._store = {}, Object.defineProperty(U._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(U, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: G
      }), Object.defineProperty(U, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: J
      }), Object.freeze && (Object.freeze(U.props), Object.freeze(U)), U;
    };
    function Vc(d, N, T, G, J) {
      {
        var et, K = {}, U = null, xt = null;
        T !== void 0 && (ca(T), U = "" + T), Wc(N) && (ca(N.key), U = "" + N.key), Gc(N) && (xt = N.ref, Bc(N, J));
        for (et in N)
          Ie.call(N, et) && !Yc.hasOwnProperty(et) && (K[et] = N[et]);
        if (d && d.defaultProps) {
          var lt = d.defaultProps;
          for (et in lt)
            K[et] === void 0 && (K[et] = lt[et]);
        }
        if (U || xt) {
          var ht = typeof d == "function" ? d.displayName || d.name || "Unknown" : d;
          U && Hc(K, ht), xt && Xc(K, ht);
        }
        return Uc(d, U, xt, J, G, Kn.current, K);
      }
    }
    var oi = _.ReactCurrentOwner, ha = _.ReactDebugCurrentFrame;
    function Rn(d) {
      if (d) {
        var N = d._owner, T = De(d.type, d._source, N ? N.type : null);
        ha.setExtraStackFrame(T);
      } else
        ha.setExtraStackFrame(null);
    }
    var ai;
    ai = !1;
    function ui(d) {
      return typeof d == "object" && d !== null && d.$$typeof === n;
    }
    function pa() {
      {
        if (oi.current) {
          var d = L(oi.current.type);
          if (d)
            return `

Check the render method of \`` + d + "`.";
        }
        return "";
      }
    }
    function Zc(d) {
      {
        if (d !== void 0) {
          var N = d.fileName.replace(/^.*[\\\/]/, ""), T = d.lineNumber;
          return `

Check your code at ` + N + ":" + T + ".";
        }
        return "";
      }
    }
    var da = {};
    function Kc(d) {
      {
        var N = pa();
        if (!N) {
          var T = typeof d == "string" ? d : d.displayName || d.name;
          T && (N = `

Check the top-level render call using <` + T + ">.");
        }
        return N;
      }
    }
    function ga(d, N) {
      {
        if (!d._store || d._store.validated || d.key != null)
          return;
        d._store.validated = !0;
        var T = Kc(N);
        if (da[T])
          return;
        da[T] = !0;
        var G = "";
        d && d._owner && d._owner !== oi.current && (G = " It was passed a child from " + L(d._owner.type) + "."), Rn(d), S('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', T, G), Rn(null);
      }
    }
    function va(d, N) {
      {
        if (typeof d != "object")
          return;
        if (ri(d))
          for (var T = 0; T < d.length; T++) {
            var G = d[T];
            ui(G) && ga(G, N);
          }
        else if (ui(d))
          d._store && (d._store.validated = !0);
        else if (d) {
          var J = b(d);
          if (typeof J == "function" && J !== d.entries)
            for (var et = J.call(d), K; !(K = et.next()).done; )
              ui(K.value) && ga(K.value, N);
        }
      }
    }
    function Jc(d) {
      {
        var N = d.type;
        if (N == null || typeof N == "string")
          return;
        var T;
        if (typeof N == "function")
          T = N.propTypes;
        else if (typeof N == "object" && (N.$$typeof === c || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        N.$$typeof === l))
          T = N.propTypes;
        else
          return;
        if (T) {
          var G = L(N);
          Dc(T, d.props, "prop", G, d);
        } else if (N.PropTypes !== void 0 && !ai) {
          ai = !0;
          var J = L(N);
          S("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", J || "Unknown");
        }
        typeof N.getDefaultProps == "function" && !N.getDefaultProps.isReactClassApproved && S("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function Qc(d) {
      {
        for (var N = Object.keys(d.props), T = 0; T < N.length; T++) {
          var G = N[T];
          if (G !== "children" && G !== "key") {
            Rn(d), S("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", G), Rn(null);
            break;
          }
        }
        d.ref !== null && (Rn(d), S("Invalid attribute `ref` supplied to `React.Fragment`."), Rn(null));
      }
    }
    function ma(d, N, T, G, J, et) {
      {
        var K = W(d);
        if (!K) {
          var U = "";
          (d === void 0 || typeof d == "object" && d !== null && Object.keys(d).length === 0) && (U += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var xt = Zc(J);
          xt ? U += xt : U += pa();
          var lt;
          d === null ? lt = "null" : ri(d) ? lt = "array" : d !== void 0 && d.$$typeof === n ? (lt = "<" + (L(d.type) || "Unknown") + " />", U = " Did you accidentally export a JSX literal instead of a component?") : lt = typeof d, S("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", lt, U);
        }
        var ht = Vc(d, N, T, J, et);
        if (ht == null)
          return ht;
        if (K) {
          var Ft = N.children;
          if (Ft !== void 0)
            if (G)
              if (ri(Ft)) {
                for (var kn = 0; kn < Ft.length; kn++)
                  va(Ft[kn], d);
                Object.freeze && Object.freeze(Ft);
              } else
                S("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              va(Ft, d);
        }
        return d === r ? Qc(ht) : Jc(ht), ht;
      }
    }
    function tf(d, N, T) {
      return ma(d, N, T, !0);
    }
    function nf(d, N, T) {
      return ma(d, N, T, !1);
    }
    var ef = nf, rf = tf;
    Qn.Fragment = r, Qn.jsx = ef, Qn.jsxs = rf;
  }()), Qn;
}
process.env.NODE_ENV === "production" ? Mi.exports = uf() : Mi.exports = sf();
var tt = Mi.exports, Hu = Symbol.for("immer-nothing"), wa = Symbol.for("immer-draftable"), jt = Symbol.for("immer-state"), cf = process.env.NODE_ENV !== "production" ? [
  // All error codes, starting by 0:
  function(t) {
    return `The plugin for '${t}' has not been loaded into Immer. To enable the plugin, import and call \`enable${t}()\` when initializing your application.`;
  },
  function(t) {
    return `produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '${t}'`;
  },
  "This object has been frozen and should not be mutated",
  function(t) {
    return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + t;
  },
  "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
  "Immer forbids circular references",
  "The first or second argument to `produce` must be a function",
  "The third argument to `produce` must be a function or undefined",
  "First argument to `createDraft` must be a plain object, an array, or an immerable object",
  "First argument to `finishDraft` must be a draft returned by `createDraft`",
  function(t) {
    return `'current' expects a draft, got: ${t}`;
  },
  "Object.defineProperty() cannot be used on an Immer draft",
  "Object.setPrototypeOf() cannot be used on an Immer draft",
  "Immer only supports deleting array indices",
  "Immer only supports setting array indices and the 'length' property",
  function(t) {
    return `'original' expects a draft, got: ${t}`;
  }
  // Note: if more errors are added, the errorOffset in Patches.ts should be increased
  // See Patches.ts for additional errors
] : [];
function $t(t, ...n) {
  if (process.env.NODE_ENV !== "production") {
    const e = cf[t], r = typeof e == "function" ? e.apply(null, n) : e;
    throw new Error(`[Immer] ${r}`);
  }
  throw new Error(
    `[Immer] minified error nr: ${t}. Full error at: https://bit.ly/3cXEKWf`
  );
}
var Ln = Object.getPrototypeOf;
function qn(t) {
  return !!t && !!t[jt];
}
function bn(t) {
  var n;
  return t ? Xu(t) || Array.isArray(t) || !!t[wa] || !!((n = t.constructor) != null && n[wa]) || Xr(t) || Ur(t) : !1;
}
var ff = Object.prototype.constructor.toString();
function Xu(t) {
  if (!t || typeof t != "object")
    return !1;
  const n = Ln(t);
  if (n === null)
    return !0;
  const e = Object.hasOwnProperty.call(n, "constructor") && n.constructor;
  return e === Object ? !0 : typeof e == "function" && Function.toString.call(e) === ff;
}
function ge(t, n) {
  Hr(t) === 0 ? Object.entries(t).forEach(([e, r]) => {
    n(e, r, t);
  }) : t.forEach((e, r) => n(r, e, t));
}
function Hr(t) {
  const n = t[jt];
  return n ? n.type_ : Array.isArray(t) ? 1 : Xr(t) ? 2 : Ur(t) ? 3 : 0;
}
function Ni(t, n) {
  return Hr(t) === 2 ? t.has(n) : Object.prototype.hasOwnProperty.call(t, n);
}
function Uu(t, n, e) {
  const r = Hr(t);
  r === 2 ? t.set(n, e) : r === 3 ? t.add(e) : t[n] = e;
}
function lf(t, n) {
  return t === n ? t !== 0 || 1 / t === 1 / n : t !== t && n !== n;
}
function Xr(t) {
  return t instanceof Map;
}
function Ur(t) {
  return t instanceof Set;
}
function mn(t) {
  return t.copy_ || t.base_;
}
function $i(t, n) {
  if (Xr(t))
    return new Map(t);
  if (Ur(t))
    return new Set(t);
  if (Array.isArray(t))
    return Array.prototype.slice.call(t);
  if (!n && Xu(t))
    return Ln(t) ? { ...t } : Object.assign(/* @__PURE__ */ Object.create(null), t);
  const e = Object.getOwnPropertyDescriptors(t);
  delete e[jt];
  let r = Reflect.ownKeys(e);
  for (let i = 0; i < r.length; i++) {
    const o = r[i], a = e[o];
    a.writable === !1 && (a.writable = !0, a.configurable = !0), (a.get || a.set) && (e[o] = {
      configurable: !0,
      writable: !0,
      // could live with !!desc.set as well here...
      enumerable: a.enumerable,
      value: t[o]
    });
  }
  return Object.create(Ln(t), e);
}
function xo(t, n = !1) {
  return Vr(t) || qn(t) || !bn(t) || (Hr(t) > 1 && (t.set = t.add = t.clear = t.delete = hf), Object.freeze(t), n && ge(t, (e, r) => xo(r, !0))), t;
}
function hf() {
  $t(2);
}
function Vr(t) {
  return Object.isFrozen(t);
}
var pf = {};
function En(t) {
  const n = pf[t];
  return n || $t(0, t), n;
}
var ve;
function Vu() {
  return ve;
}
function df(t, n) {
  return {
    drafts_: [],
    parent_: t,
    immer_: n,
    // Whenever the modified draft contains a draft from another scope, we
    // need to prevent auto-freezing so the unowned draft can be finalized.
    canAutoFreeze_: !0,
    unfinalizedDrafts_: 0
  };
}
function ba(t, n) {
  n && (En("Patches"), t.patches_ = [], t.inversePatches_ = [], t.patchListener_ = n);
}
function Pi(t) {
  Ri(t), t.drafts_.forEach(gf), t.drafts_ = null;
}
function Ri(t) {
  t === ve && (ve = t.parent_);
}
function Ea(t) {
  return ve = df(ve, t);
}
function gf(t) {
  const n = t[jt];
  n.type_ === 0 || n.type_ === 1 ? n.revoke_() : n.revoked_ = !0;
}
function Sa(t, n) {
  n.unfinalizedDrafts_ = n.drafts_.length;
  const e = n.drafts_[0];
  return t !== void 0 && t !== e ? (e[jt].modified_ && (Pi(n), $t(4)), bn(t) && (t = cr(n, t), n.parent_ || fr(n, t)), n.patches_ && En("Patches").generateReplacementPatches_(
    e[jt].base_,
    t,
    n.patches_,
    n.inversePatches_
  )) : t = cr(n, e, []), Pi(n), n.patches_ && n.patchListener_(n.patches_, n.inversePatches_), t !== Hu ? t : void 0;
}
function cr(t, n, e) {
  if (Vr(n))
    return n;
  const r = n[jt];
  if (!r)
    return ge(
      n,
      (i, o) => Ma(t, r, n, i, o, e)
    ), n;
  if (r.scope_ !== t)
    return n;
  if (!r.modified_)
    return fr(t, r.base_, !0), r.base_;
  if (!r.finalized_) {
    r.finalized_ = !0, r.scope_.unfinalizedDrafts_--;
    const i = r.copy_;
    let o = i, a = !1;
    r.type_ === 3 && (o = new Set(i), i.clear(), a = !0), ge(
      o,
      (u, c) => Ma(t, r, i, u, c, e, a)
    ), fr(t, i, !1), e && t.patches_ && En("Patches").generatePatches_(
      r,
      e,
      t.patches_,
      t.inversePatches_
    );
  }
  return r.copy_;
}
function Ma(t, n, e, r, i, o, a) {
  if (process.env.NODE_ENV !== "production" && i === e && $t(5), qn(i)) {
    const u = o && n && n.type_ !== 3 && // Set objects are atomic since they have no keys.
    !Ni(n.assigned_, r) ? o.concat(r) : void 0, c = cr(t, i, u);
    if (Uu(e, r, c), qn(c))
      t.canAutoFreeze_ = !1;
    else
      return;
  } else
    a && e.add(i);
  if (bn(i) && !Vr(i)) {
    if (!t.immer_.autoFreeze_ && t.unfinalizedDrafts_ < 1)
      return;
    cr(t, i), (!n || !n.scope_.parent_) && fr(t, i);
  }
}
function fr(t, n, e = !1) {
  !t.parent_ && t.immer_.autoFreeze_ && t.canAutoFreeze_ && xo(n, e);
}
function vf(t, n) {
  const e = Array.isArray(t), r = {
    type_: e ? 1 : 0,
    // Track which produce call this is associated with.
    scope_: n ? n.scope_ : Vu(),
    // True for both shallow and deep changes.
    modified_: !1,
    // Used during finalization.
    finalized_: !1,
    // Track which properties have been assigned (true) or deleted (false).
    assigned_: {},
    // The parent draft state.
    parent_: n,
    // The base state.
    base_: t,
    // The base proxy.
    draft_: null,
    // set below
    // The base copy with any updated values.
    copy_: null,
    // Called by the `produce` function.
    revoke_: null,
    isManual_: !1
  };
  let i = r, o = _o;
  e && (i = [r], o = me);
  const { revoke: a, proxy: u } = Proxy.revocable(i, o);
  return r.draft_ = u, r.revoke_ = a, u;
}
var _o = {
  get(t, n) {
    if (n === jt)
      return t;
    const e = mn(t);
    if (!Ni(e, n))
      return mf(t, e, n);
    const r = e[n];
    return t.finalized_ || !bn(r) ? r : r === si(t.base_, n) ? (ci(t), t.copy_[n] = Ci(r, t)) : r;
  },
  has(t, n) {
    return n in mn(t);
  },
  ownKeys(t) {
    return Reflect.ownKeys(mn(t));
  },
  set(t, n, e) {
    const r = Zu(mn(t), n);
    if (r != null && r.set)
      return r.set.call(t.draft_, e), !0;
    if (!t.modified_) {
      const i = si(mn(t), n), o = i == null ? void 0 : i[jt];
      if (o && o.base_ === e)
        return t.copy_[n] = e, t.assigned_[n] = !1, !0;
      if (lf(e, i) && (e !== void 0 || Ni(t.base_, n)))
        return !0;
      ci(t), ki(t);
    }
    return t.copy_[n] === e && // special case: handle new props with value 'undefined'
    (e !== void 0 || n in t.copy_) || // special case: NaN
    Number.isNaN(e) && Number.isNaN(t.copy_[n]) || (t.copy_[n] = e, t.assigned_[n] = !0), !0;
  },
  deleteProperty(t, n) {
    return si(t.base_, n) !== void 0 || n in t.base_ ? (t.assigned_[n] = !1, ci(t), ki(t)) : delete t.assigned_[n], t.copy_ && delete t.copy_[n], !0;
  },
  // Note: We never coerce `desc.value` into an Immer draft, because we can't make
  // the same guarantee in ES5 mode.
  getOwnPropertyDescriptor(t, n) {
    const e = mn(t), r = Reflect.getOwnPropertyDescriptor(e, n);
    return r && {
      writable: !0,
      configurable: t.type_ !== 1 || n !== "length",
      enumerable: r.enumerable,
      value: e[n]
    };
  },
  defineProperty() {
    $t(11);
  },
  getPrototypeOf(t) {
    return Ln(t.base_);
  },
  setPrototypeOf() {
    $t(12);
  }
}, me = {};
ge(_o, (t, n) => {
  me[t] = function() {
    return arguments[0] = arguments[0][0], n.apply(this, arguments);
  };
});
me.deleteProperty = function(t, n) {
  return process.env.NODE_ENV !== "production" && isNaN(parseInt(n)) && $t(13), me.set.call(this, t, n, void 0);
};
me.set = function(t, n, e) {
  return process.env.NODE_ENV !== "production" && n !== "length" && isNaN(parseInt(n)) && $t(14), _o.set.call(this, t[0], n, e, t[0]);
};
function si(t, n) {
  const e = t[jt];
  return (e ? mn(e) : t)[n];
}
function mf(t, n, e) {
  var i;
  const r = Zu(n, e);
  return r ? "value" in r ? r.value : (
    // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    (i = r.get) == null ? void 0 : i.call(t.draft_)
  ) : void 0;
}
function Zu(t, n) {
  if (!(n in t))
    return;
  let e = Ln(t);
  for (; e; ) {
    const r = Object.getOwnPropertyDescriptor(e, n);
    if (r)
      return r;
    e = Ln(e);
  }
}
function ki(t) {
  t.modified_ || (t.modified_ = !0, t.parent_ && ki(t.parent_));
}
function ci(t) {
  t.copy_ || (t.copy_ = $i(
    t.base_,
    t.scope_.immer_.useStrictShallowCopy_
  ));
}
var yf = class {
  constructor(t) {
    this.autoFreeze_ = !0, this.useStrictShallowCopy_ = !1, this.produce = (n, e, r) => {
      if (typeof n == "function" && typeof e != "function") {
        const o = e;
        e = n;
        const a = this;
        return function(c = o, ...f) {
          return a.produce(c, (s) => e.call(this, s, ...f));
        };
      }
      typeof e != "function" && $t(6), r !== void 0 && typeof r != "function" && $t(7);
      let i;
      if (bn(n)) {
        const o = Ea(this), a = Ci(n, void 0);
        let u = !0;
        try {
          i = e(a), u = !1;
        } finally {
          u ? Pi(o) : Ri(o);
        }
        return ba(o, r), Sa(i, o);
      } else if (!n || typeof n != "object") {
        if (i = e(n), i === void 0 && (i = n), i === Hu && (i = void 0), this.autoFreeze_ && xo(i, !0), r) {
          const o = [], a = [];
          En("Patches").generateReplacementPatches_(n, i, o, a), r(o, a);
        }
        return i;
      } else
        $t(1, n);
    }, this.produceWithPatches = (n, e) => {
      if (typeof n == "function")
        return (a, ...u) => this.produceWithPatches(a, (c) => n(c, ...u));
      let r, i;
      return [this.produce(n, e, (a, u) => {
        r = a, i = u;
      }), r, i];
    }, typeof (t == null ? void 0 : t.autoFreeze) == "boolean" && this.setAutoFreeze(t.autoFreeze), typeof (t == null ? void 0 : t.useStrictShallowCopy) == "boolean" && this.setUseStrictShallowCopy(t.useStrictShallowCopy);
  }
  createDraft(t) {
    bn(t) || $t(8), qn(t) && (t = xf(t));
    const n = Ea(this), e = Ci(t, void 0);
    return e[jt].isManual_ = !0, Ri(n), e;
  }
  finishDraft(t, n) {
    const e = t && t[jt];
    (!e || !e.isManual_) && $t(9);
    const { scope_: r } = e;
    return ba(r, n), Sa(void 0, r);
  }
  /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */
  setAutoFreeze(t) {
    this.autoFreeze_ = t;
  }
  /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */
  setUseStrictShallowCopy(t) {
    this.useStrictShallowCopy_ = t;
  }
  applyPatches(t, n) {
    let e;
    for (e = n.length - 1; e >= 0; e--) {
      const i = n[e];
      if (i.path.length === 0 && i.op === "replace") {
        t = i.value;
        break;
      }
    }
    e > -1 && (n = n.slice(e + 1));
    const r = En("Patches").applyPatches_;
    return qn(t) ? r(t, n) : this.produce(
      t,
      (i) => r(i, n)
    );
  }
};
function Ci(t, n) {
  const e = Xr(t) ? En("MapSet").proxyMap_(t, n) : Ur(t) ? En("MapSet").proxySet_(t, n) : vf(t, n);
  return (n ? n.scope_ : Vu()).drafts_.push(e), e;
}
function xf(t) {
  return qn(t) || $t(10, t), Ku(t);
}
function Ku(t) {
  if (!bn(t) || Vr(t))
    return t;
  const n = t[jt];
  let e;
  if (n) {
    if (!n.modified_)
      return n.base_;
    n.finalized_ = !0, e = $i(t, n.scope_.immer_.useStrictShallowCopy_);
  } else
    e = $i(t, !0);
  return ge(e, (r, i) => {
    Uu(e, r, Ku(i));
  }), n && (n.finalized_ = !1), e;
}
var zt = new yf(), fi = zt.produce;
zt.produceWithPatches.bind(
  zt
);
zt.setAutoFreeze.bind(zt);
zt.setUseStrictShallowCopy.bind(zt);
zt.applyPatches.bind(zt);
zt.createDraft.bind(zt);
zt.finishDraft.bind(zt);
var _f = "Expected a function", Ju = "__lodash_hash_undefined__", wf = "[object Function]", bf = "[object GeneratorFunction]", Ef = /[\\^$.*+?()[\]{}|]/g, Sf = /^\[object .+?Constructor\]$/, Mf = typeof pn == "object" && pn && pn.Object === Object && pn, Nf = typeof self == "object" && self && self.Object === Object && self, Qu = Mf || Nf || Function("return this")();
function $f(t, n) {
  return t == null ? void 0 : t[n];
}
function Pf(t) {
  var n = !1;
  if (t != null && typeof t.toString != "function")
    try {
      n = !!(t + "");
    } catch {
    }
  return n;
}
var Rf = Array.prototype, kf = Function.prototype, ts = Object.prototype, li = Qu["__core-js_shared__"], Na = function() {
  var t = /[^.]+$/.exec(li && li.keys && li.keys.IE_PROTO || "");
  return t ? "Symbol(src)_1." + t : "";
}(), ns = kf.toString, wo = ts.hasOwnProperty, Cf = ts.toString, Tf = RegExp(
  "^" + ns.call(wo).replace(Ef, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
), Af = Rf.splice, Of = es(Qu, "Map"), ye = es(Object, "create");
function Sn(t) {
  var n = -1, e = t ? t.length : 0;
  for (this.clear(); ++n < e; ) {
    var r = t[n];
    this.set(r[0], r[1]);
  }
}
function jf() {
  this.__data__ = ye ? ye(null) : {};
}
function zf(t) {
  return this.has(t) && delete this.__data__[t];
}
function Ff(t) {
  var n = this.__data__;
  if (ye) {
    var e = n[t];
    return e === Ju ? void 0 : e;
  }
  return wo.call(n, t) ? n[t] : void 0;
}
function Df(t) {
  var n = this.__data__;
  return ye ? n[t] !== void 0 : wo.call(n, t);
}
function If(t, n) {
  var e = this.__data__;
  return e[t] = ye && n === void 0 ? Ju : n, this;
}
Sn.prototype.clear = jf;
Sn.prototype.delete = zf;
Sn.prototype.get = Ff;
Sn.prototype.has = Df;
Sn.prototype.set = If;
function Un(t) {
  var n = -1, e = t ? t.length : 0;
  for (this.clear(); ++n < e; ) {
    var r = t[n];
    this.set(r[0], r[1]);
  }
}
function Lf() {
  this.__data__ = [];
}
function qf(t) {
  var n = this.__data__, e = Zr(n, t);
  if (e < 0)
    return !1;
  var r = n.length - 1;
  return e == r ? n.pop() : Af.call(n, e, 1), !0;
}
function Yf(t) {
  var n = this.__data__, e = Zr(n, t);
  return e < 0 ? void 0 : n[e][1];
}
function Gf(t) {
  return Zr(this.__data__, t) > -1;
}
function Wf(t, n) {
  var e = this.__data__, r = Zr(e, t);
  return r < 0 ? e.push([t, n]) : e[r][1] = n, this;
}
Un.prototype.clear = Lf;
Un.prototype.delete = qf;
Un.prototype.get = Yf;
Un.prototype.has = Gf;
Un.prototype.set = Wf;
function Pn(t) {
  var n = -1, e = t ? t.length : 0;
  for (this.clear(); ++n < e; ) {
    var r = t[n];
    this.set(r[0], r[1]);
  }
}
function Bf() {
  this.__data__ = {
    hash: new Sn(),
    map: new (Of || Un)(),
    string: new Sn()
  };
}
function Hf(t) {
  return Kr(this, t).delete(t);
}
function Xf(t) {
  return Kr(this, t).get(t);
}
function Uf(t) {
  return Kr(this, t).has(t);
}
function Vf(t, n) {
  return Kr(this, t).set(t, n), this;
}
Pn.prototype.clear = Bf;
Pn.prototype.delete = Hf;
Pn.prototype.get = Xf;
Pn.prototype.has = Uf;
Pn.prototype.set = Vf;
function Zr(t, n) {
  for (var e = t.length; e--; )
    if (tl(t[e][0], n))
      return e;
  return -1;
}
function Zf(t) {
  if (!rs(t) || Jf(t))
    return !1;
  var n = nl(t) || Pf(t) ? Tf : Sf;
  return n.test(Qf(t));
}
function Kr(t, n) {
  var e = t.__data__;
  return Kf(n) ? e[typeof n == "string" ? "string" : "hash"] : e.map;
}
function es(t, n) {
  var e = $f(t, n);
  return Zf(e) ? e : void 0;
}
function Kf(t) {
  var n = typeof t;
  return n == "string" || n == "number" || n == "symbol" || n == "boolean" ? t !== "__proto__" : t === null;
}
function Jf(t) {
  return !!Na && Na in t;
}
function Qf(t) {
  if (t != null) {
    try {
      return ns.call(t);
    } catch {
    }
    try {
      return t + "";
    } catch {
    }
  }
  return "";
}
function bo(t, n) {
  if (typeof t != "function" || n && typeof n != "function")
    throw new TypeError(_f);
  var e = function() {
    var r = arguments, i = n ? n.apply(this, r) : r[0], o = e.cache;
    if (o.has(i))
      return o.get(i);
    var a = t.apply(this, r);
    return e.cache = o.set(i, a), a;
  };
  return e.cache = new (bo.Cache || Pn)(), e;
}
bo.Cache = Pn;
function tl(t, n) {
  return t === n || t !== t && n !== n;
}
function nl(t) {
  var n = rs(t) ? Cf.call(t) : "";
  return n == wf || n == bf;
}
function rs(t) {
  var n = typeof t;
  return !!t && (n == "object" || n == "function");
}
var el = bo;
const Eo = /* @__PURE__ */ yo(el);
function rl(t) {
  return t;
}
var il = rl;
const ol = /* @__PURE__ */ yo(il);
var al = "[object AsyncFunction]", ul = "[object Function]", sl = "[object GeneratorFunction]", cl = "[object Null]", fl = "[object Proxy]", ll = "[object Undefined]", hl = typeof pn == "object" && pn && pn.Object === Object && pn, pl = typeof self == "object" && self && self.Object === Object && self, dl = hl || pl || Function("return this")(), is = Object.prototype, gl = is.hasOwnProperty, os = is.toString, $a = dl.Symbol, xn = $a ? $a.toStringTag : void 0;
function vl(t) {
  return t == null ? t === void 0 ? ll : cl : xn && xn in Object(t) ? ml(t) : yl(t);
}
function ml(t) {
  var n = gl.call(t, xn), e = t[xn];
  try {
    t[xn] = void 0;
    var r = !0;
  } catch {
  }
  var i = os.call(t);
  return r && (n ? t[xn] = e : delete t[xn]), i;
}
function yl(t) {
  return os.call(t);
}
function xl(t) {
  if (!_l(t))
    return !1;
  var n = vl(t);
  return n == ul || n == sl || n == al || n == fl;
}
function _l(t) {
  var n = typeof t;
  return t != null && (n == "object" || n == "function");
}
var wl = xl;
const as = /* @__PURE__ */ yo(wl);
function tr(t, n) {
  return t == null || n == null ? NaN : t < n ? -1 : t > n ? 1 : t >= n ? 0 : NaN;
}
function bl(t, n) {
  return t == null || n == null ? NaN : n < t ? -1 : n > t ? 1 : n >= t ? 0 : NaN;
}
function us(t) {
  let n, e, r;
  t.length !== 2 ? (n = tr, e = (u, c) => tr(t(u), c), r = (u, c) => t(u) - c) : (n = t === tr || t === bl ? t : El, e = t, r = t);
  function i(u, c, f = 0, s = u.length) {
    if (f < s) {
      if (n(c, c) !== 0)
        return s;
      do {
        const l = f + s >>> 1;
        e(u[l], c) < 0 ? f = l + 1 : s = l;
      } while (f < s);
    }
    return f;
  }
  function o(u, c, f = 0, s = u.length) {
    if (f < s) {
      if (n(c, c) !== 0)
        return s;
      do {
        const l = f + s >>> 1;
        e(u[l], c) <= 0 ? f = l + 1 : s = l;
      } while (f < s);
    }
    return f;
  }
  function a(u, c, f = 0, s = u.length) {
    const l = i(u, c, f, s - 1);
    return l > f && r(u[l - 1], c) > -r(u[l], c) ? l - 1 : l;
  }
  return { left: i, center: a, right: o };
}
function El() {
  return 0;
}
function Sl(t) {
  return t === null ? NaN : +t;
}
const Ml = us(tr), Nl = Ml.right;
us(Sl).center;
const $l = Nl;
var Ti = Math.sqrt(50), Ai = Math.sqrt(10), Oi = Math.sqrt(2);
function Pl(t, n, e) {
  var r, i = -1, o, a, u;
  if (n = +n, t = +t, e = +e, t === n && e > 0)
    return [t];
  if ((r = n < t) && (o = t, t = n, n = o), (u = ss(t, n, e)) === 0 || !isFinite(u))
    return [];
  if (u > 0) {
    let c = Math.round(t / u), f = Math.round(n / u);
    for (c * u < t && ++c, f * u > n && --f, a = new Array(o = f - c + 1); ++i < o; )
      a[i] = (c + i) * u;
  } else {
    u = -u;
    let c = Math.round(t * u), f = Math.round(n * u);
    for (c / u < t && ++c, f / u > n && --f, a = new Array(o = f - c + 1); ++i < o; )
      a[i] = (c + i) / u;
  }
  return r && a.reverse(), a;
}
function ss(t, n, e) {
  var r = (n - t) / Math.max(0, e), i = Math.floor(Math.log(r) / Math.LN10), o = r / Math.pow(10, i);
  return i >= 0 ? (o >= Ti ? 10 : o >= Ai ? 5 : o >= Oi ? 2 : 1) * Math.pow(10, i) : -Math.pow(10, -i) / (o >= Ti ? 10 : o >= Ai ? 5 : o >= Oi ? 2 : 1);
}
function Rl(t, n, e) {
  var r = Math.abs(n - t) / Math.max(0, e), i = Math.pow(10, Math.floor(Math.log(r) / Math.LN10)), o = r / i;
  return o >= Ti ? i *= 10 : o >= Ai ? i *= 5 : o >= Oi && (i *= 2), n < t ? -i : i;
}
function kl(t, n) {
  switch (arguments.length) {
    case 0:
      break;
    case 1:
      this.range(t);
      break;
    default:
      this.range(n).domain(t);
      break;
  }
  return this;
}
function So(t, n, e) {
  t.prototype = n.prototype = e, e.constructor = t;
}
function cs(t, n) {
  var e = Object.create(t.prototype);
  for (var r in n)
    e[r] = n[r];
  return e;
}
function ke() {
}
var xe = 0.7, lr = 1 / xe, Fn = "\\s*([+-]?\\d+)\\s*", _e = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", Ut = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", Cl = /^#([0-9a-f]{3,8})$/, Tl = new RegExp(`^rgb\\(${Fn},${Fn},${Fn}\\)$`), Al = new RegExp(`^rgb\\(${Ut},${Ut},${Ut}\\)$`), Ol = new RegExp(`^rgba\\(${Fn},${Fn},${Fn},${_e}\\)$`), jl = new RegExp(`^rgba\\(${Ut},${Ut},${Ut},${_e}\\)$`), zl = new RegExp(`^hsl\\(${_e},${Ut},${Ut}\\)$`), Fl = new RegExp(`^hsla\\(${_e},${Ut},${Ut},${_e}\\)$`), Pa = {
  aliceblue: 15792383,
  antiquewhite: 16444375,
  aqua: 65535,
  aquamarine: 8388564,
  azure: 15794175,
  beige: 16119260,
  bisque: 16770244,
  black: 0,
  blanchedalmond: 16772045,
  blue: 255,
  blueviolet: 9055202,
  brown: 10824234,
  burlywood: 14596231,
  cadetblue: 6266528,
  chartreuse: 8388352,
  chocolate: 13789470,
  coral: 16744272,
  cornflowerblue: 6591981,
  cornsilk: 16775388,
  crimson: 14423100,
  cyan: 65535,
  darkblue: 139,
  darkcyan: 35723,
  darkgoldenrod: 12092939,
  darkgray: 11119017,
  darkgreen: 25600,
  darkgrey: 11119017,
  darkkhaki: 12433259,
  darkmagenta: 9109643,
  darkolivegreen: 5597999,
  darkorange: 16747520,
  darkorchid: 10040012,
  darkred: 9109504,
  darksalmon: 15308410,
  darkseagreen: 9419919,
  darkslateblue: 4734347,
  darkslategray: 3100495,
  darkslategrey: 3100495,
  darkturquoise: 52945,
  darkviolet: 9699539,
  deeppink: 16716947,
  deepskyblue: 49151,
  dimgray: 6908265,
  dimgrey: 6908265,
  dodgerblue: 2003199,
  firebrick: 11674146,
  floralwhite: 16775920,
  forestgreen: 2263842,
  fuchsia: 16711935,
  gainsboro: 14474460,
  ghostwhite: 16316671,
  gold: 16766720,
  goldenrod: 14329120,
  gray: 8421504,
  green: 32768,
  greenyellow: 11403055,
  grey: 8421504,
  honeydew: 15794160,
  hotpink: 16738740,
  indianred: 13458524,
  indigo: 4915330,
  ivory: 16777200,
  khaki: 15787660,
  lavender: 15132410,
  lavenderblush: 16773365,
  lawngreen: 8190976,
  lemonchiffon: 16775885,
  lightblue: 11393254,
  lightcoral: 15761536,
  lightcyan: 14745599,
  lightgoldenrodyellow: 16448210,
  lightgray: 13882323,
  lightgreen: 9498256,
  lightgrey: 13882323,
  lightpink: 16758465,
  lightsalmon: 16752762,
  lightseagreen: 2142890,
  lightskyblue: 8900346,
  lightslategray: 7833753,
  lightslategrey: 7833753,
  lightsteelblue: 11584734,
  lightyellow: 16777184,
  lime: 65280,
  limegreen: 3329330,
  linen: 16445670,
  magenta: 16711935,
  maroon: 8388608,
  mediumaquamarine: 6737322,
  mediumblue: 205,
  mediumorchid: 12211667,
  mediumpurple: 9662683,
  mediumseagreen: 3978097,
  mediumslateblue: 8087790,
  mediumspringgreen: 64154,
  mediumturquoise: 4772300,
  mediumvioletred: 13047173,
  midnightblue: 1644912,
  mintcream: 16121850,
  mistyrose: 16770273,
  moccasin: 16770229,
  navajowhite: 16768685,
  navy: 128,
  oldlace: 16643558,
  olive: 8421376,
  olivedrab: 7048739,
  orange: 16753920,
  orangered: 16729344,
  orchid: 14315734,
  palegoldenrod: 15657130,
  palegreen: 10025880,
  paleturquoise: 11529966,
  palevioletred: 14381203,
  papayawhip: 16773077,
  peachpuff: 16767673,
  peru: 13468991,
  pink: 16761035,
  plum: 14524637,
  powderblue: 11591910,
  purple: 8388736,
  rebeccapurple: 6697881,
  red: 16711680,
  rosybrown: 12357519,
  royalblue: 4286945,
  saddlebrown: 9127187,
  salmon: 16416882,
  sandybrown: 16032864,
  seagreen: 3050327,
  seashell: 16774638,
  sienna: 10506797,
  silver: 12632256,
  skyblue: 8900331,
  slateblue: 6970061,
  slategray: 7372944,
  slategrey: 7372944,
  snow: 16775930,
  springgreen: 65407,
  steelblue: 4620980,
  tan: 13808780,
  teal: 32896,
  thistle: 14204888,
  tomato: 16737095,
  turquoise: 4251856,
  violet: 15631086,
  wheat: 16113331,
  white: 16777215,
  whitesmoke: 16119285,
  yellow: 16776960,
  yellowgreen: 10145074
};
So(ke, we, {
  copy(t) {
    return Object.assign(new this.constructor(), this, t);
  },
  displayable() {
    return this.rgb().displayable();
  },
  hex: Ra,
  // Deprecated! Use color.formatHex.
  formatHex: Ra,
  formatHex8: Dl,
  formatHsl: Il,
  formatRgb: ka,
  toString: ka
});
function Ra() {
  return this.rgb().formatHex();
}
function Dl() {
  return this.rgb().formatHex8();
}
function Il() {
  return fs(this).formatHsl();
}
function ka() {
  return this.rgb().formatRgb();
}
function we(t) {
  var n, e;
  return t = (t + "").trim().toLowerCase(), (n = Cl.exec(t)) ? (e = n[1].length, n = parseInt(n[1], 16), e === 6 ? Ca(n) : e === 3 ? new Pt(n >> 8 & 15 | n >> 4 & 240, n >> 4 & 15 | n & 240, (n & 15) << 4 | n & 15, 1) : e === 8 ? Ye(n >> 24 & 255, n >> 16 & 255, n >> 8 & 255, (n & 255) / 255) : e === 4 ? Ye(n >> 12 & 15 | n >> 8 & 240, n >> 8 & 15 | n >> 4 & 240, n >> 4 & 15 | n & 240, ((n & 15) << 4 | n & 15) / 255) : null) : (n = Tl.exec(t)) ? new Pt(n[1], n[2], n[3], 1) : (n = Al.exec(t)) ? new Pt(n[1] * 255 / 100, n[2] * 255 / 100, n[3] * 255 / 100, 1) : (n = Ol.exec(t)) ? Ye(n[1], n[2], n[3], n[4]) : (n = jl.exec(t)) ? Ye(n[1] * 255 / 100, n[2] * 255 / 100, n[3] * 255 / 100, n[4]) : (n = zl.exec(t)) ? Oa(n[1], n[2] / 100, n[3] / 100, 1) : (n = Fl.exec(t)) ? Oa(n[1], n[2] / 100, n[3] / 100, n[4]) : Pa.hasOwnProperty(t) ? Ca(Pa[t]) : t === "transparent" ? new Pt(NaN, NaN, NaN, 0) : null;
}
function Ca(t) {
  return new Pt(t >> 16 & 255, t >> 8 & 255, t & 255, 1);
}
function Ye(t, n, e, r) {
  return r <= 0 && (t = n = e = NaN), new Pt(t, n, e, r);
}
function Ll(t) {
  return t instanceof ke || (t = we(t)), t ? (t = t.rgb(), new Pt(t.r, t.g, t.b, t.opacity)) : new Pt();
}
function ji(t, n, e, r) {
  return arguments.length === 1 ? Ll(t) : new Pt(t, n, e, r ?? 1);
}
function Pt(t, n, e, r) {
  this.r = +t, this.g = +n, this.b = +e, this.opacity = +r;
}
So(Pt, ji, cs(ke, {
  brighter(t) {
    return t = t == null ? lr : Math.pow(lr, t), new Pt(this.r * t, this.g * t, this.b * t, this.opacity);
  },
  darker(t) {
    return t = t == null ? xe : Math.pow(xe, t), new Pt(this.r * t, this.g * t, this.b * t, this.opacity);
  },
  rgb() {
    return this;
  },
  clamp() {
    return new Pt(wn(this.r), wn(this.g), wn(this.b), hr(this.opacity));
  },
  displayable() {
    return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
  },
  hex: Ta,
  // Deprecated! Use color.formatHex.
  formatHex: Ta,
  formatHex8: ql,
  formatRgb: Aa,
  toString: Aa
}));
function Ta() {
  return `#${_n(this.r)}${_n(this.g)}${_n(this.b)}`;
}
function ql() {
  return `#${_n(this.r)}${_n(this.g)}${_n(this.b)}${_n((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function Aa() {
  const t = hr(this.opacity);
  return `${t === 1 ? "rgb(" : "rgba("}${wn(this.r)}, ${wn(this.g)}, ${wn(this.b)}${t === 1 ? ")" : `, ${t})`}`;
}
function hr(t) {
  return isNaN(t) ? 1 : Math.max(0, Math.min(1, t));
}
function wn(t) {
  return Math.max(0, Math.min(255, Math.round(t) || 0));
}
function _n(t) {
  return t = wn(t), (t < 16 ? "0" : "") + t.toString(16);
}
function Oa(t, n, e, r) {
  return r <= 0 ? t = n = e = NaN : e <= 0 || e >= 1 ? t = n = NaN : n <= 0 && (t = NaN), new Lt(t, n, e, r);
}
function fs(t) {
  if (t instanceof Lt)
    return new Lt(t.h, t.s, t.l, t.opacity);
  if (t instanceof ke || (t = we(t)), !t)
    return new Lt();
  if (t instanceof Lt)
    return t;
  t = t.rgb();
  var n = t.r / 255, e = t.g / 255, r = t.b / 255, i = Math.min(n, e, r), o = Math.max(n, e, r), a = NaN, u = o - i, c = (o + i) / 2;
  return u ? (n === o ? a = (e - r) / u + (e < r) * 6 : e === o ? a = (r - n) / u + 2 : a = (n - e) / u + 4, u /= c < 0.5 ? o + i : 2 - o - i, a *= 60) : u = c > 0 && c < 1 ? 0 : a, new Lt(a, u, c, t.opacity);
}
function Yl(t, n, e, r) {
  return arguments.length === 1 ? fs(t) : new Lt(t, n, e, r ?? 1);
}
function Lt(t, n, e, r) {
  this.h = +t, this.s = +n, this.l = +e, this.opacity = +r;
}
So(Lt, Yl, cs(ke, {
  brighter(t) {
    return t = t == null ? lr : Math.pow(lr, t), new Lt(this.h, this.s, this.l * t, this.opacity);
  },
  darker(t) {
    return t = t == null ? xe : Math.pow(xe, t), new Lt(this.h, this.s, this.l * t, this.opacity);
  },
  rgb() {
    var t = this.h % 360 + (this.h < 0) * 360, n = isNaN(t) || isNaN(this.s) ? 0 : this.s, e = this.l, r = e + (e < 0.5 ? e : 1 - e) * n, i = 2 * e - r;
    return new Pt(
      hi(t >= 240 ? t - 240 : t + 120, i, r),
      hi(t, i, r),
      hi(t < 120 ? t + 240 : t - 120, i, r),
      this.opacity
    );
  },
  clamp() {
    return new Lt(ja(this.h), Ge(this.s), Ge(this.l), hr(this.opacity));
  },
  displayable() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
  },
  formatHsl() {
    const t = hr(this.opacity);
    return `${t === 1 ? "hsl(" : "hsla("}${ja(this.h)}, ${Ge(this.s) * 100}%, ${Ge(this.l) * 100}%${t === 1 ? ")" : `, ${t})`}`;
  }
}));
function ja(t) {
  return t = (t || 0) % 360, t < 0 ? t + 360 : t;
}
function Ge(t) {
  return Math.max(0, Math.min(1, t || 0));
}
function hi(t, n, e) {
  return (t < 60 ? n + (e - n) * t / 60 : t < 180 ? e : t < 240 ? n + (e - n) * (240 - t) / 60 : n) * 255;
}
const Mo = (t) => () => t;
function Gl(t, n) {
  return function(e) {
    return t + e * n;
  };
}
function Wl(t, n, e) {
  return t = Math.pow(t, e), n = Math.pow(n, e) - t, e = 1 / e, function(r) {
    return Math.pow(t + r * n, e);
  };
}
function Bl(t) {
  return (t = +t) == 1 ? ls : function(n, e) {
    return e - n ? Wl(n, e, t) : Mo(isNaN(n) ? e : n);
  };
}
function ls(t, n) {
  var e = n - t;
  return e ? Gl(t, e) : Mo(isNaN(t) ? n : t);
}
const za = function t(n) {
  var e = Bl(n);
  function r(i, o) {
    var a = e((i = ji(i)).r, (o = ji(o)).r), u = e(i.g, o.g), c = e(i.b, o.b), f = ls(i.opacity, o.opacity);
    return function(s) {
      return i.r = a(s), i.g = u(s), i.b = c(s), i.opacity = f(s), i + "";
    };
  }
  return r.gamma = t, r;
}(1);
function Hl(t, n) {
  n || (n = []);
  var e = t ? Math.min(n.length, t.length) : 0, r = n.slice(), i;
  return function(o) {
    for (i = 0; i < e; ++i)
      r[i] = t[i] * (1 - o) + n[i] * o;
    return r;
  };
}
function Xl(t) {
  return ArrayBuffer.isView(t) && !(t instanceof DataView);
}
function Ul(t, n) {
  var e = n ? n.length : 0, r = t ? Math.min(e, t.length) : 0, i = new Array(r), o = new Array(e), a;
  for (a = 0; a < r; ++a)
    i[a] = No(t[a], n[a]);
  for (; a < e; ++a)
    o[a] = n[a];
  return function(u) {
    for (a = 0; a < r; ++a)
      o[a] = i[a](u);
    return o;
  };
}
function Vl(t, n) {
  var e = /* @__PURE__ */ new Date();
  return t = +t, n = +n, function(r) {
    return e.setTime(t * (1 - r) + n * r), e;
  };
}
function pr(t, n) {
  return t = +t, n = +n, function(e) {
    return t * (1 - e) + n * e;
  };
}
function Zl(t, n) {
  var e = {}, r = {}, i;
  (t === null || typeof t != "object") && (t = {}), (n === null || typeof n != "object") && (n = {});
  for (i in n)
    i in t ? e[i] = No(t[i], n[i]) : r[i] = n[i];
  return function(o) {
    for (i in e)
      r[i] = e[i](o);
    return r;
  };
}
var zi = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, pi = new RegExp(zi.source, "g");
function Kl(t) {
  return function() {
    return t;
  };
}
function Jl(t) {
  return function(n) {
    return t(n) + "";
  };
}
function Ql(t, n) {
  var e = zi.lastIndex = pi.lastIndex = 0, r, i, o, a = -1, u = [], c = [];
  for (t = t + "", n = n + ""; (r = zi.exec(t)) && (i = pi.exec(n)); )
    (o = i.index) > e && (o = n.slice(e, o), u[a] ? u[a] += o : u[++a] = o), (r = r[0]) === (i = i[0]) ? u[a] ? u[a] += i : u[++a] = i : (u[++a] = null, c.push({ i: a, x: pr(r, i) })), e = pi.lastIndex;
  return e < n.length && (o = n.slice(e), u[a] ? u[a] += o : u[++a] = o), u.length < 2 ? c[0] ? Jl(c[0].x) : Kl(n) : (n = c.length, function(f) {
    for (var s = 0, l; s < n; ++s)
      u[(l = c[s]).i] = l.x(f);
    return u.join("");
  });
}
function No(t, n) {
  var e = typeof n, r;
  return n == null || e === "boolean" ? Mo(n) : (e === "number" ? pr : e === "string" ? (r = we(n)) ? (n = r, za) : Ql : n instanceof we ? za : n instanceof Date ? Vl : Xl(n) ? Hl : Array.isArray(n) ? Ul : typeof n.valueOf != "function" && typeof n.toString != "function" || isNaN(n) ? Zl : pr)(t, n);
}
function th(t, n) {
  return t = +t, n = +n, function(e) {
    return Math.round(t * (1 - e) + n * e);
  };
}
function nh(t) {
  return function() {
    return t;
  };
}
function eh(t) {
  return +t;
}
var Fa = [0, 1];
function An(t) {
  return t;
}
function Fi(t, n) {
  return (n -= t = +t) ? function(e) {
    return (e - t) / n;
  } : nh(isNaN(n) ? NaN : 0.5);
}
function rh(t, n) {
  var e;
  return t > n && (e = t, t = n, n = e), function(r) {
    return Math.max(t, Math.min(n, r));
  };
}
function ih(t, n, e) {
  var r = t[0], i = t[1], o = n[0], a = n[1];
  return i < r ? (r = Fi(i, r), o = e(a, o)) : (r = Fi(r, i), o = e(o, a)), function(u) {
    return o(r(u));
  };
}
function oh(t, n, e) {
  var r = Math.min(t.length, n.length) - 1, i = new Array(r), o = new Array(r), a = -1;
  for (t[r] < t[0] && (t = t.slice().reverse(), n = n.slice().reverse()); ++a < r; )
    i[a] = Fi(t[a], t[a + 1]), o[a] = e(n[a], n[a + 1]);
  return function(u) {
    var c = $l(t, u, 1, r) - 1;
    return o[c](i[c](u));
  };
}
function ah(t, n) {
  return n.domain(t.domain()).range(t.range()).interpolate(t.interpolate()).clamp(t.clamp()).unknown(t.unknown());
}
function uh() {
  var t = Fa, n = Fa, e = No, r, i, o, a = An, u, c, f;
  function s() {
    var h = Math.min(t.length, n.length);
    return a !== An && (a = rh(t[0], t[h - 1])), u = h > 2 ? oh : ih, c = f = null, l;
  }
  function l(h) {
    return h == null || isNaN(h = +h) ? o : (c || (c = u(t.map(r), n, e)))(r(a(h)));
  }
  return l.invert = function(h) {
    return a(i((f || (f = u(n, t.map(r), pr)))(h)));
  }, l.domain = function(h) {
    return arguments.length ? (t = Array.from(h, eh), s()) : t.slice();
  }, l.range = function(h) {
    return arguments.length ? (n = Array.from(h), s()) : n.slice();
  }, l.rangeRound = function(h) {
    return n = Array.from(h), e = th, s();
  }, l.clamp = function(h) {
    return arguments.length ? (a = h ? !0 : An, s()) : a !== An;
  }, l.interpolate = function(h) {
    return arguments.length ? (e = h, s()) : e;
  }, l.unknown = function(h) {
    return arguments.length ? (o = h, l) : o;
  }, function(h, p) {
    return r = h, i = p, s();
  };
}
function sh() {
  return uh()(An, An);
}
function ch(t) {
  return Math.abs(t = Math.round(t)) >= 1e21 ? t.toLocaleString("en").replace(/,/g, "") : t.toString(10);
}
function dr(t, n) {
  if ((e = (t = n ? t.toExponential(n - 1) : t.toExponential()).indexOf("e")) < 0)
    return null;
  var e, r = t.slice(0, e);
  return [
    r.length > 1 ? r[0] + r.slice(2) : r,
    +t.slice(e + 1)
  ];
}
function Yn(t) {
  return t = dr(Math.abs(t)), t ? t[1] : NaN;
}
function fh(t, n) {
  return function(e, r) {
    for (var i = e.length, o = [], a = 0, u = t[0], c = 0; i > 0 && u > 0 && (c + u + 1 > r && (u = Math.max(1, r - c)), o.push(e.substring(i -= u, i + u)), !((c += u + 1) > r)); )
      u = t[a = (a + 1) % t.length];
    return o.reverse().join(n);
  };
}
function lh(t) {
  return function(n) {
    return n.replace(/[0-9]/g, function(e) {
      return t[+e];
    });
  };
}
var hh = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function gr(t) {
  if (!(n = hh.exec(t)))
    throw new Error("invalid format: " + t);
  var n;
  return new $o({
    fill: n[1],
    align: n[2],
    sign: n[3],
    symbol: n[4],
    zero: n[5],
    width: n[6],
    comma: n[7],
    precision: n[8] && n[8].slice(1),
    trim: n[9],
    type: n[10]
  });
}
gr.prototype = $o.prototype;
function $o(t) {
  this.fill = t.fill === void 0 ? " " : t.fill + "", this.align = t.align === void 0 ? ">" : t.align + "", this.sign = t.sign === void 0 ? "-" : t.sign + "", this.symbol = t.symbol === void 0 ? "" : t.symbol + "", this.zero = !!t.zero, this.width = t.width === void 0 ? void 0 : +t.width, this.comma = !!t.comma, this.precision = t.precision === void 0 ? void 0 : +t.precision, this.trim = !!t.trim, this.type = t.type === void 0 ? "" : t.type + "";
}
$o.prototype.toString = function() {
  return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === void 0 ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === void 0 ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};
function ph(t) {
  t:
    for (var n = t.length, e = 1, r = -1, i; e < n; ++e)
      switch (t[e]) {
        case ".":
          r = i = e;
          break;
        case "0":
          r === 0 && (r = e), i = e;
          break;
        default:
          if (!+t[e])
            break t;
          r > 0 && (r = 0);
          break;
      }
  return r > 0 ? t.slice(0, r) + t.slice(i + 1) : t;
}
var hs;
function dh(t, n) {
  var e = dr(t, n);
  if (!e)
    return t + "";
  var r = e[0], i = e[1], o = i - (hs = Math.max(-8, Math.min(8, Math.floor(i / 3))) * 3) + 1, a = r.length;
  return o === a ? r : o > a ? r + new Array(o - a + 1).join("0") : o > 0 ? r.slice(0, o) + "." + r.slice(o) : "0." + new Array(1 - o).join("0") + dr(t, Math.max(0, n + o - 1))[0];
}
function Da(t, n) {
  var e = dr(t, n);
  if (!e)
    return t + "";
  var r = e[0], i = e[1];
  return i < 0 ? "0." + new Array(-i).join("0") + r : r.length > i + 1 ? r.slice(0, i + 1) + "." + r.slice(i + 1) : r + new Array(i - r.length + 2).join("0");
}
const Ia = {
  "%": (t, n) => (t * 100).toFixed(n),
  b: (t) => Math.round(t).toString(2),
  c: (t) => t + "",
  d: ch,
  e: (t, n) => t.toExponential(n),
  f: (t, n) => t.toFixed(n),
  g: (t, n) => t.toPrecision(n),
  o: (t) => Math.round(t).toString(8),
  p: (t, n) => Da(t * 100, n),
  r: Da,
  s: dh,
  X: (t) => Math.round(t).toString(16).toUpperCase(),
  x: (t) => Math.round(t).toString(16)
};
function La(t) {
  return t;
}
var qa = Array.prototype.map, Ya = ["y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"];
function gh(t) {
  var n = t.grouping === void 0 || t.thousands === void 0 ? La : fh(qa.call(t.grouping, Number), t.thousands + ""), e = t.currency === void 0 ? "" : t.currency[0] + "", r = t.currency === void 0 ? "" : t.currency[1] + "", i = t.decimal === void 0 ? "." : t.decimal + "", o = t.numerals === void 0 ? La : lh(qa.call(t.numerals, String)), a = t.percent === void 0 ? "%" : t.percent + "", u = t.minus === void 0 ? "−" : t.minus + "", c = t.nan === void 0 ? "NaN" : t.nan + "";
  function f(l) {
    l = gr(l);
    var h = l.fill, p = l.align, g = l.sign, w = l.symbol, b = l.zero, _ = l.width, S = l.comma, y = l.precision, E = l.trim, M = l.type;
    M === "n" ? (S = !0, M = "g") : Ia[M] || (y === void 0 && (y = 12), E = !0, M = "g"), (b || h === "0" && p === "=") && (b = !0, h = "0", p = "=");
    var R = w === "$" ? e : w === "#" && /[boxX]/.test(M) ? "0" + M.toLowerCase() : "", j = w === "$" ? r : /[%p]/.test(M) ? a : "", I = Ia[M], q = /[defgprs%]/.test(M);
    y = y === void 0 ? 6 : /[gprs]/.test(M) ? Math.max(1, Math.min(21, y)) : Math.max(0, Math.min(20, y));
    function W(P) {
      var B = R, L = j, v, m, x;
      if (M === "c")
        L = I(P) + L, P = "";
      else {
        P = +P;
        var C = P < 0 || 1 / P < 0;
        if (P = isNaN(P) ? c : I(Math.abs(P), y), E && (P = ph(P)), C && +P == 0 && g !== "+" && (C = !1), B = (C ? g === "(" ? g : u : g === "-" || g === "(" ? "" : g) + B, L = (M === "s" ? Ya[8 + hs / 3] : "") + L + (C && g === "(" ? ")" : ""), q) {
          for (v = -1, m = P.length; ++v < m; )
            if (x = P.charCodeAt(v), 48 > x || x > 57) {
              L = (x === 46 ? i + P.slice(v + 1) : P.slice(v)) + L, P = P.slice(0, v);
              break;
            }
        }
      }
      S && !b && (P = n(P, 1 / 0));
      var A = B.length + P.length + L.length, k = A < _ ? new Array(_ - A + 1).join(h) : "";
      switch (S && b && (P = n(k + P, k.length ? _ - L.length : 1 / 0), k = ""), p) {
        case "<":
          P = B + P + L + k;
          break;
        case "=":
          P = B + k + P + L;
          break;
        case "^":
          P = k.slice(0, A = k.length >> 1) + B + P + L + k.slice(A);
          break;
        default:
          P = k + B + P + L;
          break;
      }
      return o(P);
    }
    return W.toString = function() {
      return l + "";
    }, W;
  }
  function s(l, h) {
    var p = f((l = gr(l), l.type = "f", l)), g = Math.max(-8, Math.min(8, Math.floor(Yn(h) / 3))) * 3, w = Math.pow(10, -g), b = Ya[8 + g / 3];
    return function(_) {
      return p(w * _) + b;
    };
  }
  return {
    format: f,
    formatPrefix: s
  };
}
var We, ps, ds;
vh({
  thousands: ",",
  grouping: [3],
  currency: ["$", ""]
});
function vh(t) {
  return We = gh(t), ps = We.format, ds = We.formatPrefix, We;
}
function mh(t) {
  return Math.max(0, -Yn(Math.abs(t)));
}
function yh(t, n) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(Yn(n) / 3))) * 3 - Yn(Math.abs(t)));
}
function xh(t, n) {
  return t = Math.abs(t), n = Math.abs(n) - t, Math.max(0, Yn(n) - Yn(t)) + 1;
}
function _h(t, n, e, r) {
  var i = Rl(t, n, e), o;
  switch (r = gr(r ?? ",f"), r.type) {
    case "s": {
      var a = Math.max(Math.abs(t), Math.abs(n));
      return r.precision == null && !isNaN(o = yh(i, a)) && (r.precision = o), ds(r, a);
    }
    case "":
    case "e":
    case "g":
    case "p":
    case "r": {
      r.precision == null && !isNaN(o = xh(i, Math.max(Math.abs(t), Math.abs(n)))) && (r.precision = o - (r.type === "e"));
      break;
    }
    case "f":
    case "%": {
      r.precision == null && !isNaN(o = mh(i)) && (r.precision = o - (r.type === "%") * 2);
      break;
    }
  }
  return ps(r);
}
function wh(t) {
  var n = t.domain;
  return t.ticks = function(e) {
    var r = n();
    return Pl(r[0], r[r.length - 1], e ?? 10);
  }, t.tickFormat = function(e, r) {
    var i = n();
    return _h(i[0], i[i.length - 1], e ?? 10, r);
  }, t.nice = function(e) {
    e == null && (e = 10);
    var r = n(), i = 0, o = r.length - 1, a = r[i], u = r[o], c, f, s = 10;
    for (u < a && (f = a, a = u, u = f, f = i, i = o, o = f); s-- > 0; ) {
      if (f = ss(a, u, e), f === c)
        return r[i] = a, r[o] = u, n(r);
      if (f > 0)
        a = Math.floor(a / f) * f, u = Math.ceil(u / f) * f;
      else if (f < 0)
        a = Math.ceil(a * f) / f, u = Math.floor(u * f) / f;
      else
        break;
      c = f;
    }
    return t;
  }, t;
}
function gs() {
  var t = sh();
  return t.copy = function() {
    return ah(t, gs());
  }, kl.apply(t, arguments), wh(t);
}
let di = null;
function bh() {
  return di || (di = document.body), di;
}
const Ga = {
  background: "#fff",
  borderRadius: 5,
  boxShadow: "0 0 14px rgba(0, 0, 0, 0.3)",
  color: "#2c2c2c",
  fontSize: 0,
  lineHeight: 0,
  overflow: "visible",
  padding: 0,
  pointerEvents: "none",
  position: "absolute",
  width: "auto",
  zIndex: 9999
};
function Eh({ x: t, y: n, width: e, height: r }) {
  return r <= 0 || e <= 0 ? {
    ...Ga,
    left: 0,
    opacity: 0,
    top: 0,
    visibility: "hidden"
  } : {
    ...Ga,
    left: t - e / 2,
    top: n - r - 10
  };
}
const vs = ({ x: t, y: n, children: e }) => {
  const [r, i] = on(-1), [o, a] = on(-1), u = Tn((c) => {
    if (c) {
      const { height: f, width: s } = c.getBoundingClientRect();
      if (!f || !s)
        return;
      i(s), a(f);
    }
  }, [i, a]);
  return af.createPortal(
    /* @__PURE__ */ tt.jsxs(
      "div",
      {
        className: "react-chart-tooltip",
        ref: (c) => u(c),
        style: Eh({ x: t, y: n, width: r, height: o }),
        children: [
          /* @__PURE__ */ tt.jsx(
            "div",
            {
              className: "react-chart-tooltip-content",
              style: {
                fontSize: 14,
                lineHeight: "16px",
                overflow: "hidden",
                padding: "8px 10px"
              },
              children: e
            }
          ),
          /* @__PURE__ */ tt.jsx(
            "div",
            {
              className: "react-chart-tooltip-arrow",
              style: {
                display: "block",
                height: "100%",
                left: 0,
                position: "absolute",
                textAlign: "center",
                top: 0,
                width: "100%",
                zIndex: -1
              },
              children: /* @__PURE__ */ tt.jsx(
                "span",
                {
                  style: {
                    borderColor: "#fff transparent transparent",
                    borderStyle: "solid",
                    borderWidth: "9px 9px 0",
                    bottom: -7,
                    display: "block",
                    height: 0,
                    left: 0,
                    margin: "0 auto",
                    position: "absolute",
                    right: 0,
                    width: 0
                  }
                }
              )
            }
          )
        ]
      }
    ),
    bh()
  );
};
vs.propTypes = {
  x: $.number.isRequired,
  y: $.number.isRequired,
  children: $.oneOfType([$.arrayOf($.node), $.node]).isRequired
};
class yt {
  constructor() {
    this._partials = new Float64Array(32), this._n = 0;
  }
  add(n) {
    const e = this._partials;
    let r = 0;
    for (let i = 0; i < this._n && i < 32; i++) {
      const o = e[i], a = n + o, u = Math.abs(n) < Math.abs(o) ? n - (a - o) : o - (a - n);
      u && (e[r++] = u), n = a;
    }
    return e[r] = n, this._n = r + 1, this;
  }
  valueOf() {
    const n = this._partials;
    let e = this._n, r, i, o, a = 0;
    if (e > 0) {
      for (a = n[--e]; e > 0 && (r = a, i = n[--e], a = r + i, o = i - (a - r), !o); )
        ;
      e > 0 && (o < 0 && n[e - 1] < 0 || o > 0 && n[e - 1] > 0) && (i = o * 2, r = a + i, i == r - a && (a = r));
    }
    return a;
  }
}
function* Sh(t) {
  for (const n of t)
    yield* n;
}
function ms(t) {
  return Array.from(Sh(t));
}
function On(t, n, e) {
  t = +t, n = +n, e = (i = arguments.length) < 2 ? (n = t, t = 0, 1) : i < 3 ? 1 : +e;
  for (var r = -1, i = Math.max(0, Math.ceil((n - t) / e)) | 0, o = new Array(i); ++r < i; )
    o[r] = t + r * e;
  return o;
}
var F = 1e-6, be = 1e-12, X = Math.PI, ft = X / 2, vr = X / 4, Et = X * 2, rt = 180 / X, D = X / 180, Z = Math.abs, Vn = Math.atan, St = Math.atan2, z = Math.cos, Be = Math.ceil, ys = Math.exp, Di = Math.hypot, mr = Math.log, gi = Math.pow, O = Math.sin, Dt = Math.sign || function(t) {
  return t > 0 ? 1 : t < 0 ? -1 : 0;
}, pt = Math.sqrt, Po = Math.tan;
function xs(t) {
  return t > 1 ? 0 : t < -1 ? X : Math.acos(t);
}
function Mt(t) {
  return t > 1 ? ft : t < -1 ? -ft : Math.asin(t);
}
function Wa(t) {
  return (t = O(t / 2)) * t;
}
function ut() {
}
function yr(t, n) {
  t && Ha.hasOwnProperty(t.type) && Ha[t.type](t, n);
}
var Ba = {
  Feature: function(t, n) {
    yr(t.geometry, n);
  },
  FeatureCollection: function(t, n) {
    for (var e = t.features, r = -1, i = e.length; ++r < i; )
      yr(e[r].geometry, n);
  }
}, Ha = {
  Sphere: function(t, n) {
    n.sphere();
  },
  Point: function(t, n) {
    t = t.coordinates, n.point(t[0], t[1], t[2]);
  },
  MultiPoint: function(t, n) {
    for (var e = t.coordinates, r = -1, i = e.length; ++r < i; )
      t = e[r], n.point(t[0], t[1], t[2]);
  },
  LineString: function(t, n) {
    Ii(t.coordinates, n, 0);
  },
  MultiLineString: function(t, n) {
    for (var e = t.coordinates, r = -1, i = e.length; ++r < i; )
      Ii(e[r], n, 0);
  },
  Polygon: function(t, n) {
    Xa(t.coordinates, n);
  },
  MultiPolygon: function(t, n) {
    for (var e = t.coordinates, r = -1, i = e.length; ++r < i; )
      Xa(e[r], n);
  },
  GeometryCollection: function(t, n) {
    for (var e = t.geometries, r = -1, i = e.length; ++r < i; )
      yr(e[r], n);
  }
};
function Ii(t, n, e) {
  var r = -1, i = t.length - e, o;
  for (n.lineStart(); ++r < i; )
    o = t[r], n.point(o[0], o[1], o[2]);
  n.lineEnd();
}
function Xa(t, n) {
  var e = -1, r = t.length;
  for (n.polygonStart(); ++e < r; )
    Ii(t[e], n, 1);
  n.polygonEnd();
}
function qt(t, n) {
  t && Ba.hasOwnProperty(t.type) ? Ba[t.type](t, n) : yr(t, n);
}
var xr = new yt(), _r = new yt(), _s, ws, Li, qi, Yi, Zt = {
  point: ut,
  lineStart: ut,
  lineEnd: ut,
  polygonStart: function() {
    xr = new yt(), Zt.lineStart = Mh, Zt.lineEnd = Nh;
  },
  polygonEnd: function() {
    var t = +xr;
    _r.add(t < 0 ? Et + t : t), this.lineStart = this.lineEnd = this.point = ut;
  },
  sphere: function() {
    _r.add(Et);
  }
};
function Mh() {
  Zt.point = $h;
}
function Nh() {
  bs(_s, ws);
}
function $h(t, n) {
  Zt.point = bs, _s = t, ws = n, t *= D, n *= D, Li = t, qi = z(n = n / 2 + vr), Yi = O(n);
}
function bs(t, n) {
  t *= D, n *= D, n = n / 2 + vr;
  var e = t - Li, r = e >= 0 ? 1 : -1, i = r * e, o = z(n), a = O(n), u = Yi * a, c = qi * o + u * z(i), f = u * r * O(i);
  xr.add(St(f, c)), Li = t, qi = o, Yi = a;
}
function Ph(t) {
  return _r = new yt(), qt(t, Zt), _r * 2;
}
function wr(t) {
  return [St(t[1], t[0]), Mt(t[2])];
}
function Mn(t) {
  var n = t[0], e = t[1], r = z(e);
  return [r * z(n), r * O(n), O(e)];
}
function He(t, n) {
  return t[0] * n[0] + t[1] * n[1] + t[2] * n[2];
}
function Gn(t, n) {
  return [t[1] * n[2] - t[2] * n[1], t[2] * n[0] - t[0] * n[2], t[0] * n[1] - t[1] * n[0]];
}
function vi(t, n) {
  t[0] += n[0], t[1] += n[1], t[2] += n[2];
}
function Xe(t, n) {
  return [t[0] * n, t[1] * n, t[2] * n];
}
function br(t) {
  var n = pt(t[0] * t[0] + t[1] * t[1] + t[2] * t[2]);
  t[0] /= n, t[1] /= n, t[2] /= n;
}
var at, Nt, st, At, yn, Es, Ss, Dn, fe, fn, an, nn = {
  point: Gi,
  lineStart: Ua,
  lineEnd: Va,
  polygonStart: function() {
    nn.point = Ns, nn.lineStart = Rh, nn.lineEnd = kh, fe = new yt(), Zt.polygonStart();
  },
  polygonEnd: function() {
    Zt.polygonEnd(), nn.point = Gi, nn.lineStart = Ua, nn.lineEnd = Va, xr < 0 ? (at = -(st = 180), Nt = -(At = 90)) : fe > F ? At = 90 : fe < -F && (Nt = -90), an[0] = at, an[1] = st;
  },
  sphere: function() {
    at = -(st = 180), Nt = -(At = 90);
  }
};
function Gi(t, n) {
  fn.push(an = [at = t, st = t]), n < Nt && (Nt = n), n > At && (At = n);
}
function Ms(t, n) {
  var e = Mn([t * D, n * D]);
  if (Dn) {
    var r = Gn(Dn, e), i = [r[1], -r[0], 0], o = Gn(i, r);
    br(o), o = wr(o);
    var a = t - yn, u = a > 0 ? 1 : -1, c = o[0] * rt * u, f, s = Z(a) > 180;
    s ^ (u * yn < c && c < u * t) ? (f = o[1] * rt, f > At && (At = f)) : (c = (c + 360) % 360 - 180, s ^ (u * yn < c && c < u * t) ? (f = -o[1] * rt, f < Nt && (Nt = f)) : (n < Nt && (Nt = n), n > At && (At = n))), s ? t < yn ? Tt(at, t) > Tt(at, st) && (st = t) : Tt(t, st) > Tt(at, st) && (at = t) : st >= at ? (t < at && (at = t), t > st && (st = t)) : t > yn ? Tt(at, t) > Tt(at, st) && (st = t) : Tt(t, st) > Tt(at, st) && (at = t);
  } else
    fn.push(an = [at = t, st = t]);
  n < Nt && (Nt = n), n > At && (At = n), Dn = e, yn = t;
}
function Ua() {
  nn.point = Ms;
}
function Va() {
  an[0] = at, an[1] = st, nn.point = Gi, Dn = null;
}
function Ns(t, n) {
  if (Dn) {
    var e = t - yn;
    fe.add(Z(e) > 180 ? e + (e > 0 ? 360 : -360) : e);
  } else
    Es = t, Ss = n;
  Zt.point(t, n), Ms(t, n);
}
function Rh() {
  Zt.lineStart();
}
function kh() {
  Ns(Es, Ss), Zt.lineEnd(), Z(fe) > F && (at = -(st = 180)), an[0] = at, an[1] = st, Dn = null;
}
function Tt(t, n) {
  return (n -= t) < 0 ? n + 360 : n;
}
function Ch(t, n) {
  return t[0] - n[0];
}
function Za(t, n) {
  return t[0] <= t[1] ? t[0] <= n && n <= t[1] : n < t[0] || t[1] < n;
}
function Th(t) {
  var n, e, r, i, o, a, u;
  if (At = st = -(at = Nt = 1 / 0), fn = [], qt(t, nn), e = fn.length) {
    for (fn.sort(Ch), n = 1, r = fn[0], o = [r]; n < e; ++n)
      i = fn[n], Za(r, i[0]) || Za(r, i[1]) ? (Tt(r[0], i[1]) > Tt(r[0], r[1]) && (r[1] = i[1]), Tt(i[0], r[1]) > Tt(r[0], r[1]) && (r[0] = i[0])) : o.push(r = i);
    for (a = -1 / 0, e = o.length - 1, n = 0, r = o[e]; n <= e; r = i, ++n)
      i = o[n], (u = Tt(r[1], i[0])) > a && (a = u, at = i[0], st = r[1]);
  }
  return fn = an = null, at === 1 / 0 || Nt === 1 / 0 ? [[NaN, NaN], [NaN, NaN]] : [[at, Nt], [st, At]];
}
var ee, Er, Sr, Mr, Nr, $r, Pr, Rr, Wi, Bi, Hi, $s, Ps, _t, wt, bt, Gt = {
  sphere: ut,
  point: Ro,
  lineStart: Ka,
  lineEnd: Ja,
  polygonStart: function() {
    Gt.lineStart = jh, Gt.lineEnd = zh;
  },
  polygonEnd: function() {
    Gt.lineStart = Ka, Gt.lineEnd = Ja;
  }
};
function Ro(t, n) {
  t *= D, n *= D;
  var e = z(n);
  Ce(e * z(t), e * O(t), O(n));
}
function Ce(t, n, e) {
  ++ee, Sr += (t - Sr) / ee, Mr += (n - Mr) / ee, Nr += (e - Nr) / ee;
}
function Ka() {
  Gt.point = Ah;
}
function Ah(t, n) {
  t *= D, n *= D;
  var e = z(n);
  _t = e * z(t), wt = e * O(t), bt = O(n), Gt.point = Oh, Ce(_t, wt, bt);
}
function Oh(t, n) {
  t *= D, n *= D;
  var e = z(n), r = e * z(t), i = e * O(t), o = O(n), a = St(pt((a = wt * o - bt * i) * a + (a = bt * r - _t * o) * a + (a = _t * i - wt * r) * a), _t * r + wt * i + bt * o);
  Er += a, $r += a * (_t + (_t = r)), Pr += a * (wt + (wt = i)), Rr += a * (bt + (bt = o)), Ce(_t, wt, bt);
}
function Ja() {
  Gt.point = Ro;
}
function jh() {
  Gt.point = Fh;
}
function zh() {
  Rs($s, Ps), Gt.point = Ro;
}
function Fh(t, n) {
  $s = t, Ps = n, t *= D, n *= D, Gt.point = Rs;
  var e = z(n);
  _t = e * z(t), wt = e * O(t), bt = O(n), Ce(_t, wt, bt);
}
function Rs(t, n) {
  t *= D, n *= D;
  var e = z(n), r = e * z(t), i = e * O(t), o = O(n), a = wt * o - bt * i, u = bt * r - _t * o, c = _t * i - wt * r, f = Di(a, u, c), s = Mt(f), l = f && -s / f;
  Wi.add(l * a), Bi.add(l * u), Hi.add(l * c), Er += s, $r += s * (_t + (_t = r)), Pr += s * (wt + (wt = i)), Rr += s * (bt + (bt = o)), Ce(_t, wt, bt);
}
function Dh(t) {
  ee = Er = Sr = Mr = Nr = $r = Pr = Rr = 0, Wi = new yt(), Bi = new yt(), Hi = new yt(), qt(t, Gt);
  var n = +Wi, e = +Bi, r = +Hi, i = Di(n, e, r);
  return i < be && (n = $r, e = Pr, r = Rr, Er < F && (n = Sr, e = Mr, r = Nr), i = Di(n, e, r), i < be) ? [NaN, NaN] : [St(e, n) * rt, Mt(r / i) * rt];
}
function Cn(t) {
  return function() {
    return t;
  };
}
function Xi(t, n) {
  function e(r, i) {
    return r = t(r, i), n(r[0], r[1]);
  }
  return t.invert && n.invert && (e.invert = function(r, i) {
    return r = n.invert(r, i), r && t.invert(r[0], r[1]);
  }), e;
}
function Ui(t, n) {
  return [Z(t) > X ? t + Math.round(-t / Et) * Et : t, n];
}
Ui.invert = Ui;
function ko(t, n, e) {
  return (t %= Et) ? n || e ? Xi(tu(t), nu(n, e)) : tu(t) : n || e ? nu(n, e) : Ui;
}
function Qa(t) {
  return function(n, e) {
    return n += t, [n > X ? n - Et : n < -X ? n + Et : n, e];
  };
}
function tu(t) {
  var n = Qa(t);
  return n.invert = Qa(-t), n;
}
function nu(t, n) {
  var e = z(t), r = O(t), i = z(n), o = O(n);
  function a(u, c) {
    var f = z(c), s = z(u) * f, l = O(u) * f, h = O(c), p = h * e + s * r;
    return [
      St(l * i - p * o, s * e - h * r),
      Mt(p * i + l * o)
    ];
  }
  return a.invert = function(u, c) {
    var f = z(c), s = z(u) * f, l = O(u) * f, h = O(c), p = h * i - l * o;
    return [
      St(l * i + h * o, s * e + p * r),
      Mt(p * e - s * r)
    ];
  }, a;
}
function ks(t) {
  t = ko(t[0] * D, t[1] * D, t.length > 2 ? t[2] * D : 0);
  function n(e) {
    return e = t(e[0] * D, e[1] * D), e[0] *= rt, e[1] *= rt, e;
  }
  return n.invert = function(e) {
    return e = t.invert(e[0] * D, e[1] * D), e[0] *= rt, e[1] *= rt, e;
  }, n;
}
function Cs(t, n, e, r, i, o) {
  if (e) {
    var a = z(n), u = O(n), c = r * e;
    i == null ? (i = n + r * Et, o = n - c / 2) : (i = eu(a, i), o = eu(a, o), (r > 0 ? i < o : i > o) && (i += r * Et));
    for (var f, s = i; r > 0 ? s > o : s < o; s -= c)
      f = wr([a, -u * z(s), -u * O(s)]), t.point(f[0], f[1]);
  }
}
function eu(t, n) {
  n = Mn(n), n[0] -= t, br(n);
  var e = xs(-n[1]);
  return ((-n[2] < 0 ? -e : e) + Et - F) % Et;
}
function Ih() {
  var t = Cn([0, 0]), n = Cn(90), e = Cn(6), r, i, o = { point: a };
  function a(c, f) {
    r.push(c = i(c, f)), c[0] *= rt, c[1] *= rt;
  }
  function u() {
    var c = t.apply(this, arguments), f = n.apply(this, arguments) * D, s = e.apply(this, arguments) * D;
    return r = [], i = ko(-c[0] * D, -c[1] * D, 0).invert, Cs(o, f, s, 1), c = { type: "Polygon", coordinates: [r] }, r = i = null, c;
  }
  return u.center = function(c) {
    return arguments.length ? (t = typeof c == "function" ? c : Cn([+c[0], +c[1]]), u) : t;
  }, u.radius = function(c) {
    return arguments.length ? (n = typeof c == "function" ? c : Cn(+c), u) : n;
  }, u.precision = function(c) {
    return arguments.length ? (e = typeof c == "function" ? c : Cn(+c), u) : e;
  }, u;
}
function Ts() {
  var t = [], n;
  return {
    point: function(e, r, i) {
      n.push([e, r, i]);
    },
    lineStart: function() {
      t.push(n = []);
    },
    lineEnd: ut,
    rejoin: function() {
      t.length > 1 && t.push(t.pop().concat(t.shift()));
    },
    result: function() {
      var e = t;
      return t = [], n = null, e;
    }
  };
}
function nr(t, n) {
  return Z(t[0] - n[0]) < F && Z(t[1] - n[1]) < F;
}
function Ue(t, n, e, r) {
  this.x = t, this.z = n, this.o = e, this.e = r, this.v = !1, this.n = this.p = null;
}
function As(t, n, e, r, i) {
  var o = [], a = [], u, c;
  if (t.forEach(function(g) {
    if (!((w = g.length - 1) <= 0)) {
      var w, b = g[0], _ = g[w], S;
      if (nr(b, _)) {
        if (!b[2] && !_[2]) {
          for (i.lineStart(), u = 0; u < w; ++u)
            i.point((b = g[u])[0], b[1]);
          i.lineEnd();
          return;
        }
        _[0] += 2 * F;
      }
      o.push(S = new Ue(b, g, null, !0)), a.push(S.o = new Ue(b, null, S, !1)), o.push(S = new Ue(_, g, null, !1)), a.push(S.o = new Ue(_, null, S, !0));
    }
  }), !!o.length) {
    for (a.sort(n), ru(o), ru(a), u = 0, c = a.length; u < c; ++u)
      a[u].e = e = !e;
    for (var f = o[0], s, l; ; ) {
      for (var h = f, p = !0; h.v; )
        if ((h = h.n) === f)
          return;
      s = h.z, i.lineStart();
      do {
        if (h.v = h.o.v = !0, h.e) {
          if (p)
            for (u = 0, c = s.length; u < c; ++u)
              i.point((l = s[u])[0], l[1]);
          else
            r(h.x, h.n.x, 1, i);
          h = h.n;
        } else {
          if (p)
            for (s = h.p.z, u = s.length - 1; u >= 0; --u)
              i.point((l = s[u])[0], l[1]);
          else
            r(h.x, h.p.x, -1, i);
          h = h.p;
        }
        h = h.o, s = h.z, p = !p;
      } while (!h.v);
      i.lineEnd();
    }
  }
}
function ru(t) {
  if (n = t.length) {
    for (var n, e = 0, r = t[0], i; ++e < n; )
      r.n = i = t[e], i.p = r, r = i;
    r.n = i = t[0], i.p = r;
  }
}
function mi(t) {
  return Z(t[0]) <= X ? t[0] : Dt(t[0]) * ((Z(t[0]) + X) % Et - X);
}
function Os(t, n) {
  var e = mi(n), r = n[1], i = O(r), o = [O(e), -z(e), 0], a = 0, u = 0, c = new yt();
  i === 1 ? r = ft + F : i === -1 && (r = -ft - F);
  for (var f = 0, s = t.length; f < s; ++f)
    if (h = (l = t[f]).length)
      for (var l, h, p = l[h - 1], g = mi(p), w = p[1] / 2 + vr, b = O(w), _ = z(w), S = 0; S < h; ++S, g = E, b = R, _ = j, p = y) {
        var y = l[S], E = mi(y), M = y[1] / 2 + vr, R = O(M), j = z(M), I = E - g, q = I >= 0 ? 1 : -1, W = q * I, P = W > X, B = b * R;
        if (c.add(St(B * q * O(W), _ * j + B * z(W))), a += P ? I + q * Et : I, P ^ g >= e ^ E >= e) {
          var L = Gn(Mn(p), Mn(y));
          br(L);
          var v = Gn(o, L);
          br(v);
          var m = (P ^ I >= 0 ? -1 : 1) * Mt(v[2]);
          (r > m || r === m && (L[0] || L[1])) && (u += P ^ I >= 0 ? 1 : -1);
        }
      }
  return (a < -F || a < F && c < -be) ^ u & 1;
}
function js(t, n, e, r) {
  return function(i) {
    var o = n(i), a = Ts(), u = n(a), c = !1, f, s, l, h = {
      point: p,
      lineStart: w,
      lineEnd: b,
      polygonStart: function() {
        h.point = _, h.lineStart = S, h.lineEnd = y, s = [], f = [];
      },
      polygonEnd: function() {
        h.point = p, h.lineStart = w, h.lineEnd = b, s = ms(s);
        var E = Os(f, r);
        s.length ? (c || (i.polygonStart(), c = !0), As(s, qh, E, e, i)) : E && (c || (i.polygonStart(), c = !0), i.lineStart(), e(null, null, 1, i), i.lineEnd()), c && (i.polygonEnd(), c = !1), s = f = null;
      },
      sphere: function() {
        i.polygonStart(), i.lineStart(), e(null, null, 1, i), i.lineEnd(), i.polygonEnd();
      }
    };
    function p(E, M) {
      t(E, M) && i.point(E, M);
    }
    function g(E, M) {
      o.point(E, M);
    }
    function w() {
      h.point = g, o.lineStart();
    }
    function b() {
      h.point = p, o.lineEnd();
    }
    function _(E, M) {
      l.push([E, M]), u.point(E, M);
    }
    function S() {
      u.lineStart(), l = [];
    }
    function y() {
      _(l[0][0], l[0][1]), u.lineEnd();
      var E = u.clean(), M = a.result(), R, j = M.length, I, q, W;
      if (l.pop(), f.push(l), l = null, !!j) {
        if (E & 1) {
          if (q = M[0], (I = q.length - 1) > 0) {
            for (c || (i.polygonStart(), c = !0), i.lineStart(), R = 0; R < I; ++R)
              i.point((W = q[R])[0], W[1]);
            i.lineEnd();
          }
          return;
        }
        j > 1 && E & 2 && M.push(M.pop().concat(M.shift())), s.push(M.filter(Lh));
      }
    }
    return h;
  };
}
function Lh(t) {
  return t.length > 1;
}
function qh(t, n) {
  return ((t = t.x)[0] < 0 ? t[1] - ft - F : ft - t[1]) - ((n = n.x)[0] < 0 ? n[1] - ft - F : ft - n[1]);
}
const Vi = js(
  function() {
    return !0;
  },
  Yh,
  Wh,
  [-X, -ft]
);
function Yh(t) {
  var n = NaN, e = NaN, r = NaN, i;
  return {
    lineStart: function() {
      t.lineStart(), i = 1;
    },
    point: function(o, a) {
      var u = o > 0 ? X : -X, c = Z(o - n);
      Z(c - X) < F ? (t.point(n, e = (e + a) / 2 > 0 ? ft : -ft), t.point(r, e), t.lineEnd(), t.lineStart(), t.point(u, e), t.point(o, e), i = 0) : r !== u && c >= X && (Z(n - r) < F && (n -= r * F), Z(o - u) < F && (o -= u * F), e = Gh(n, e, o, a), t.point(r, e), t.lineEnd(), t.lineStart(), t.point(u, e), i = 0), t.point(n = o, e = a), r = u;
    },
    lineEnd: function() {
      t.lineEnd(), n = e = NaN;
    },
    clean: function() {
      return 2 - i;
    }
  };
}
function Gh(t, n, e, r) {
  var i, o, a = O(t - e);
  return Z(a) > F ? Vn((O(n) * (o = z(r)) * O(e) - O(r) * (i = z(n)) * O(t)) / (i * o * a)) : (n + r) / 2;
}
function Wh(t, n, e, r) {
  var i;
  if (t == null)
    i = e * ft, r.point(-X, i), r.point(0, i), r.point(X, i), r.point(X, 0), r.point(X, -i), r.point(0, -i), r.point(-X, -i), r.point(-X, 0), r.point(-X, i);
  else if (Z(t[0] - n[0]) > F) {
    var o = t[0] < n[0] ? X : -X;
    i = e * o / 2, r.point(-o, i), r.point(0, i), r.point(o, i);
  } else
    r.point(n[0], n[1]);
}
function zs(t) {
  var n = z(t), e = 6 * D, r = n > 0, i = Z(n) > F;
  function o(s, l, h, p) {
    Cs(p, t, e, h, s, l);
  }
  function a(s, l) {
    return z(s) * z(l) > n;
  }
  function u(s) {
    var l, h, p, g, w;
    return {
      lineStart: function() {
        g = p = !1, w = 1;
      },
      point: function(b, _) {
        var S = [b, _], y, E = a(b, _), M = r ? E ? 0 : f(b, _) : E ? f(b + (b < 0 ? X : -X), _) : 0;
        if (!l && (g = p = E) && s.lineStart(), E !== p && (y = c(l, S), (!y || nr(l, y) || nr(S, y)) && (S[2] = 1)), E !== p)
          w = 0, E ? (s.lineStart(), y = c(S, l), s.point(y[0], y[1])) : (y = c(l, S), s.point(y[0], y[1], 2), s.lineEnd()), l = y;
        else if (i && l && r ^ E) {
          var R;
          !(M & h) && (R = c(S, l, !0)) && (w = 0, r ? (s.lineStart(), s.point(R[0][0], R[0][1]), s.point(R[1][0], R[1][1]), s.lineEnd()) : (s.point(R[1][0], R[1][1]), s.lineEnd(), s.lineStart(), s.point(R[0][0], R[0][1], 3)));
        }
        E && (!l || !nr(l, S)) && s.point(S[0], S[1]), l = S, p = E, h = M;
      },
      lineEnd: function() {
        p && s.lineEnd(), l = null;
      },
      // Rejoin first and last segments if there were intersections and the first
      // and last points were visible.
      clean: function() {
        return w | (g && p) << 1;
      }
    };
  }
  function c(s, l, h) {
    var p = Mn(s), g = Mn(l), w = [1, 0, 0], b = Gn(p, g), _ = He(b, b), S = b[0], y = _ - S * S;
    if (!y)
      return !h && s;
    var E = n * _ / y, M = -n * S / y, R = Gn(w, b), j = Xe(w, E), I = Xe(b, M);
    vi(j, I);
    var q = R, W = He(j, q), P = He(q, q), B = W * W - P * (He(j, j) - 1);
    if (!(B < 0)) {
      var L = pt(B), v = Xe(q, (-W - L) / P);
      if (vi(v, j), v = wr(v), !h)
        return v;
      var m = s[0], x = l[0], C = s[1], A = l[1], k;
      x < m && (k = m, m = x, x = k);
      var Y = x - m, H = Z(Y - X) < F, V = H || Y < F;
      if (!H && A < C && (k = C, C = A, A = k), V ? H ? C + A > 0 ^ v[1] < (Z(v[0] - m) < F ? C : A) : C <= v[1] && v[1] <= A : Y > X ^ (m <= v[0] && v[0] <= x)) {
        var nt = Xe(q, (-W + L) / P);
        return vi(nt, j), [v, wr(nt)];
      }
    }
  }
  function f(s, l) {
    var h = r ? t : X - t, p = 0;
    return s < -h ? p |= 1 : s > h && (p |= 2), l < -h ? p |= 4 : l > h && (p |= 8), p;
  }
  return js(a, u, o, r ? [0, -t] : [-X, t - X]);
}
function Bh(t, n, e, r, i, o) {
  var a = t[0], u = t[1], c = n[0], f = n[1], s = 0, l = 1, h = c - a, p = f - u, g;
  if (g = e - a, !(!h && g > 0)) {
    if (g /= h, h < 0) {
      if (g < s)
        return;
      g < l && (l = g);
    } else if (h > 0) {
      if (g > l)
        return;
      g > s && (s = g);
    }
    if (g = i - a, !(!h && g < 0)) {
      if (g /= h, h < 0) {
        if (g > l)
          return;
        g > s && (s = g);
      } else if (h > 0) {
        if (g < s)
          return;
        g < l && (l = g);
      }
      if (g = r - u, !(!p && g > 0)) {
        if (g /= p, p < 0) {
          if (g < s)
            return;
          g < l && (l = g);
        } else if (p > 0) {
          if (g > l)
            return;
          g > s && (s = g);
        }
        if (g = o - u, !(!p && g < 0)) {
          if (g /= p, p < 0) {
            if (g > l)
              return;
            g > s && (s = g);
          } else if (p > 0) {
            if (g < s)
              return;
            g < l && (l = g);
          }
          return s > 0 && (t[0] = a + s * h, t[1] = u + s * p), l < 1 && (n[0] = a + l * h, n[1] = u + l * p), !0;
        }
      }
    }
  }
}
var re = 1e9, Ve = -re;
function Jr(t, n, e, r) {
  function i(f, s) {
    return t <= f && f <= e && n <= s && s <= r;
  }
  function o(f, s, l, h) {
    var p = 0, g = 0;
    if (f == null || (p = a(f, l)) !== (g = a(s, l)) || c(f, s) < 0 ^ l > 0)
      do
        h.point(p === 0 || p === 3 ? t : e, p > 1 ? r : n);
      while ((p = (p + l + 4) % 4) !== g);
    else
      h.point(s[0], s[1]);
  }
  function a(f, s) {
    return Z(f[0] - t) < F ? s > 0 ? 0 : 3 : Z(f[0] - e) < F ? s > 0 ? 2 : 1 : Z(f[1] - n) < F ? s > 0 ? 1 : 0 : s > 0 ? 3 : 2;
  }
  function u(f, s) {
    return c(f.x, s.x);
  }
  function c(f, s) {
    var l = a(f, 1), h = a(s, 1);
    return l !== h ? l - h : l === 0 ? s[1] - f[1] : l === 1 ? f[0] - s[0] : l === 2 ? f[1] - s[1] : s[0] - f[0];
  }
  return function(f) {
    var s = f, l = Ts(), h, p, g, w, b, _, S, y, E, M, R, j = {
      point: I,
      lineStart: B,
      lineEnd: L,
      polygonStart: W,
      polygonEnd: P
    };
    function I(m, x) {
      i(m, x) && s.point(m, x);
    }
    function q() {
      for (var m = 0, x = 0, C = p.length; x < C; ++x)
        for (var A = p[x], k = 1, Y = A.length, H = A[0], V, nt, Q = H[0], it = H[1]; k < Y; ++k)
          V = Q, nt = it, H = A[k], Q = H[0], it = H[1], nt <= r ? it > r && (Q - V) * (r - nt) > (it - nt) * (t - V) && ++m : it <= r && (Q - V) * (r - nt) < (it - nt) * (t - V) && --m;
      return m;
    }
    function W() {
      s = l, h = [], p = [], R = !0;
    }
    function P() {
      var m = q(), x = R && m, C = (h = ms(h)).length;
      (x || C) && (f.polygonStart(), x && (f.lineStart(), o(null, null, 1, f), f.lineEnd()), C && As(h, u, m, o, f), f.polygonEnd()), s = f, h = p = g = null;
    }
    function B() {
      j.point = v, p && p.push(g = []), M = !0, E = !1, S = y = NaN;
    }
    function L() {
      h && (v(w, b), _ && E && l.rejoin(), h.push(l.result())), j.point = I, E && s.lineEnd();
    }
    function v(m, x) {
      var C = i(m, x);
      if (p && g.push([m, x]), M)
        w = m, b = x, _ = C, M = !1, C && (s.lineStart(), s.point(m, x));
      else if (C && E)
        s.point(m, x);
      else {
        var A = [S = Math.max(Ve, Math.min(re, S)), y = Math.max(Ve, Math.min(re, y))], k = [m = Math.max(Ve, Math.min(re, m)), x = Math.max(Ve, Math.min(re, x))];
        Bh(A, k, t, n, e, r) ? (E || (s.lineStart(), s.point(A[0], A[1])), s.point(k[0], k[1]), C || s.lineEnd(), R = !1) : C && (s.lineStart(), s.point(m, x), R = !1);
      }
      S = m, y = x, E = C;
    }
    return j;
  };
}
function Hh() {
  var t = 0, n = 0, e = 960, r = 500, i, o, a;
  return a = {
    stream: function(u) {
      return i && o === u ? i : i = Jr(t, n, e, r)(o = u);
    },
    extent: function(u) {
      return arguments.length ? (t = +u[0][0], n = +u[0][1], e = +u[1][0], r = +u[1][1], i = o = null, a) : [[t, n], [e, r]];
    }
  };
}
var Zi, Ki, er, rr, Wn = {
  sphere: ut,
  point: ut,
  lineStart: Xh,
  lineEnd: ut,
  polygonStart: ut,
  polygonEnd: ut
};
function Xh() {
  Wn.point = Vh, Wn.lineEnd = Uh;
}
function Uh() {
  Wn.point = Wn.lineEnd = ut;
}
function Vh(t, n) {
  t *= D, n *= D, Ki = t, er = O(n), rr = z(n), Wn.point = Zh;
}
function Zh(t, n) {
  t *= D, n *= D;
  var e = O(n), r = z(n), i = Z(t - Ki), o = z(i), a = O(i), u = r * a, c = rr * e - er * r * o, f = er * e + rr * r * o;
  Zi.add(St(pt(u * u + c * c), f)), Ki = t, er = e, rr = r;
}
function Fs(t) {
  return Zi = new yt(), qt(t, Wn), +Zi;
}
var Ji = [null, null], Kh = { type: "LineString", coordinates: Ji };
function kr(t, n) {
  return Ji[0] = t, Ji[1] = n, Fs(Kh);
}
var iu = {
  Feature: function(t, n) {
    return Cr(t.geometry, n);
  },
  FeatureCollection: function(t, n) {
    for (var e = t.features, r = -1, i = e.length; ++r < i; )
      if (Cr(e[r].geometry, n))
        return !0;
    return !1;
  }
}, ou = {
  Sphere: function() {
    return !0;
  },
  Point: function(t, n) {
    return au(t.coordinates, n);
  },
  MultiPoint: function(t, n) {
    for (var e = t.coordinates, r = -1, i = e.length; ++r < i; )
      if (au(e[r], n))
        return !0;
    return !1;
  },
  LineString: function(t, n) {
    return uu(t.coordinates, n);
  },
  MultiLineString: function(t, n) {
    for (var e = t.coordinates, r = -1, i = e.length; ++r < i; )
      if (uu(e[r], n))
        return !0;
    return !1;
  },
  Polygon: function(t, n) {
    return su(t.coordinates, n);
  },
  MultiPolygon: function(t, n) {
    for (var e = t.coordinates, r = -1, i = e.length; ++r < i; )
      if (su(e[r], n))
        return !0;
    return !1;
  },
  GeometryCollection: function(t, n) {
    for (var e = t.geometries, r = -1, i = e.length; ++r < i; )
      if (Cr(e[r], n))
        return !0;
    return !1;
  }
};
function Cr(t, n) {
  return t && ou.hasOwnProperty(t.type) ? ou[t.type](t, n) : !1;
}
function au(t, n) {
  return kr(t, n) === 0;
}
function uu(t, n) {
  for (var e, r, i, o = 0, a = t.length; o < a; o++) {
    if (r = kr(t[o], n), r === 0 || o > 0 && (i = kr(t[o], t[o - 1]), i > 0 && e <= i && r <= i && (e + r - i) * (1 - Math.pow((e - r) / i, 2)) < be * i))
      return !0;
    e = r;
  }
  return !1;
}
function su(t, n) {
  return !!Os(t.map(Jh), Ds(n));
}
function Jh(t) {
  return t = t.map(Ds), t.pop(), t;
}
function Ds(t) {
  return [t[0] * D, t[1] * D];
}
function Qh(t, n) {
  return (t && iu.hasOwnProperty(t.type) ? iu[t.type] : Cr)(t, n);
}
function cu(t, n, e) {
  var r = On(t, n - F, e).concat(n);
  return function(i) {
    return r.map(function(o) {
      return [i, o];
    });
  };
}
function fu(t, n, e) {
  var r = On(t, n - F, e).concat(n);
  return function(i) {
    return r.map(function(o) {
      return [o, i];
    });
  };
}
function Co() {
  var t, n, e, r, i, o, a, u, c = 10, f = c, s = 90, l = 360, h, p, g, w, b = 2.5;
  function _() {
    return { type: "MultiLineString", coordinates: S() };
  }
  function S() {
    return On(Be(r / s) * s, e, s).map(g).concat(On(Be(u / l) * l, a, l).map(w)).concat(On(Be(n / c) * c, t, c).filter(function(y) {
      return Z(y % s) > F;
    }).map(h)).concat(On(Be(o / f) * f, i, f).filter(function(y) {
      return Z(y % l) > F;
    }).map(p));
  }
  return _.lines = function() {
    return S().map(function(y) {
      return { type: "LineString", coordinates: y };
    });
  }, _.outline = function() {
    return {
      type: "Polygon",
      coordinates: [
        g(r).concat(
          w(a).slice(1),
          g(e).reverse().slice(1),
          w(u).reverse().slice(1)
        )
      ]
    };
  }, _.extent = function(y) {
    return arguments.length ? _.extentMajor(y).extentMinor(y) : _.extentMinor();
  }, _.extentMajor = function(y) {
    return arguments.length ? (r = +y[0][0], e = +y[1][0], u = +y[0][1], a = +y[1][1], r > e && (y = r, r = e, e = y), u > a && (y = u, u = a, a = y), _.precision(b)) : [[r, u], [e, a]];
  }, _.extentMinor = function(y) {
    return arguments.length ? (n = +y[0][0], t = +y[1][0], o = +y[0][1], i = +y[1][1], n > t && (y = n, n = t, t = y), o > i && (y = o, o = i, i = y), _.precision(b)) : [[n, o], [t, i]];
  }, _.step = function(y) {
    return arguments.length ? _.stepMajor(y).stepMinor(y) : _.stepMinor();
  }, _.stepMajor = function(y) {
    return arguments.length ? (s = +y[0], l = +y[1], _) : [s, l];
  }, _.stepMinor = function(y) {
    return arguments.length ? (c = +y[0], f = +y[1], _) : [c, f];
  }, _.precision = function(y) {
    return arguments.length ? (b = +y, h = cu(o, i, 90), p = fu(n, t, b), g = cu(u, a, 90), w = fu(r, e, b), _) : b;
  }, _.extentMajor([[-180, -90 + F], [180, 90 - F]]).extentMinor([[-180, -80 - F], [180, 80 + F]]);
}
function t0() {
  return Co()();
}
function n0(t, n) {
  var e = t[0] * D, r = t[1] * D, i = n[0] * D, o = n[1] * D, a = z(r), u = O(r), c = z(o), f = O(o), s = a * z(e), l = a * O(e), h = c * z(i), p = c * O(i), g = 2 * Mt(pt(Wa(o - r) + a * c * Wa(i - e))), w = O(g), b = g ? function(_) {
    var S = O(_ *= g) / w, y = O(g - _) / w, E = y * s + S * h, M = y * l + S * p, R = y * u + S * f;
    return [
      St(M, E) * rt,
      St(R, pt(E * E + M * M)) * rt
    ];
  } : function() {
    return [e * rt, r * rt];
  };
  return b.distance = g, b;
}
const Ee = (t) => t;
var yi = new yt(), Qi = new yt(), Is, Ls, to, no, hn = {
  point: ut,
  lineStart: ut,
  lineEnd: ut,
  polygonStart: function() {
    hn.lineStart = e0, hn.lineEnd = i0;
  },
  polygonEnd: function() {
    hn.lineStart = hn.lineEnd = hn.point = ut, yi.add(Z(Qi)), Qi = new yt();
  },
  result: function() {
    var t = yi / 2;
    return yi = new yt(), t;
  }
};
function e0() {
  hn.point = r0;
}
function r0(t, n) {
  hn.point = qs, Is = to = t, Ls = no = n;
}
function qs(t, n) {
  Qi.add(no * t - to * n), to = t, no = n;
}
function i0() {
  qs(Is, Ls);
}
const lu = hn;
var Bn = 1 / 0, Tr = Bn, Se = -Bn, Ar = Se, o0 = {
  point: a0,
  lineStart: ut,
  lineEnd: ut,
  polygonStart: ut,
  polygonEnd: ut,
  result: function() {
    var t = [[Bn, Tr], [Se, Ar]];
    return Se = Ar = -(Tr = Bn = 1 / 0), t;
  }
};
function a0(t, n) {
  t < Bn && (Bn = t), t > Se && (Se = t), n < Tr && (Tr = n), n > Ar && (Ar = n);
}
const Or = o0;
var eo = 0, ro = 0, ie = 0, jr = 0, zr = 0, jn = 0, io = 0, oo = 0, oe = 0, Ys, Gs, Bt, Ht, Yt = {
  point: Nn,
  lineStart: hu,
  lineEnd: pu,
  polygonStart: function() {
    Yt.lineStart = c0, Yt.lineEnd = f0;
  },
  polygonEnd: function() {
    Yt.point = Nn, Yt.lineStart = hu, Yt.lineEnd = pu;
  },
  result: function() {
    var t = oe ? [io / oe, oo / oe] : jn ? [jr / jn, zr / jn] : ie ? [eo / ie, ro / ie] : [NaN, NaN];
    return eo = ro = ie = jr = zr = jn = io = oo = oe = 0, t;
  }
};
function Nn(t, n) {
  eo += t, ro += n, ++ie;
}
function hu() {
  Yt.point = u0;
}
function u0(t, n) {
  Yt.point = s0, Nn(Bt = t, Ht = n);
}
function s0(t, n) {
  var e = t - Bt, r = n - Ht, i = pt(e * e + r * r);
  jr += i * (Bt + t) / 2, zr += i * (Ht + n) / 2, jn += i, Nn(Bt = t, Ht = n);
}
function pu() {
  Yt.point = Nn;
}
function c0() {
  Yt.point = l0;
}
function f0() {
  Ws(Ys, Gs);
}
function l0(t, n) {
  Yt.point = Ws, Nn(Ys = Bt = t, Gs = Ht = n);
}
function Ws(t, n) {
  var e = t - Bt, r = n - Ht, i = pt(e * e + r * r);
  jr += i * (Bt + t) / 2, zr += i * (Ht + n) / 2, jn += i, i = Ht * t - Bt * n, io += i * (Bt + t), oo += i * (Ht + n), oe += i * 3, Nn(Bt = t, Ht = n);
}
const du = Yt;
function Bs(t) {
  this._context = t;
}
Bs.prototype = {
  _radius: 4.5,
  pointRadius: function(t) {
    return this._radius = t, this;
  },
  polygonStart: function() {
    this._line = 0;
  },
  polygonEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    this._line === 0 && this._context.closePath(), this._point = NaN;
  },
  point: function(t, n) {
    switch (this._point) {
      case 0: {
        this._context.moveTo(t, n), this._point = 1;
        break;
      }
      case 1: {
        this._context.lineTo(t, n);
        break;
      }
      default: {
        this._context.moveTo(t + this._radius, n), this._context.arc(t, n, this._radius, 0, Et);
        break;
      }
    }
  },
  result: ut
};
var ao = new yt(), xi, Hs, Xs, ae, ue, Fr = {
  point: ut,
  lineStart: function() {
    Fr.point = h0;
  },
  lineEnd: function() {
    xi && Us(Hs, Xs), Fr.point = ut;
  },
  polygonStart: function() {
    xi = !0;
  },
  polygonEnd: function() {
    xi = null;
  },
  result: function() {
    var t = +ao;
    return ao = new yt(), t;
  }
};
function h0(t, n) {
  Fr.point = Us, Hs = ae = t, Xs = ue = n;
}
function Us(t, n) {
  ae -= t, ue -= n, ao.add(pt(ae * ae + ue * ue)), ae = t, ue = n;
}
const gu = Fr;
function Vs() {
  this._string = [];
}
Vs.prototype = {
  _radius: 4.5,
  _circle: vu(4.5),
  pointRadius: function(t) {
    return (t = +t) !== this._radius && (this._radius = t, this._circle = null), this;
  },
  polygonStart: function() {
    this._line = 0;
  },
  polygonEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    this._line === 0 && this._string.push("Z"), this._point = NaN;
  },
  point: function(t, n) {
    switch (this._point) {
      case 0: {
        this._string.push("M", t, ",", n), this._point = 1;
        break;
      }
      case 1: {
        this._string.push("L", t, ",", n);
        break;
      }
      default: {
        this._circle == null && (this._circle = vu(this._radius)), this._string.push("M", t, ",", n, this._circle);
        break;
      }
    }
  },
  result: function() {
    if (this._string.length) {
      var t = this._string.join("");
      return this._string = [], t;
    } else
      return null;
  }
};
function vu(t) {
  return "m0," + t + "a" + t + "," + t + " 0 1,1 0," + -2 * t + "a" + t + "," + t + " 0 1,1 0," + 2 * t + "z";
}
function Zs(t, n) {
  var e = 4.5, r, i;
  function o(a) {
    return a && (typeof e == "function" && i.pointRadius(+e.apply(this, arguments)), qt(a, r(i))), i.result();
  }
  return o.area = function(a) {
    return qt(a, r(lu)), lu.result();
  }, o.measure = function(a) {
    return qt(a, r(gu)), gu.result();
  }, o.bounds = function(a) {
    return qt(a, r(Or)), Or.result();
  }, o.centroid = function(a) {
    return qt(a, r(du)), du.result();
  }, o.projection = function(a) {
    return arguments.length ? (r = a == null ? (t = null, Ee) : (t = a).stream, o) : t;
  }, o.context = function(a) {
    return arguments.length ? (i = a == null ? (n = null, new Vs()) : new Bs(n = a), typeof e != "function" && i.pointRadius(e), o) : n;
  }, o.pointRadius = function(a) {
    return arguments.length ? (e = typeof a == "function" ? a : (i.pointRadius(+a), +a), o) : e;
  }, o.projection(t).context(n);
}
function p0(t) {
  return {
    stream: Te(t)
  };
}
function Te(t) {
  return function(n) {
    var e = new uo();
    for (var r in t)
      e[r] = t[r];
    return e.stream = n, e;
  };
}
function uo() {
}
uo.prototype = {
  constructor: uo,
  point: function(t, n) {
    this.stream.point(t, n);
  },
  sphere: function() {
    this.stream.sphere();
  },
  lineStart: function() {
    this.stream.lineStart();
  },
  lineEnd: function() {
    this.stream.lineEnd();
  },
  polygonStart: function() {
    this.stream.polygonStart();
  },
  polygonEnd: function() {
    this.stream.polygonEnd();
  }
};
function To(t, n, e) {
  var r = t.clipExtent && t.clipExtent();
  return t.scale(150).translate([0, 0]), r != null && t.clipExtent(null), qt(e, t.stream(Or)), n(Or.result()), r != null && t.clipExtent(r), t;
}
function Qr(t, n, e) {
  return To(t, function(r) {
    var i = n[1][0] - n[0][0], o = n[1][1] - n[0][1], a = Math.min(i / (r[1][0] - r[0][0]), o / (r[1][1] - r[0][1])), u = +n[0][0] + (i - a * (r[1][0] + r[0][0])) / 2, c = +n[0][1] + (o - a * (r[1][1] + r[0][1])) / 2;
    t.scale(150 * a).translate([u, c]);
  }, e);
}
function Ao(t, n, e) {
  return Qr(t, [[0, 0], n], e);
}
function Oo(t, n, e) {
  return To(t, function(r) {
    var i = +n, o = i / (r[1][0] - r[0][0]), a = (i - o * (r[1][0] + r[0][0])) / 2, u = -o * r[0][1];
    t.scale(150 * o).translate([a, u]);
  }, e);
}
function jo(t, n, e) {
  return To(t, function(r) {
    var i = +n, o = i / (r[1][1] - r[0][1]), a = -o * r[0][0], u = (i - o * (r[1][1] + r[0][1])) / 2;
    t.scale(150 * o).translate([a, u]);
  }, e);
}
var mu = 16, d0 = z(30 * D);
function yu(t, n) {
  return +n ? v0(t, n) : g0(t);
}
function g0(t) {
  return Te({
    point: function(n, e) {
      n = t(n, e), this.stream.point(n[0], n[1]);
    }
  });
}
function v0(t, n) {
  function e(r, i, o, a, u, c, f, s, l, h, p, g, w, b) {
    var _ = f - r, S = s - i, y = _ * _ + S * S;
    if (y > 4 * n && w--) {
      var E = a + h, M = u + p, R = c + g, j = pt(E * E + M * M + R * R), I = Mt(R /= j), q = Z(Z(R) - 1) < F || Z(o - l) < F ? (o + l) / 2 : St(M, E), W = t(q, I), P = W[0], B = W[1], L = P - r, v = B - i, m = S * L - _ * v;
      (m * m / y > n || Z((_ * L + S * v) / y - 0.5) > 0.3 || a * h + u * p + c * g < d0) && (e(r, i, o, a, u, c, P, B, q, E /= j, M /= j, R, w, b), b.point(P, B), e(P, B, q, E, M, R, f, s, l, h, p, g, w, b));
    }
  }
  return function(r) {
    var i, o, a, u, c, f, s, l, h, p, g, w, b = {
      point: _,
      lineStart: S,
      lineEnd: E,
      polygonStart: function() {
        r.polygonStart(), b.lineStart = M;
      },
      polygonEnd: function() {
        r.polygonEnd(), b.lineStart = S;
      }
    };
    function _(I, q) {
      I = t(I, q), r.point(I[0], I[1]);
    }
    function S() {
      l = NaN, b.point = y, r.lineStart();
    }
    function y(I, q) {
      var W = Mn([I, q]), P = t(I, q);
      e(l, h, s, p, g, w, l = P[0], h = P[1], s = I, p = W[0], g = W[1], w = W[2], mu, r), r.point(l, h);
    }
    function E() {
      b.point = _, r.lineEnd();
    }
    function M() {
      S(), b.point = R, b.lineEnd = j;
    }
    function R(I, q) {
      y(i = I, q), o = l, a = h, u = p, c = g, f = w, b.point = y;
    }
    function j() {
      e(l, h, s, p, g, w, o, a, i, u, c, f, mu, r), b.lineEnd = E, E();
    }
    return b;
  };
}
var m0 = Te({
  point: function(t, n) {
    this.stream.point(t * D, n * D);
  }
});
function y0(t) {
  return Te({
    point: function(n, e) {
      var r = t(n, e);
      return this.stream.point(r[0], r[1]);
    }
  });
}
function x0(t, n, e, r, i) {
  function o(a, u) {
    return a *= r, u *= i, [n + t * a, e - t * u];
  }
  return o.invert = function(a, u) {
    return [(a - n) / t * r, (e - u) / t * i];
  }, o;
}
function xu(t, n, e, r, i, o) {
  if (!o)
    return x0(t, n, e, r, i);
  var a = z(o), u = O(o), c = a * t, f = u * t, s = a / t, l = u / t, h = (u * e - a * n) / t, p = (u * n + a * e) / t;
  function g(w, b) {
    return w *= r, b *= i, [c * w - f * b + n, e - f * w - c * b];
  }
  return g.invert = function(w, b) {
    return [r * (s * w - l * b + h), i * (p - l * w - s * b)];
  }, g;
}
function Kt(t) {
  return zo(function() {
    return t;
  })();
}
function zo(t) {
  var n, e = 150, r = 480, i = 250, o = 0, a = 0, u = 0, c = 0, f = 0, s, l = 0, h = 1, p = 1, g = null, w = Vi, b = null, _, S, y, E = Ee, M = 0.5, R, j, I, q, W;
  function P(m) {
    return I(m[0] * D, m[1] * D);
  }
  function B(m) {
    return m = I.invert(m[0], m[1]), m && [m[0] * rt, m[1] * rt];
  }
  P.stream = function(m) {
    return q && W === m ? q : q = m0(y0(s)(w(R(E(W = m)))));
  }, P.preclip = function(m) {
    return arguments.length ? (w = m, g = void 0, v()) : w;
  }, P.postclip = function(m) {
    return arguments.length ? (E = m, b = _ = S = y = null, v()) : E;
  }, P.clipAngle = function(m) {
    return arguments.length ? (w = +m ? zs(g = m * D) : (g = null, Vi), v()) : g * rt;
  }, P.clipExtent = function(m) {
    return arguments.length ? (E = m == null ? (b = _ = S = y = null, Ee) : Jr(b = +m[0][0], _ = +m[0][1], S = +m[1][0], y = +m[1][1]), v()) : b == null ? null : [[b, _], [S, y]];
  }, P.scale = function(m) {
    return arguments.length ? (e = +m, L()) : e;
  }, P.translate = function(m) {
    return arguments.length ? (r = +m[0], i = +m[1], L()) : [r, i];
  }, P.center = function(m) {
    return arguments.length ? (o = m[0] % 360 * D, a = m[1] % 360 * D, L()) : [o * rt, a * rt];
  }, P.rotate = function(m) {
    return arguments.length ? (u = m[0] % 360 * D, c = m[1] % 360 * D, f = m.length > 2 ? m[2] % 360 * D : 0, L()) : [u * rt, c * rt, f * rt];
  }, P.angle = function(m) {
    return arguments.length ? (l = m % 360 * D, L()) : l * rt;
  }, P.reflectX = function(m) {
    return arguments.length ? (h = m ? -1 : 1, L()) : h < 0;
  }, P.reflectY = function(m) {
    return arguments.length ? (p = m ? -1 : 1, L()) : p < 0;
  }, P.precision = function(m) {
    return arguments.length ? (R = yu(j, M = m * m), v()) : pt(M);
  }, P.fitExtent = function(m, x) {
    return Qr(P, m, x);
  }, P.fitSize = function(m, x) {
    return Ao(P, m, x);
  }, P.fitWidth = function(m, x) {
    return Oo(P, m, x);
  }, P.fitHeight = function(m, x) {
    return jo(P, m, x);
  };
  function L() {
    var m = xu(e, 0, 0, h, p, l).apply(null, n(o, a)), x = xu(e, r - m[0], i - m[1], h, p, l);
    return s = ko(u, c, f), j = Xi(n, x), I = Xi(s, j), R = yu(j, M), v();
  }
  function v() {
    return q = W = null, P;
  }
  return function() {
    return n = t.apply(this, arguments), P.invert = n.invert && B, L();
  };
}
function Fo(t) {
  var n = 0, e = X / 3, r = zo(t), i = r(n, e);
  return i.parallels = function(o) {
    return arguments.length ? r(n = o[0] * D, e = o[1] * D) : [n * rt, e * rt];
  }, i;
}
function _0(t) {
  var n = z(t);
  function e(r, i) {
    return [r * n, O(i) / n];
  }
  return e.invert = function(r, i) {
    return [r / n, Mt(i * n)];
  }, e;
}
function Ks(t, n) {
  var e = O(t), r = (e + O(n)) / 2;
  if (Z(r) < F)
    return _0(t);
  var i = 1 + e * (2 * r - e), o = pt(i) / r;
  function a(u, c) {
    var f = pt(i - 2 * r * O(c)) / r;
    return [f * O(u *= r), o - f * z(u)];
  }
  return a.invert = function(u, c) {
    var f = o - c, s = St(u, Z(f)) * Dt(f);
    return f * r < 0 && (s -= X * Dt(u) * Dt(f)), [s / r, Mt((i - (u * u + f * f) * r * r) / (2 * r))];
  }, a;
}
function Dr() {
  return Fo(Ks).scale(155.424).center([0, 33.6442]);
}
function Js() {
  return Dr().parallels([29.5, 45.5]).scale(1070).translate([480, 250]).rotate([96, 0]).center([-0.6, 38.7]);
}
function w0(t) {
  var n = t.length;
  return {
    point: function(e, r) {
      for (var i = -1; ++i < n; )
        t[i].point(e, r);
    },
    sphere: function() {
      for (var e = -1; ++e < n; )
        t[e].sphere();
    },
    lineStart: function() {
      for (var e = -1; ++e < n; )
        t[e].lineStart();
    },
    lineEnd: function() {
      for (var e = -1; ++e < n; )
        t[e].lineEnd();
    },
    polygonStart: function() {
      for (var e = -1; ++e < n; )
        t[e].polygonStart();
    },
    polygonEnd: function() {
      for (var e = -1; ++e < n; )
        t[e].polygonEnd();
    }
  };
}
function b0() {
  var t, n, e = Js(), r, i = Dr().rotate([154, 0]).center([-2, 58.5]).parallels([55, 65]), o, a = Dr().rotate([157, 0]).center([-3, 19.9]).parallels([8, 18]), u, c, f = { point: function(h, p) {
    c = [h, p];
  } };
  function s(h) {
    var p = h[0], g = h[1];
    return c = null, r.point(p, g), c || (o.point(p, g), c) || (u.point(p, g), c);
  }
  s.invert = function(h) {
    var p = e.scale(), g = e.translate(), w = (h[0] - g[0]) / p, b = (h[1] - g[1]) / p;
    return (b >= 0.12 && b < 0.234 && w >= -0.425 && w < -0.214 ? i : b >= 0.166 && b < 0.234 && w >= -0.214 && w < -0.115 ? a : e).invert(h);
  }, s.stream = function(h) {
    return t && n === h ? t : t = w0([e.stream(n = h), i.stream(h), a.stream(h)]);
  }, s.precision = function(h) {
    return arguments.length ? (e.precision(h), i.precision(h), a.precision(h), l()) : e.precision();
  }, s.scale = function(h) {
    return arguments.length ? (e.scale(h), i.scale(h * 0.35), a.scale(h), s.translate(e.translate())) : e.scale();
  }, s.translate = function(h) {
    if (!arguments.length)
      return e.translate();
    var p = e.scale(), g = +h[0], w = +h[1];
    return r = e.translate(h).clipExtent([[g - 0.455 * p, w - 0.238 * p], [g + 0.455 * p, w + 0.238 * p]]).stream(f), o = i.translate([g - 0.307 * p, w + 0.201 * p]).clipExtent([[g - 0.425 * p + F, w + 0.12 * p + F], [g - 0.214 * p - F, w + 0.234 * p - F]]).stream(f), u = a.translate([g - 0.205 * p, w + 0.212 * p]).clipExtent([[g - 0.214 * p + F, w + 0.166 * p + F], [g - 0.115 * p - F, w + 0.234 * p - F]]).stream(f), l();
  }, s.fitExtent = function(h, p) {
    return Qr(s, h, p);
  }, s.fitSize = function(h, p) {
    return Ao(s, h, p);
  }, s.fitWidth = function(h, p) {
    return Oo(s, h, p);
  }, s.fitHeight = function(h, p) {
    return jo(s, h, p);
  };
  function l() {
    return t = n = null, s;
  }
  return s.scale(1070);
}
function Qs(t) {
  return function(n, e) {
    var r = z(n), i = z(e), o = t(r * i);
    return o === 1 / 0 ? [2, 0] : [
      o * i * O(n),
      o * O(e)
    ];
  };
}
function Ae(t) {
  return function(n, e) {
    var r = pt(n * n + e * e), i = t(r), o = O(i), a = z(i);
    return [
      St(n * o, r * a),
      Mt(r && e * o / r)
    ];
  };
}
var Do = Qs(function(t) {
  return pt(2 / (1 + t));
});
Do.invert = Ae(function(t) {
  return 2 * Mt(t / 2);
});
function E0() {
  return Kt(Do).scale(124.75).clipAngle(180 - 1e-3);
}
var Io = Qs(function(t) {
  return (t = xs(t)) && t / O(t);
});
Io.invert = Ae(function(t) {
  return t;
});
function S0() {
  return Kt(Io).scale(79.4188).clipAngle(180 - 1e-3);
}
function Oe(t, n) {
  return [t, mr(Po((ft + n) / 2))];
}
Oe.invert = function(t, n) {
  return [t, 2 * Vn(ys(n)) - ft];
};
function M0() {
  return tc(Oe).scale(961 / Et);
}
function tc(t) {
  var n = Kt(t), e = n.center, r = n.scale, i = n.translate, o = n.clipExtent, a = null, u, c, f;
  n.scale = function(l) {
    return arguments.length ? (r(l), s()) : r();
  }, n.translate = function(l) {
    return arguments.length ? (i(l), s()) : i();
  }, n.center = function(l) {
    return arguments.length ? (e(l), s()) : e();
  }, n.clipExtent = function(l) {
    return arguments.length ? (l == null ? a = u = c = f = null : (a = +l[0][0], u = +l[0][1], c = +l[1][0], f = +l[1][1]), s()) : a == null ? null : [[a, u], [c, f]];
  };
  function s() {
    var l = X * r(), h = n(ks(n.rotate()).invert([0, 0]));
    return o(a == null ? [[h[0] - l, h[1] - l], [h[0] + l, h[1] + l]] : t === Oe ? [[Math.max(h[0] - l, a), u], [Math.min(h[0] + l, c), f]] : [[a, Math.max(h[1] - l, u)], [c, Math.min(h[1] + l, f)]]);
  }
  return s();
}
function Ze(t) {
  return Po((ft + t) / 2);
}
function nc(t, n) {
  var e = z(t), r = t === n ? O(t) : mr(e / z(n)) / mr(Ze(n) / Ze(t)), i = e * gi(Ze(t), r) / r;
  if (!r)
    return Oe;
  function o(a, u) {
    i > 0 ? u < -ft + F && (u = -ft + F) : u > ft - F && (u = ft - F);
    var c = i / gi(Ze(u), r);
    return [c * O(r * a), i - c * z(r * a)];
  }
  return o.invert = function(a, u) {
    var c = i - u, f = Dt(r) * pt(a * a + c * c), s = St(a, Z(c)) * Dt(c);
    return c * r < 0 && (s -= X * Dt(a) * Dt(c)), [s / r, 2 * Vn(gi(i / f, 1 / r)) - ft];
  }, o;
}
function N0() {
  return Fo(nc).scale(109.5).parallels([30, 30]);
}
function Me(t, n) {
  return [t, n];
}
Me.invert = Me;
function $0() {
  return Kt(Me).scale(152.63);
}
function ec(t, n) {
  var e = z(t), r = t === n ? O(t) : (e - z(n)) / (n - t), i = e / r + t;
  if (Z(r) < F)
    return Me;
  function o(a, u) {
    var c = i - u, f = r * a;
    return [c * O(f), i - c * z(f)];
  }
  return o.invert = function(a, u) {
    var c = i - u, f = St(a, Z(c)) * Dt(c);
    return c * r < 0 && (f -= X * Dt(a) * Dt(c)), [f / r, i - Dt(r) * pt(a * a + c * c)];
  }, o;
}
function P0() {
  return Fo(ec).scale(131.154).center([0, 13.9389]);
}
var le = 1.340264, he = -0.081106, pe = 893e-6, de = 3796e-6, Ir = pt(3) / 2, R0 = 12;
function Lo(t, n) {
  var e = Mt(Ir * O(n)), r = e * e, i = r * r * r;
  return [
    t * z(e) / (Ir * (le + 3 * he * r + i * (7 * pe + 9 * de * r))),
    e * (le + he * r + i * (pe + de * r))
  ];
}
Lo.invert = function(t, n) {
  for (var e = n, r = e * e, i = r * r * r, o = 0, a, u, c; o < R0 && (u = e * (le + he * r + i * (pe + de * r)) - n, c = le + 3 * he * r + i * (7 * pe + 9 * de * r), e -= a = u / c, r = e * e, i = r * r * r, !(Z(a) < be)); ++o)
    ;
  return [
    Ir * t * (le + 3 * he * r + i * (7 * pe + 9 * de * r)) / z(e),
    Mt(O(e) / Ir)
  ];
};
function k0() {
  return Kt(Lo).scale(177.158);
}
function qo(t, n) {
  var e = z(n), r = z(t) * e;
  return [e * O(t) / r, O(n) / r];
}
qo.invert = Ae(Vn);
function C0() {
  return Kt(qo).scale(144.049).clipAngle(60);
}
function T0() {
  var t = 1, n = 0, e = 0, r = 1, i = 1, o = 0, a, u, c = null, f, s, l, h = 1, p = 1, g = Te({
    point: function(E, M) {
      var R = y([E, M]);
      this.stream.point(R[0], R[1]);
    }
  }), w = Ee, b, _;
  function S() {
    return h = t * r, p = t * i, b = _ = null, y;
  }
  function y(E) {
    var M = E[0] * h, R = E[1] * p;
    if (o) {
      var j = R * a - M * u;
      M = M * a + R * u, R = j;
    }
    return [M + n, R + e];
  }
  return y.invert = function(E) {
    var M = E[0] - n, R = E[1] - e;
    if (o) {
      var j = R * a + M * u;
      M = M * a - R * u, R = j;
    }
    return [M / h, R / p];
  }, y.stream = function(E) {
    return b && _ === E ? b : b = g(w(_ = E));
  }, y.postclip = function(E) {
    return arguments.length ? (w = E, c = f = s = l = null, S()) : w;
  }, y.clipExtent = function(E) {
    return arguments.length ? (w = E == null ? (c = f = s = l = null, Ee) : Jr(c = +E[0][0], f = +E[0][1], s = +E[1][0], l = +E[1][1]), S()) : c == null ? null : [[c, f], [s, l]];
  }, y.scale = function(E) {
    return arguments.length ? (t = +E, S()) : t;
  }, y.translate = function(E) {
    return arguments.length ? (n = +E[0], e = +E[1], S()) : [n, e];
  }, y.angle = function(E) {
    return arguments.length ? (o = E % 360 * D, u = O(o), a = z(o), S()) : o * rt;
  }, y.reflectX = function(E) {
    return arguments.length ? (r = E ? -1 : 1, S()) : r < 0;
  }, y.reflectY = function(E) {
    return arguments.length ? (i = E ? -1 : 1, S()) : i < 0;
  }, y.fitExtent = function(E, M) {
    return Qr(y, E, M);
  }, y.fitSize = function(E, M) {
    return Ao(y, E, M);
  }, y.fitWidth = function(E, M) {
    return Oo(y, E, M);
  }, y.fitHeight = function(E, M) {
    return jo(y, E, M);
  }, y;
}
function Yo(t, n) {
  var e = n * n, r = e * e;
  return [
    t * (0.8707 - 0.131979 * e + r * (-0.013791 + r * (3971e-6 * e - 1529e-6 * r))),
    n * (1.007226 + e * (0.015085 + r * (-0.044475 + 0.028874 * e - 5916e-6 * r)))
  ];
}
Yo.invert = function(t, n) {
  var e = n, r = 25, i;
  do {
    var o = e * e, a = o * o;
    e -= i = (e * (1.007226 + o * (0.015085 + a * (-0.044475 + 0.028874 * o - 5916e-6 * a))) - n) / (1.007226 + o * (0.015085 * 3 + a * (-0.044475 * 7 + 0.028874 * 9 * o - 5916e-6 * 11 * a)));
  } while (Z(i) > F && --r > 0);
  return [
    t / (0.8707 + (o = e * e) * (-0.131979 + o * (-0.013791 + o * o * o * (3971e-6 - 1529e-6 * o)))),
    e
  ];
};
function A0() {
  return Kt(Yo).scale(175.295);
}
function Go(t, n) {
  return [z(n) * O(t), O(n)];
}
Go.invert = Ae(Mt);
function O0() {
  return Kt(Go).scale(249.5).clipAngle(90 + F);
}
function Wo(t, n) {
  var e = z(n), r = 1 + z(t) * e;
  return [e * O(t) / r, O(n) / r];
}
Wo.invert = Ae(function(t) {
  return 2 * Vn(t);
});
function j0() {
  return Kt(Wo).scale(250).clipAngle(142);
}
function Bo(t, n) {
  return [mr(Po((ft + n) / 2)), -t];
}
Bo.invert = function(t, n) {
  return [-n, 2 * Vn(ys(t)) - ft];
};
function z0() {
  var t = tc(Bo), n = t.center, e = t.rotate;
  return t.center = function(r) {
    return arguments.length ? n([-r[1], r[0]]) : (r = n(), [r[1], -r[0]]);
  }, t.rotate = function(r) {
    return arguments.length ? e([r[0], r[1], r.length > 2 ? r[2] + 90 : 90]) : (r = e(), [r[0], r[1], r[2] - 90]);
  }, e([0, 0, 90]).scale(159.155);
}
const F0 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  geoAlbers: Js,
  geoAlbersUsa: b0,
  geoArea: Ph,
  geoAzimuthalEqualArea: E0,
  geoAzimuthalEqualAreaRaw: Do,
  geoAzimuthalEquidistant: S0,
  geoAzimuthalEquidistantRaw: Io,
  geoBounds: Th,
  geoCentroid: Dh,
  geoCircle: Ih,
  geoClipAntimeridian: Vi,
  geoClipCircle: zs,
  geoClipExtent: Hh,
  geoClipRectangle: Jr,
  geoConicConformal: N0,
  geoConicConformalRaw: nc,
  geoConicEqualArea: Dr,
  geoConicEqualAreaRaw: Ks,
  geoConicEquidistant: P0,
  geoConicEquidistantRaw: ec,
  geoContains: Qh,
  geoDistance: kr,
  geoEqualEarth: k0,
  geoEqualEarthRaw: Lo,
  geoEquirectangular: $0,
  geoEquirectangularRaw: Me,
  geoGnomonic: C0,
  geoGnomonicRaw: qo,
  geoGraticule: Co,
  geoGraticule10: t0,
  geoIdentity: T0,
  geoInterpolate: n0,
  geoLength: Fs,
  geoMercator: M0,
  geoMercatorRaw: Oe,
  geoNaturalEarth1: A0,
  geoNaturalEarth1Raw: Yo,
  geoOrthographic: O0,
  geoOrthographicRaw: Go,
  geoPath: Zs,
  geoProjection: Kt,
  geoProjectionMutator: zo,
  geoRotation: ks,
  geoStereographic: j0,
  geoStereographicRaw: Wo,
  geoStream: qt,
  geoTransform: p0,
  geoTransverseMercator: z0,
  geoTransverseMercatorRaw: Bo
}, Symbol.toStringTag, { value: "Module" }));
function D0(t) {
  return t;
}
function I0(t) {
  if (t == null)
    return D0;
  var n, e, r = t.scale[0], i = t.scale[1], o = t.translate[0], a = t.translate[1];
  return function(u, c) {
    c || (n = e = 0);
    var f = 2, s = u.length, l = new Array(s);
    for (l[0] = (n += u[0]) * r + o, l[1] = (e += u[1]) * i + a; f < s; )
      l[f] = u[f], ++f;
    return l;
  };
}
function L0(t, n) {
  for (var e, r = t.length, i = r - n; i < --r; )
    e = t[i], t[i++] = t[r], t[r] = e;
}
function q0(t, n) {
  return typeof n == "string" && (n = t.objects[n]), n.type === "GeometryCollection" ? { type: "FeatureCollection", features: n.geometries.map(function(e) {
    return _u(t, e);
  }) } : _u(t, n);
}
function _u(t, n) {
  var e = n.id, r = n.bbox, i = n.properties == null ? {} : n.properties, o = rc(t, n);
  return e == null && r == null ? { type: "Feature", properties: i, geometry: o } : r == null ? { type: "Feature", id: e, properties: i, geometry: o } : { type: "Feature", id: e, bbox: r, properties: i, geometry: o };
}
function rc(t, n) {
  var e = I0(t.transform), r = t.arcs;
  function i(s, l) {
    l.length && l.pop();
    for (var h = r[s < 0 ? ~s : s], p = 0, g = h.length; p < g; ++p)
      l.push(e(h[p], p));
    s < 0 && L0(l, g);
  }
  function o(s) {
    return e(s);
  }
  function a(s) {
    for (var l = [], h = 0, p = s.length; h < p; ++h)
      i(s[h], l);
    return l.length < 2 && l.push(l[0]), l;
  }
  function u(s) {
    for (var l = a(s); l.length < 4; )
      l.push(l[0]);
    return l;
  }
  function c(s) {
    return s.map(u);
  }
  function f(s) {
    var l = s.type, h;
    switch (l) {
      case "GeometryCollection":
        return { type: l, geometries: s.geometries.map(f) };
      case "Point":
        h = o(s.coordinates);
        break;
      case "MultiPoint":
        h = s.coordinates.map(o);
        break;
      case "LineString":
        h = a(s.arcs);
        break;
      case "MultiLineString":
        h = s.arcs.map(a);
        break;
      case "Polygon":
        h = c(s.arcs);
        break;
      case "MultiPolygon":
        h = s.arcs.map(c);
        break;
      default:
        return null;
    }
    return { type: l, coordinates: h };
  }
  return f(n);
}
function Y0(t, n) {
  var e = {}, r = {}, i = {}, o = [], a = -1;
  n.forEach(function(f, s) {
    var l = t.arcs[f < 0 ? ~f : f], h;
    l.length < 3 && !l[1][0] && !l[1][1] && (h = n[++a], n[a] = f, n[s] = h);
  }), n.forEach(function(f) {
    var s = u(f), l = s[0], h = s[1], p, g;
    if (p = i[l])
      if (delete i[p.end], p.push(f), p.end = h, g = r[h]) {
        delete r[g.start];
        var w = g === p ? p : p.concat(g);
        r[w.start = p.start] = i[w.end = g.end] = w;
      } else
        r[p.start] = i[p.end] = p;
    else if (p = r[h])
      if (delete r[p.start], p.unshift(f), p.start = l, g = i[l]) {
        delete i[g.end];
        var b = g === p ? p : g.concat(p);
        r[b.start = g.start] = i[b.end = p.end] = b;
      } else
        r[p.start] = i[p.end] = p;
    else
      p = [f], r[p.start = l] = i[p.end = h] = p;
  });
  function u(f) {
    var s = t.arcs[f < 0 ? ~f : f], l = s[0], h;
    return t.transform ? (h = [0, 0], s.forEach(function(p) {
      h[0] += p[0], h[1] += p[1];
    })) : h = s[s.length - 1], f < 0 ? [h, l] : [l, h];
  }
  function c(f, s) {
    for (var l in f) {
      var h = f[l];
      delete s[h.start], delete h.start, delete h.end, h.forEach(function(p) {
        e[p < 0 ? ~p : p] = 1;
      }), o.push(h);
    }
  }
  return c(i, r), c(r, i), n.forEach(function(f) {
    e[f < 0 ? ~f : f] || o.push([f]);
  }), o;
}
function wu(t) {
  return rc(t, G0.apply(this, arguments));
}
function G0(t, n, e) {
  var r, i, o;
  if (arguments.length > 1)
    r = W0(t, n, e);
  else
    for (i = 0, r = new Array(o = t.arcs.length); i < o; ++i)
      r[i] = i;
  return { type: "MultiLineString", arcs: Y0(t, r) };
}
function W0(t, n, e) {
  var r = [], i = [], o;
  function a(l) {
    var h = l < 0 ? ~l : l;
    (i[h] || (i[h] = [])).push({ i: l, g: o });
  }
  function u(l) {
    l.forEach(a);
  }
  function c(l) {
    l.forEach(u);
  }
  function f(l) {
    l.forEach(c);
  }
  function s(l) {
    switch (o = l, l.type) {
      case "GeometryCollection":
        l.geometries.forEach(s);
        break;
      case "LineString":
        u(l.arcs);
        break;
      case "MultiLineString":
      case "Polygon":
        c(l.arcs);
        break;
      case "MultiPolygon":
        f(l.arcs);
        break;
    }
  }
  return s(n), i.forEach(e == null ? function(l) {
    r.push(l[0].i);
  } : function(l) {
    e(l[0].g, l[l.length - 1].g) && r.push(l[0].i);
  }), r;
}
var B0 = { value: () => {
} };
function Ho() {
  for (var t = 0, n = arguments.length, e = {}, r; t < n; ++t) {
    if (!(r = arguments[t] + "") || r in e || /[\s.]/.test(r))
      throw new Error("illegal type: " + r);
    e[r] = [];
  }
  return new ir(e);
}
function ir(t) {
  this._ = t;
}
function H0(t, n) {
  return t.trim().split(/^|\s+/).map(function(e) {
    var r = "", i = e.indexOf(".");
    if (i >= 0 && (r = e.slice(i + 1), e = e.slice(0, i)), e && !n.hasOwnProperty(e))
      throw new Error("unknown type: " + e);
    return { type: e, name: r };
  });
}
ir.prototype = Ho.prototype = {
  constructor: ir,
  on: function(t, n) {
    var e = this._, r = H0(t + "", e), i, o = -1, a = r.length;
    if (arguments.length < 2) {
      for (; ++o < a; )
        if ((i = (t = r[o]).type) && (i = X0(e[i], t.name)))
          return i;
      return;
    }
    if (n != null && typeof n != "function")
      throw new Error("invalid callback: " + n);
    for (; ++o < a; )
      if (i = (t = r[o]).type)
        e[i] = bu(e[i], t.name, n);
      else if (n == null)
        for (i in e)
          e[i] = bu(e[i], t.name, null);
    return this;
  },
  copy: function() {
    var t = {}, n = this._;
    for (var e in n)
      t[e] = n[e].slice();
    return new ir(t);
  },
  call: function(t, n) {
    if ((i = arguments.length - 2) > 0)
      for (var e = new Array(i), r = 0, i, o; r < i; ++r)
        e[r] = arguments[r + 2];
    if (!this._.hasOwnProperty(t))
      throw new Error("unknown type: " + t);
    for (o = this._[t], r = 0, i = o.length; r < i; ++r)
      o[r].value.apply(n, e);
  },
  apply: function(t, n, e) {
    if (!this._.hasOwnProperty(t))
      throw new Error("unknown type: " + t);
    for (var r = this._[t], i = 0, o = r.length; i < o; ++i)
      r[i].value.apply(n, e);
  }
};
function X0(t, n) {
  for (var e = 0, r = t.length, i; e < r; ++e)
    if ((i = t[e]).name === n)
      return i.value;
}
function bu(t, n, e) {
  for (var r = 0, i = t.length; r < i; ++r)
    if (t[r].name === n) {
      t[r] = B0, t = t.slice(0, r).concat(t.slice(r + 1));
      break;
    }
  return e != null && t.push({ name: n, value: e }), t;
}
var so = "http://www.w3.org/1999/xhtml";
const Eu = {
  svg: "http://www.w3.org/2000/svg",
  xhtml: so,
  xlink: "http://www.w3.org/1999/xlink",
  xml: "http://www.w3.org/XML/1998/namespace",
  xmlns: "http://www.w3.org/2000/xmlns/"
};
function ti(t) {
  var n = t += "", e = n.indexOf(":");
  return e >= 0 && (n = t.slice(0, e)) !== "xmlns" && (t = t.slice(e + 1)), Eu.hasOwnProperty(n) ? { space: Eu[n], local: t } : t;
}
function U0(t) {
  return function() {
    var n = this.ownerDocument, e = this.namespaceURI;
    return e === so && n.documentElement.namespaceURI === so ? n.createElement(t) : n.createElementNS(e, t);
  };
}
function V0(t) {
  return function() {
    return this.ownerDocument.createElementNS(t.space, t.local);
  };
}
function ic(t) {
  var n = ti(t);
  return (n.local ? V0 : U0)(n);
}
function Z0() {
}
function Xo(t) {
  return t == null ? Z0 : function() {
    return this.querySelector(t);
  };
}
function K0(t) {
  typeof t != "function" && (t = Xo(t));
  for (var n = this._groups, e = n.length, r = new Array(e), i = 0; i < e; ++i)
    for (var o = n[i], a = o.length, u = r[i] = new Array(a), c, f, s = 0; s < a; ++s)
      (c = o[s]) && (f = t.call(c, c.__data__, s, o)) && ("__data__" in c && (f.__data__ = c.__data__), u[s] = f);
  return new Rt(r, this._parents);
}
function oc(t) {
  return typeof t == "object" && "length" in t ? t : Array.from(t);
}
function J0() {
  return [];
}
function ac(t) {
  return t == null ? J0 : function() {
    return this.querySelectorAll(t);
  };
}
function Q0(t) {
  return function() {
    var n = t.apply(this, arguments);
    return n == null ? [] : oc(n);
  };
}
function tp(t) {
  typeof t == "function" ? t = Q0(t) : t = ac(t);
  for (var n = this._groups, e = n.length, r = [], i = [], o = 0; o < e; ++o)
    for (var a = n[o], u = a.length, c, f = 0; f < u; ++f)
      (c = a[f]) && (r.push(t.call(c, c.__data__, f, a)), i.push(c));
  return new Rt(r, i);
}
function uc(t) {
  return function() {
    return this.matches(t);
  };
}
function sc(t) {
  return function(n) {
    return n.matches(t);
  };
}
var np = Array.prototype.find;
function ep(t) {
  return function() {
    return np.call(this.children, t);
  };
}
function rp() {
  return this.firstElementChild;
}
function ip(t) {
  return this.select(t == null ? rp : ep(typeof t == "function" ? t : sc(t)));
}
var op = Array.prototype.filter;
function ap() {
  return this.children;
}
function up(t) {
  return function() {
    return op.call(this.children, t);
  };
}
function sp(t) {
  return this.selectAll(t == null ? ap : up(typeof t == "function" ? t : sc(t)));
}
function cp(t) {
  typeof t != "function" && (t = uc(t));
  for (var n = this._groups, e = n.length, r = new Array(e), i = 0; i < e; ++i)
    for (var o = n[i], a = o.length, u = r[i] = [], c, f = 0; f < a; ++f)
      (c = o[f]) && t.call(c, c.__data__, f, o) && u.push(c);
  return new Rt(r, this._parents);
}
function cc(t) {
  return new Array(t.length);
}
function fp() {
  return new Rt(this._enter || this._groups.map(cc), this._parents);
}
function Lr(t, n) {
  this.ownerDocument = t.ownerDocument, this.namespaceURI = t.namespaceURI, this._next = null, this._parent = t, this.__data__ = n;
}
Lr.prototype = {
  constructor: Lr,
  appendChild: function(t) {
    return this._parent.insertBefore(t, this._next);
  },
  insertBefore: function(t, n) {
    return this._parent.insertBefore(t, n);
  },
  querySelector: function(t) {
    return this._parent.querySelector(t);
  },
  querySelectorAll: function(t) {
    return this._parent.querySelectorAll(t);
  }
};
function lp(t) {
  return function() {
    return t;
  };
}
function hp(t, n, e, r, i, o) {
  for (var a = 0, u, c = n.length, f = o.length; a < f; ++a)
    (u = n[a]) ? (u.__data__ = o[a], r[a] = u) : e[a] = new Lr(t, o[a]);
  for (; a < c; ++a)
    (u = n[a]) && (i[a] = u);
}
function pp(t, n, e, r, i, o, a) {
  var u, c, f = /* @__PURE__ */ new Map(), s = n.length, l = o.length, h = new Array(s), p;
  for (u = 0; u < s; ++u)
    (c = n[u]) && (h[u] = p = a.call(c, c.__data__, u, n) + "", f.has(p) ? i[u] = c : f.set(p, c));
  for (u = 0; u < l; ++u)
    p = a.call(t, o[u], u, o) + "", (c = f.get(p)) ? (r[u] = c, c.__data__ = o[u], f.delete(p)) : e[u] = new Lr(t, o[u]);
  for (u = 0; u < s; ++u)
    (c = n[u]) && f.get(h[u]) === c && (i[u] = c);
}
function dp(t) {
  return t.__data__;
}
function gp(t, n) {
  if (!arguments.length)
    return Array.from(this, dp);
  var e = n ? pp : hp, r = this._parents, i = this._groups;
  typeof t != "function" && (t = lp(t));
  for (var o = i.length, a = new Array(o), u = new Array(o), c = new Array(o), f = 0; f < o; ++f) {
    var s = r[f], l = i[f], h = l.length, p = oc(t.call(s, s && s.__data__, f, r)), g = p.length, w = u[f] = new Array(g), b = a[f] = new Array(g), _ = c[f] = new Array(h);
    e(s, l, w, b, _, p, n);
    for (var S = 0, y = 0, E, M; S < g; ++S)
      if (E = w[S]) {
        for (S >= y && (y = S + 1); !(M = b[y]) && ++y < g; )
          ;
        E._next = M || null;
      }
  }
  return a = new Rt(a, r), a._enter = u, a._exit = c, a;
}
function vp() {
  return new Rt(this._exit || this._groups.map(cc), this._parents);
}
function mp(t, n, e) {
  var r = this.enter(), i = this, o = this.exit();
  return r = typeof t == "function" ? t(r) : r.append(t + ""), n != null && (i = n(i)), e == null ? o.remove() : e(o), r && i ? r.merge(i).order() : i;
}
function yp(t) {
  if (!(t instanceof Rt))
    throw new Error("invalid merge");
  for (var n = this._groups, e = t._groups, r = n.length, i = e.length, o = Math.min(r, i), a = new Array(r), u = 0; u < o; ++u)
    for (var c = n[u], f = e[u], s = c.length, l = a[u] = new Array(s), h, p = 0; p < s; ++p)
      (h = c[p] || f[p]) && (l[p] = h);
  for (; u < r; ++u)
    a[u] = n[u];
  return new Rt(a, this._parents);
}
function xp() {
  for (var t = this._groups, n = -1, e = t.length; ++n < e; )
    for (var r = t[n], i = r.length - 1, o = r[i], a; --i >= 0; )
      (a = r[i]) && (o && a.compareDocumentPosition(o) ^ 4 && o.parentNode.insertBefore(a, o), o = a);
  return this;
}
function _p(t) {
  t || (t = wp);
  function n(l, h) {
    return l && h ? t(l.__data__, h.__data__) : !l - !h;
  }
  for (var e = this._groups, r = e.length, i = new Array(r), o = 0; o < r; ++o) {
    for (var a = e[o], u = a.length, c = i[o] = new Array(u), f, s = 0; s < u; ++s)
      (f = a[s]) && (c[s] = f);
    c.sort(n);
  }
  return new Rt(i, this._parents).order();
}
function wp(t, n) {
  return t < n ? -1 : t > n ? 1 : t >= n ? 0 : NaN;
}
function bp() {
  var t = arguments[0];
  return arguments[0] = this, t.apply(null, arguments), this;
}
function Ep() {
  return Array.from(this);
}
function Sp() {
  for (var t = this._groups, n = 0, e = t.length; n < e; ++n)
    for (var r = t[n], i = 0, o = r.length; i < o; ++i) {
      var a = r[i];
      if (a)
        return a;
    }
  return null;
}
function Mp() {
  let t = 0;
  for (const n of this)
    ++t;
  return t;
}
function Np() {
  return !this.node();
}
function $p(t) {
  for (var n = this._groups, e = 0, r = n.length; e < r; ++e)
    for (var i = n[e], o = 0, a = i.length, u; o < a; ++o)
      (u = i[o]) && t.call(u, u.__data__, o, i);
  return this;
}
function Pp(t) {
  return function() {
    this.removeAttribute(t);
  };
}
function Rp(t) {
  return function() {
    this.removeAttributeNS(t.space, t.local);
  };
}
function kp(t, n) {
  return function() {
    this.setAttribute(t, n);
  };
}
function Cp(t, n) {
  return function() {
    this.setAttributeNS(t.space, t.local, n);
  };
}
function Tp(t, n) {
  return function() {
    var e = n.apply(this, arguments);
    e == null ? this.removeAttribute(t) : this.setAttribute(t, e);
  };
}
function Ap(t, n) {
  return function() {
    var e = n.apply(this, arguments);
    e == null ? this.removeAttributeNS(t.space, t.local) : this.setAttributeNS(t.space, t.local, e);
  };
}
function Op(t, n) {
  var e = ti(t);
  if (arguments.length < 2) {
    var r = this.node();
    return e.local ? r.getAttributeNS(e.space, e.local) : r.getAttribute(e);
  }
  return this.each((n == null ? e.local ? Rp : Pp : typeof n == "function" ? e.local ? Ap : Tp : e.local ? Cp : kp)(e, n));
}
function fc(t) {
  return t.ownerDocument && t.ownerDocument.defaultView || t.document && t || t.defaultView;
}
function jp(t) {
  return function() {
    this.style.removeProperty(t);
  };
}
function zp(t, n, e) {
  return function() {
    this.style.setProperty(t, n, e);
  };
}
function Fp(t, n, e) {
  return function() {
    var r = n.apply(this, arguments);
    r == null ? this.style.removeProperty(t) : this.style.setProperty(t, r, e);
  };
}
function Dp(t, n, e) {
  return arguments.length > 1 ? this.each((n == null ? jp : typeof n == "function" ? Fp : zp)(t, n, e ?? "")) : Hn(this.node(), t);
}
function Hn(t, n) {
  return t.style.getPropertyValue(n) || fc(t).getComputedStyle(t, null).getPropertyValue(n);
}
function Ip(t) {
  return function() {
    delete this[t];
  };
}
function Lp(t, n) {
  return function() {
    this[t] = n;
  };
}
function qp(t, n) {
  return function() {
    var e = n.apply(this, arguments);
    e == null ? delete this[t] : this[t] = e;
  };
}
function Yp(t, n) {
  return arguments.length > 1 ? this.each((n == null ? Ip : typeof n == "function" ? qp : Lp)(t, n)) : this.node()[t];
}
function lc(t) {
  return t.trim().split(/^|\s+/);
}
function Uo(t) {
  return t.classList || new hc(t);
}
function hc(t) {
  this._node = t, this._names = lc(t.getAttribute("class") || "");
}
hc.prototype = {
  add: function(t) {
    var n = this._names.indexOf(t);
    n < 0 && (this._names.push(t), this._node.setAttribute("class", this._names.join(" ")));
  },
  remove: function(t) {
    var n = this._names.indexOf(t);
    n >= 0 && (this._names.splice(n, 1), this._node.setAttribute("class", this._names.join(" ")));
  },
  contains: function(t) {
    return this._names.indexOf(t) >= 0;
  }
};
function pc(t, n) {
  for (var e = Uo(t), r = -1, i = n.length; ++r < i; )
    e.add(n[r]);
}
function dc(t, n) {
  for (var e = Uo(t), r = -1, i = n.length; ++r < i; )
    e.remove(n[r]);
}
function Gp(t) {
  return function() {
    pc(this, t);
  };
}
function Wp(t) {
  return function() {
    dc(this, t);
  };
}
function Bp(t, n) {
  return function() {
    (n.apply(this, arguments) ? pc : dc)(this, t);
  };
}
function Hp(t, n) {
  var e = lc(t + "");
  if (arguments.length < 2) {
    for (var r = Uo(this.node()), i = -1, o = e.length; ++i < o; )
      if (!r.contains(e[i]))
        return !1;
    return !0;
  }
  return this.each((typeof n == "function" ? Bp : n ? Gp : Wp)(e, n));
}
function Xp() {
  this.textContent = "";
}
function Up(t) {
  return function() {
    this.textContent = t;
  };
}
function Vp(t) {
  return function() {
    var n = t.apply(this, arguments);
    this.textContent = n ?? "";
  };
}
function Zp(t) {
  return arguments.length ? this.each(t == null ? Xp : (typeof t == "function" ? Vp : Up)(t)) : this.node().textContent;
}
function Kp() {
  this.innerHTML = "";
}
function Jp(t) {
  return function() {
    this.innerHTML = t;
  };
}
function Qp(t) {
  return function() {
    var n = t.apply(this, arguments);
    this.innerHTML = n ?? "";
  };
}
function td(t) {
  return arguments.length ? this.each(t == null ? Kp : (typeof t == "function" ? Qp : Jp)(t)) : this.node().innerHTML;
}
function nd() {
  this.nextSibling && this.parentNode.appendChild(this);
}
function ed() {
  return this.each(nd);
}
function rd() {
  this.previousSibling && this.parentNode.insertBefore(this, this.parentNode.firstChild);
}
function id() {
  return this.each(rd);
}
function od(t) {
  var n = typeof t == "function" ? t : ic(t);
  return this.select(function() {
    return this.appendChild(n.apply(this, arguments));
  });
}
function ad() {
  return null;
}
function ud(t, n) {
  var e = typeof t == "function" ? t : ic(t), r = n == null ? ad : typeof n == "function" ? n : Xo(n);
  return this.select(function() {
    return this.insertBefore(e.apply(this, arguments), r.apply(this, arguments) || null);
  });
}
function sd() {
  var t = this.parentNode;
  t && t.removeChild(this);
}
function cd() {
  return this.each(sd);
}
function fd() {
  var t = this.cloneNode(!1), n = this.parentNode;
  return n ? n.insertBefore(t, this.nextSibling) : t;
}
function ld() {
  var t = this.cloneNode(!0), n = this.parentNode;
  return n ? n.insertBefore(t, this.nextSibling) : t;
}
function hd(t) {
  return this.select(t ? ld : fd);
}
function pd(t) {
  return arguments.length ? this.property("__data__", t) : this.node().__data__;
}
function dd(t) {
  return function(n) {
    t.call(this, n, this.__data__);
  };
}
function gd(t) {
  return t.trim().split(/^|\s+/).map(function(n) {
    var e = "", r = n.indexOf(".");
    return r >= 0 && (e = n.slice(r + 1), n = n.slice(0, r)), { type: n, name: e };
  });
}
function vd(t) {
  return function() {
    var n = this.__on;
    if (n) {
      for (var e = 0, r = -1, i = n.length, o; e < i; ++e)
        o = n[e], (!t.type || o.type === t.type) && o.name === t.name ? this.removeEventListener(o.type, o.listener, o.options) : n[++r] = o;
      ++r ? n.length = r : delete this.__on;
    }
  };
}
function md(t, n, e) {
  return function() {
    var r = this.__on, i, o = dd(n);
    if (r) {
      for (var a = 0, u = r.length; a < u; ++a)
        if ((i = r[a]).type === t.type && i.name === t.name) {
          this.removeEventListener(i.type, i.listener, i.options), this.addEventListener(i.type, i.listener = o, i.options = e), i.value = n;
          return;
        }
    }
    this.addEventListener(t.type, o, e), i = { type: t.type, name: t.name, value: n, listener: o, options: e }, r ? r.push(i) : this.__on = [i];
  };
}
function yd(t, n, e) {
  var r = gd(t + ""), i, o = r.length, a;
  if (arguments.length < 2) {
    var u = this.node().__on;
    if (u) {
      for (var c = 0, f = u.length, s; c < f; ++c)
        for (i = 0, s = u[c]; i < o; ++i)
          if ((a = r[i]).type === s.type && a.name === s.name)
            return s.value;
    }
    return;
  }
  for (u = n ? md : vd, i = 0; i < o; ++i)
    this.each(u(r[i], n, e));
  return this;
}
function gc(t, n, e) {
  var r = fc(t), i = r.CustomEvent;
  typeof i == "function" ? i = new i(n, e) : (i = r.document.createEvent("Event"), e ? (i.initEvent(n, e.bubbles, e.cancelable), i.detail = e.detail) : i.initEvent(n, !1, !1)), t.dispatchEvent(i);
}
function xd(t, n) {
  return function() {
    return gc(this, t, n);
  };
}
function _d(t, n) {
  return function() {
    return gc(this, t, n.apply(this, arguments));
  };
}
function wd(t, n) {
  return this.each((typeof n == "function" ? _d : xd)(t, n));
}
function* bd() {
  for (var t = this._groups, n = 0, e = t.length; n < e; ++n)
    for (var r = t[n], i = 0, o = r.length, a; i < o; ++i)
      (a = r[i]) && (yield a);
}
var vc = [null];
function Rt(t, n) {
  this._groups = t, this._parents = n;
}
function je() {
  return new Rt([[document.documentElement]], vc);
}
function Ed() {
  return this;
}
Rt.prototype = je.prototype = {
  constructor: Rt,
  select: K0,
  selectAll: tp,
  selectChild: ip,
  selectChildren: sp,
  filter: cp,
  data: gp,
  enter: fp,
  exit: vp,
  join: mp,
  merge: yp,
  selection: Ed,
  order: xp,
  sort: _p,
  call: bp,
  nodes: Ep,
  node: Sp,
  size: Mp,
  empty: Np,
  each: $p,
  attr: Op,
  style: Dp,
  property: Yp,
  classed: Hp,
  text: Zp,
  html: td,
  raise: ed,
  lower: id,
  append: od,
  insert: ud,
  remove: cd,
  clone: hd,
  datum: pd,
  on: yd,
  dispatch: wd,
  [Symbol.iterator]: bd
};
function en(t) {
  return typeof t == "string" ? new Rt([[document.querySelector(t)]], [document.documentElement]) : new Rt([[t]], vc);
}
function Sd(t) {
  let n;
  for (; n = t.sourceEvent; )
    t = n;
  return t;
}
function gn(t, n) {
  if (t = Sd(t), n === void 0 && (n = t.currentTarget), n) {
    var e = n.ownerSVGElement || n;
    if (e.createSVGPoint) {
      var r = e.createSVGPoint();
      return r.x = t.clientX, r.y = t.clientY, r = r.matrixTransform(n.getScreenCTM().inverse()), [r.x, r.y];
    }
    if (n.getBoundingClientRect) {
      var i = n.getBoundingClientRect();
      return [t.clientX - i.left - n.clientLeft, t.clientY - i.top - n.clientTop];
    }
  }
  return [t.pageX, t.pageY];
}
function co(t) {
  t.preventDefault(), t.stopImmediatePropagation();
}
function Md(t) {
  var n = t.document.documentElement, e = en(t).on("dragstart.drag", co, !0);
  "onselectstart" in n ? e.on("selectstart.drag", co, !0) : (n.__noselect = n.style.MozUserSelect, n.style.MozUserSelect = "none");
}
function Nd(t, n) {
  var e = t.document.documentElement, r = en(t).on("dragstart.drag", null);
  n && (r.on("click.drag", co, !0), setTimeout(function() {
    r.on("click.drag", null);
  }, 0)), "onselectstart" in e ? r.on("selectstart.drag", null) : (e.style.MozUserSelect = e.__noselect, delete e.__noselect);
}
function Vo(t, n, e) {
  t.prototype = n.prototype = e, e.constructor = t;
}
function mc(t, n) {
  var e = Object.create(t.prototype);
  for (var r in n)
    e[r] = n[r];
  return e;
}
function ze() {
}
var Ne = 0.7, qr = 1 / Ne, In = "\\s*([+-]?\\d+)\\s*", $e = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*", Vt = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*", $d = /^#([0-9a-f]{3,8})$/, Pd = new RegExp("^rgb\\(" + [In, In, In] + "\\)$"), Rd = new RegExp("^rgb\\(" + [Vt, Vt, Vt] + "\\)$"), kd = new RegExp("^rgba\\(" + [In, In, In, $e] + "\\)$"), Cd = new RegExp("^rgba\\(" + [Vt, Vt, Vt, $e] + "\\)$"), Td = new RegExp("^hsl\\(" + [$e, Vt, Vt] + "\\)$"), Ad = new RegExp("^hsla\\(" + [$e, Vt, Vt, $e] + "\\)$"), Su = {
  aliceblue: 15792383,
  antiquewhite: 16444375,
  aqua: 65535,
  aquamarine: 8388564,
  azure: 15794175,
  beige: 16119260,
  bisque: 16770244,
  black: 0,
  blanchedalmond: 16772045,
  blue: 255,
  blueviolet: 9055202,
  brown: 10824234,
  burlywood: 14596231,
  cadetblue: 6266528,
  chartreuse: 8388352,
  chocolate: 13789470,
  coral: 16744272,
  cornflowerblue: 6591981,
  cornsilk: 16775388,
  crimson: 14423100,
  cyan: 65535,
  darkblue: 139,
  darkcyan: 35723,
  darkgoldenrod: 12092939,
  darkgray: 11119017,
  darkgreen: 25600,
  darkgrey: 11119017,
  darkkhaki: 12433259,
  darkmagenta: 9109643,
  darkolivegreen: 5597999,
  darkorange: 16747520,
  darkorchid: 10040012,
  darkred: 9109504,
  darksalmon: 15308410,
  darkseagreen: 9419919,
  darkslateblue: 4734347,
  darkslategray: 3100495,
  darkslategrey: 3100495,
  darkturquoise: 52945,
  darkviolet: 9699539,
  deeppink: 16716947,
  deepskyblue: 49151,
  dimgray: 6908265,
  dimgrey: 6908265,
  dodgerblue: 2003199,
  firebrick: 11674146,
  floralwhite: 16775920,
  forestgreen: 2263842,
  fuchsia: 16711935,
  gainsboro: 14474460,
  ghostwhite: 16316671,
  gold: 16766720,
  goldenrod: 14329120,
  gray: 8421504,
  green: 32768,
  greenyellow: 11403055,
  grey: 8421504,
  honeydew: 15794160,
  hotpink: 16738740,
  indianred: 13458524,
  indigo: 4915330,
  ivory: 16777200,
  khaki: 15787660,
  lavender: 15132410,
  lavenderblush: 16773365,
  lawngreen: 8190976,
  lemonchiffon: 16775885,
  lightblue: 11393254,
  lightcoral: 15761536,
  lightcyan: 14745599,
  lightgoldenrodyellow: 16448210,
  lightgray: 13882323,
  lightgreen: 9498256,
  lightgrey: 13882323,
  lightpink: 16758465,
  lightsalmon: 16752762,
  lightseagreen: 2142890,
  lightskyblue: 8900346,
  lightslategray: 7833753,
  lightslategrey: 7833753,
  lightsteelblue: 11584734,
  lightyellow: 16777184,
  lime: 65280,
  limegreen: 3329330,
  linen: 16445670,
  magenta: 16711935,
  maroon: 8388608,
  mediumaquamarine: 6737322,
  mediumblue: 205,
  mediumorchid: 12211667,
  mediumpurple: 9662683,
  mediumseagreen: 3978097,
  mediumslateblue: 8087790,
  mediumspringgreen: 64154,
  mediumturquoise: 4772300,
  mediumvioletred: 13047173,
  midnightblue: 1644912,
  mintcream: 16121850,
  mistyrose: 16770273,
  moccasin: 16770229,
  navajowhite: 16768685,
  navy: 128,
  oldlace: 16643558,
  olive: 8421376,
  olivedrab: 7048739,
  orange: 16753920,
  orangered: 16729344,
  orchid: 14315734,
  palegoldenrod: 15657130,
  palegreen: 10025880,
  paleturquoise: 11529966,
  palevioletred: 14381203,
  papayawhip: 16773077,
  peachpuff: 16767673,
  peru: 13468991,
  pink: 16761035,
  plum: 14524637,
  powderblue: 11591910,
  purple: 8388736,
  rebeccapurple: 6697881,
  red: 16711680,
  rosybrown: 12357519,
  royalblue: 4286945,
  saddlebrown: 9127187,
  salmon: 16416882,
  sandybrown: 16032864,
  seagreen: 3050327,
  seashell: 16774638,
  sienna: 10506797,
  silver: 12632256,
  skyblue: 8900331,
  slateblue: 6970061,
  slategray: 7372944,
  slategrey: 7372944,
  snow: 16775930,
  springgreen: 65407,
  steelblue: 4620980,
  tan: 13808780,
  teal: 32896,
  thistle: 14204888,
  tomato: 16737095,
  turquoise: 4251856,
  violet: 15631086,
  wheat: 16113331,
  white: 16777215,
  whitesmoke: 16119285,
  yellow: 16776960,
  yellowgreen: 10145074
};
Vo(ze, Pe, {
  copy: function(t) {
    return Object.assign(new this.constructor(), this, t);
  },
  displayable: function() {
    return this.rgb().displayable();
  },
  hex: Mu,
  // Deprecated! Use color.formatHex.
  formatHex: Mu,
  formatHsl: Od,
  formatRgb: Nu,
  toString: Nu
});
function Mu() {
  return this.rgb().formatHex();
}
function Od() {
  return yc(this).formatHsl();
}
function Nu() {
  return this.rgb().formatRgb();
}
function Pe(t) {
  var n, e;
  return t = (t + "").trim().toLowerCase(), (n = $d.exec(t)) ? (e = n[1].length, n = parseInt(n[1], 16), e === 6 ? $u(n) : e === 3 ? new Ot(n >> 8 & 15 | n >> 4 & 240, n >> 4 & 15 | n & 240, (n & 15) << 4 | n & 15, 1) : e === 8 ? Ke(n >> 24 & 255, n >> 16 & 255, n >> 8 & 255, (n & 255) / 255) : e === 4 ? Ke(n >> 12 & 15 | n >> 8 & 240, n >> 8 & 15 | n >> 4 & 240, n >> 4 & 15 | n & 240, ((n & 15) << 4 | n & 15) / 255) : null) : (n = Pd.exec(t)) ? new Ot(n[1], n[2], n[3], 1) : (n = Rd.exec(t)) ? new Ot(n[1] * 255 / 100, n[2] * 255 / 100, n[3] * 255 / 100, 1) : (n = kd.exec(t)) ? Ke(n[1], n[2], n[3], n[4]) : (n = Cd.exec(t)) ? Ke(n[1] * 255 / 100, n[2] * 255 / 100, n[3] * 255 / 100, n[4]) : (n = Td.exec(t)) ? ku(n[1], n[2] / 100, n[3] / 100, 1) : (n = Ad.exec(t)) ? ku(n[1], n[2] / 100, n[3] / 100, n[4]) : Su.hasOwnProperty(t) ? $u(Su[t]) : t === "transparent" ? new Ot(NaN, NaN, NaN, 0) : null;
}
function $u(t) {
  return new Ot(t >> 16 & 255, t >> 8 & 255, t & 255, 1);
}
function Ke(t, n, e, r) {
  return r <= 0 && (t = n = e = NaN), new Ot(t, n, e, r);
}
function jd(t) {
  return t instanceof ze || (t = Pe(t)), t ? (t = t.rgb(), new Ot(t.r, t.g, t.b, t.opacity)) : new Ot();
}
function fo(t, n, e, r) {
  return arguments.length === 1 ? jd(t) : new Ot(t, n, e, r ?? 1);
}
function Ot(t, n, e, r) {
  this.r = +t, this.g = +n, this.b = +e, this.opacity = +r;
}
Vo(Ot, fo, mc(ze, {
  brighter: function(t) {
    return t = t == null ? qr : Math.pow(qr, t), new Ot(this.r * t, this.g * t, this.b * t, this.opacity);
  },
  darker: function(t) {
    return t = t == null ? Ne : Math.pow(Ne, t), new Ot(this.r * t, this.g * t, this.b * t, this.opacity);
  },
  rgb: function() {
    return this;
  },
  displayable: function() {
    return -0.5 <= this.r && this.r < 255.5 && -0.5 <= this.g && this.g < 255.5 && -0.5 <= this.b && this.b < 255.5 && 0 <= this.opacity && this.opacity <= 1;
  },
  hex: Pu,
  // Deprecated! Use color.formatHex.
  formatHex: Pu,
  formatRgb: Ru,
  toString: Ru
}));
function Pu() {
  return "#" + _i(this.r) + _i(this.g) + _i(this.b);
}
function Ru() {
  var t = this.opacity;
  return t = isNaN(t) ? 1 : Math.max(0, Math.min(1, t)), (t === 1 ? "rgb(" : "rgba(") + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", " + Math.max(0, Math.min(255, Math.round(this.b) || 0)) + (t === 1 ? ")" : ", " + t + ")");
}
function _i(t) {
  return t = Math.max(0, Math.min(255, Math.round(t) || 0)), (t < 16 ? "0" : "") + t.toString(16);
}
function ku(t, n, e, r) {
  return r <= 0 ? t = n = e = NaN : e <= 0 || e >= 1 ? t = n = NaN : n <= 0 && (t = NaN), new Xt(t, n, e, r);
}
function yc(t) {
  if (t instanceof Xt)
    return new Xt(t.h, t.s, t.l, t.opacity);
  if (t instanceof ze || (t = Pe(t)), !t)
    return new Xt();
  if (t instanceof Xt)
    return t;
  t = t.rgb();
  var n = t.r / 255, e = t.g / 255, r = t.b / 255, i = Math.min(n, e, r), o = Math.max(n, e, r), a = NaN, u = o - i, c = (o + i) / 2;
  return u ? (n === o ? a = (e - r) / u + (e < r) * 6 : e === o ? a = (r - n) / u + 2 : a = (n - e) / u + 4, u /= c < 0.5 ? o + i : 2 - o - i, a *= 60) : u = c > 0 && c < 1 ? 0 : a, new Xt(a, u, c, t.opacity);
}
function zd(t, n, e, r) {
  return arguments.length === 1 ? yc(t) : new Xt(t, n, e, r ?? 1);
}
function Xt(t, n, e, r) {
  this.h = +t, this.s = +n, this.l = +e, this.opacity = +r;
}
Vo(Xt, zd, mc(ze, {
  brighter: function(t) {
    return t = t == null ? qr : Math.pow(qr, t), new Xt(this.h, this.s, this.l * t, this.opacity);
  },
  darker: function(t) {
    return t = t == null ? Ne : Math.pow(Ne, t), new Xt(this.h, this.s, this.l * t, this.opacity);
  },
  rgb: function() {
    var t = this.h % 360 + (this.h < 0) * 360, n = isNaN(t) || isNaN(this.s) ? 0 : this.s, e = this.l, r = e + (e < 0.5 ? e : 1 - e) * n, i = 2 * e - r;
    return new Ot(
      wi(t >= 240 ? t - 240 : t + 120, i, r),
      wi(t, i, r),
      wi(t < 120 ? t + 240 : t - 120, i, r),
      this.opacity
    );
  },
  displayable: function() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && 0 <= this.l && this.l <= 1 && 0 <= this.opacity && this.opacity <= 1;
  },
  formatHsl: function() {
    var t = this.opacity;
    return t = isNaN(t) ? 1 : Math.max(0, Math.min(1, t)), (t === 1 ? "hsl(" : "hsla(") + (this.h || 0) + ", " + (this.s || 0) * 100 + "%, " + (this.l || 0) * 100 + "%" + (t === 1 ? ")" : ", " + t + ")");
  }
}));
function wi(t, n, e) {
  return (t < 60 ? n + (e - n) * t / 60 : t < 180 ? e : t < 240 ? n + (e - n) * (240 - t) / 60 : n) * 255;
}
const xc = (t) => () => t;
function Fd(t, n) {
  return function(e) {
    return t + e * n;
  };
}
function Dd(t, n, e) {
  return t = Math.pow(t, e), n = Math.pow(n, e) - t, e = 1 / e, function(r) {
    return Math.pow(t + r * n, e);
  };
}
function Id(t) {
  return (t = +t) == 1 ? _c : function(n, e) {
    return e - n ? Dd(n, e, t) : xc(isNaN(n) ? e : n);
  };
}
function _c(t, n) {
  var e = n - t;
  return e ? Fd(t, e) : xc(isNaN(t) ? n : t);
}
const Cu = function t(n) {
  var e = Id(n);
  function r(i, o) {
    var a = e((i = fo(i)).r, (o = fo(o)).r), u = e(i.g, o.g), c = e(i.b, o.b), f = _c(i.opacity, o.opacity);
    return function(s) {
      return i.r = a(s), i.g = u(s), i.b = c(s), i.opacity = f(s), i + "";
    };
  }
  return r.gamma = t, r;
}(1);
function ln(t, n) {
  return t = +t, n = +n, function(e) {
    return t * (1 - e) + n * e;
  };
}
var lo = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, bi = new RegExp(lo.source, "g");
function Ld(t) {
  return function() {
    return t;
  };
}
function qd(t) {
  return function(n) {
    return t(n) + "";
  };
}
function Yd(t, n) {
  var e = lo.lastIndex = bi.lastIndex = 0, r, i, o, a = -1, u = [], c = [];
  for (t = t + "", n = n + ""; (r = lo.exec(t)) && (i = bi.exec(n)); )
    (o = i.index) > e && (o = n.slice(e, o), u[a] ? u[a] += o : u[++a] = o), (r = r[0]) === (i = i[0]) ? u[a] ? u[a] += i : u[++a] = i : (u[++a] = null, c.push({ i: a, x: ln(r, i) })), e = bi.lastIndex;
  return e < n.length && (o = n.slice(e), u[a] ? u[a] += o : u[++a] = o), u.length < 2 ? c[0] ? qd(c[0].x) : Ld(n) : (n = c.length, function(f) {
    for (var s = 0, l; s < n; ++s)
      u[(l = c[s]).i] = l.x(f);
    return u.join("");
  });
}
var Tu = 180 / Math.PI, ho = {
  translateX: 0,
  translateY: 0,
  rotate: 0,
  skewX: 0,
  scaleX: 1,
  scaleY: 1
};
function wc(t, n, e, r, i, o) {
  var a, u, c;
  return (a = Math.sqrt(t * t + n * n)) && (t /= a, n /= a), (c = t * e + n * r) && (e -= t * c, r -= n * c), (u = Math.sqrt(e * e + r * r)) && (e /= u, r /= u, c /= u), t * r < n * e && (t = -t, n = -n, c = -c, a = -a), {
    translateX: i,
    translateY: o,
    rotate: Math.atan2(n, t) * Tu,
    skewX: Math.atan(c) * Tu,
    scaleX: a,
    scaleY: u
  };
}
var Je;
function Gd(t) {
  const n = new (typeof DOMMatrix == "function" ? DOMMatrix : WebKitCSSMatrix)(t + "");
  return n.isIdentity ? ho : wc(n.a, n.b, n.c, n.d, n.e, n.f);
}
function Wd(t) {
  return t == null || (Je || (Je = document.createElementNS("http://www.w3.org/2000/svg", "g")), Je.setAttribute("transform", t), !(t = Je.transform.baseVal.consolidate())) ? ho : (t = t.matrix, wc(t.a, t.b, t.c, t.d, t.e, t.f));
}
function bc(t, n, e, r) {
  function i(f) {
    return f.length ? f.pop() + " " : "";
  }
  function o(f, s, l, h, p, g) {
    if (f !== l || s !== h) {
      var w = p.push("translate(", null, n, null, e);
      g.push({ i: w - 4, x: ln(f, l) }, { i: w - 2, x: ln(s, h) });
    } else
      (l || h) && p.push("translate(" + l + n + h + e);
  }
  function a(f, s, l, h) {
    f !== s ? (f - s > 180 ? s += 360 : s - f > 180 && (f += 360), h.push({ i: l.push(i(l) + "rotate(", null, r) - 2, x: ln(f, s) })) : s && l.push(i(l) + "rotate(" + s + r);
  }
  function u(f, s, l, h) {
    f !== s ? h.push({ i: l.push(i(l) + "skewX(", null, r) - 2, x: ln(f, s) }) : s && l.push(i(l) + "skewX(" + s + r);
  }
  function c(f, s, l, h, p, g) {
    if (f !== l || s !== h) {
      var w = p.push(i(p) + "scale(", null, ",", null, ")");
      g.push({ i: w - 4, x: ln(f, l) }, { i: w - 2, x: ln(s, h) });
    } else
      (l !== 1 || h !== 1) && p.push(i(p) + "scale(" + l + "," + h + ")");
  }
  return function(f, s) {
    var l = [], h = [];
    return f = t(f), s = t(s), o(f.translateX, f.translateY, s.translateX, s.translateY, l, h), a(f.rotate, s.rotate, l, h), u(f.skewX, s.skewX, l, h), c(f.scaleX, f.scaleY, s.scaleX, s.scaleY, l, h), f = s = null, function(p) {
      for (var g = -1, w = h.length, b; ++g < w; )
        l[(b = h[g]).i] = b.x(p);
      return l.join("");
    };
  };
}
var Bd = bc(Gd, "px, ", "px)", "deg)"), Hd = bc(Wd, ", ", ")", ")"), Xd = 1e-12;
function Au(t) {
  return ((t = Math.exp(t)) + 1 / t) / 2;
}
function Ud(t) {
  return ((t = Math.exp(t)) - 1 / t) / 2;
}
function Vd(t) {
  return ((t = Math.exp(2 * t)) - 1) / (t + 1);
}
const Zd = function t(n, e, r) {
  function i(o, a) {
    var u = o[0], c = o[1], f = o[2], s = a[0], l = a[1], h = a[2], p = s - u, g = l - c, w = p * p + g * g, b, _;
    if (w < Xd)
      _ = Math.log(h / f) / n, b = function(j) {
        return [
          u + j * p,
          c + j * g,
          f * Math.exp(n * j * _)
        ];
      };
    else {
      var S = Math.sqrt(w), y = (h * h - f * f + r * w) / (2 * f * e * S), E = (h * h - f * f - r * w) / (2 * h * e * S), M = Math.log(Math.sqrt(y * y + 1) - y), R = Math.log(Math.sqrt(E * E + 1) - E);
      _ = (R - M) / n, b = function(j) {
        var I = j * _, q = Au(M), W = f / (e * S) * (q * Vd(n * I + M) - Ud(M));
        return [
          u + W * p,
          c + W * g,
          f * q / Au(n * I + M)
        ];
      };
    }
    return b.duration = _ * 1e3 * n / Math.SQRT2, b;
  }
  return i.rho = function(o) {
    var a = Math.max(1e-3, +o), u = a * a, c = u * u;
    return t(a, u, c);
  }, i;
}(Math.SQRT2, 2, 4);
var Xn = 0, se = 0, te = 0, Ec = 1e3, Yr, ce, Gr = 0, $n = 0, ni = 0, Re = typeof performance == "object" && performance.now ? performance : Date, Sc = typeof window == "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(t) {
  setTimeout(t, 17);
};
function Zo() {
  return $n || (Sc(Kd), $n = Re.now() + ni);
}
function Kd() {
  $n = 0;
}
function Wr() {
  this._call = this._time = this._next = null;
}
Wr.prototype = Mc.prototype = {
  constructor: Wr,
  restart: function(t, n, e) {
    if (typeof t != "function")
      throw new TypeError("callback is not a function");
    e = (e == null ? Zo() : +e) + (n == null ? 0 : +n), !this._next && ce !== this && (ce ? ce._next = this : Yr = this, ce = this), this._call = t, this._time = e, po();
  },
  stop: function() {
    this._call && (this._call = null, this._time = 1 / 0, po());
  }
};
function Mc(t, n, e) {
  var r = new Wr();
  return r.restart(t, n, e), r;
}
function Jd() {
  Zo(), ++Xn;
  for (var t = Yr, n; t; )
    (n = $n - t._time) >= 0 && t._call.call(null, n), t = t._next;
  --Xn;
}
function Ou() {
  $n = (Gr = Re.now()) + ni, Xn = se = 0;
  try {
    Jd();
  } finally {
    Xn = 0, tg(), $n = 0;
  }
}
function Qd() {
  var t = Re.now(), n = t - Gr;
  n > Ec && (ni -= n, Gr = t);
}
function tg() {
  for (var t, n = Yr, e, r = 1 / 0; n; )
    n._call ? (r > n._time && (r = n._time), t = n, n = n._next) : (e = n._next, n._next = null, n = t ? t._next = e : Yr = e);
  ce = t, po(r);
}
function po(t) {
  if (!Xn) {
    se && (se = clearTimeout(se));
    var n = t - $n;
    n > 24 ? (t < 1 / 0 && (se = setTimeout(Ou, t - Re.now() - ni)), te && (te = clearInterval(te))) : (te || (Gr = Re.now(), te = setInterval(Qd, Ec)), Xn = 1, Sc(Ou));
  }
}
function ju(t, n, e) {
  var r = new Wr();
  return n = n == null ? 0 : +n, r.restart((i) => {
    r.stop(), t(i + n);
  }, n, e), r;
}
var ng = Ho("start", "end", "cancel", "interrupt"), eg = [], Nc = 0, zu = 1, go = 2, or = 3, Fu = 4, vo = 5, ar = 6;
function ei(t, n, e, r, i, o) {
  var a = t.__transition;
  if (!a)
    t.__transition = {};
  else if (e in a)
    return;
  rg(t, e, {
    name: n,
    index: r,
    // For context during callback.
    group: i,
    // For context during callback.
    on: ng,
    tween: eg,
    time: o.time,
    delay: o.delay,
    duration: o.duration,
    ease: o.ease,
    timer: null,
    state: Nc
  });
}
function Ko(t, n) {
  var e = Wt(t, n);
  if (e.state > Nc)
    throw new Error("too late; already scheduled");
  return e;
}
function Jt(t, n) {
  var e = Wt(t, n);
  if (e.state > or)
    throw new Error("too late; already running");
  return e;
}
function Wt(t, n) {
  var e = t.__transition;
  if (!e || !(e = e[n]))
    throw new Error("transition not found");
  return e;
}
function rg(t, n, e) {
  var r = t.__transition, i;
  r[n] = e, e.timer = Mc(o, 0, e.time);
  function o(f) {
    e.state = zu, e.timer.restart(a, e.delay, e.time), e.delay <= f && a(f - e.delay);
  }
  function a(f) {
    var s, l, h, p;
    if (e.state !== zu)
      return c();
    for (s in r)
      if (p = r[s], p.name === e.name) {
        if (p.state === or)
          return ju(a);
        p.state === Fu ? (p.state = ar, p.timer.stop(), p.on.call("interrupt", t, t.__data__, p.index, p.group), delete r[s]) : +s < n && (p.state = ar, p.timer.stop(), p.on.call("cancel", t, t.__data__, p.index, p.group), delete r[s]);
      }
    if (ju(function() {
      e.state === or && (e.state = Fu, e.timer.restart(u, e.delay, e.time), u(f));
    }), e.state = go, e.on.call("start", t, t.__data__, e.index, e.group), e.state === go) {
      for (e.state = or, i = new Array(h = e.tween.length), s = 0, l = -1; s < h; ++s)
        (p = e.tween[s].value.call(t, t.__data__, e.index, e.group)) && (i[++l] = p);
      i.length = l + 1;
    }
  }
  function u(f) {
    for (var s = f < e.duration ? e.ease.call(null, f / e.duration) : (e.timer.restart(c), e.state = vo, 1), l = -1, h = i.length; ++l < h; )
      i[l].call(t, s);
    e.state === vo && (e.on.call("end", t, t.__data__, e.index, e.group), c());
  }
  function c() {
    e.state = ar, e.timer.stop(), delete r[n];
    for (var f in r)
      return;
    delete t.__transition;
  }
}
function ur(t, n) {
  var e = t.__transition, r, i, o = !0, a;
  if (e) {
    n = n == null ? null : n + "";
    for (a in e) {
      if ((r = e[a]).name !== n) {
        o = !1;
        continue;
      }
      i = r.state > go && r.state < vo, r.state = ar, r.timer.stop(), r.on.call(i ? "interrupt" : "cancel", t, t.__data__, r.index, r.group), delete e[a];
    }
    o && delete t.__transition;
  }
}
function ig(t) {
  return this.each(function() {
    ur(this, t);
  });
}
function og(t, n) {
  var e, r;
  return function() {
    var i = Jt(this, t), o = i.tween;
    if (o !== e) {
      r = e = o;
      for (var a = 0, u = r.length; a < u; ++a)
        if (r[a].name === n) {
          r = r.slice(), r.splice(a, 1);
          break;
        }
    }
    i.tween = r;
  };
}
function ag(t, n, e) {
  var r, i;
  if (typeof e != "function")
    throw new Error();
  return function() {
    var o = Jt(this, t), a = o.tween;
    if (a !== r) {
      i = (r = a).slice();
      for (var u = { name: n, value: e }, c = 0, f = i.length; c < f; ++c)
        if (i[c].name === n) {
          i[c] = u;
          break;
        }
      c === f && i.push(u);
    }
    o.tween = i;
  };
}
function ug(t, n) {
  var e = this._id;
  if (t += "", arguments.length < 2) {
    for (var r = Wt(this.node(), e).tween, i = 0, o = r.length, a; i < o; ++i)
      if ((a = r[i]).name === t)
        return a.value;
    return null;
  }
  return this.each((n == null ? og : ag)(e, t, n));
}
function Jo(t, n, e) {
  var r = t._id;
  return t.each(function() {
    var i = Jt(this, r);
    (i.value || (i.value = {}))[n] = e.apply(this, arguments);
  }), function(i) {
    return Wt(i, r).value[n];
  };
}
function $c(t, n) {
  var e;
  return (typeof n == "number" ? ln : n instanceof Pe ? Cu : (e = Pe(n)) ? (n = e, Cu) : Yd)(t, n);
}
function sg(t) {
  return function() {
    this.removeAttribute(t);
  };
}
function cg(t) {
  return function() {
    this.removeAttributeNS(t.space, t.local);
  };
}
function fg(t, n, e) {
  var r, i = e + "", o;
  return function() {
    var a = this.getAttribute(t);
    return a === i ? null : a === r ? o : o = n(r = a, e);
  };
}
function lg(t, n, e) {
  var r, i = e + "", o;
  return function() {
    var a = this.getAttributeNS(t.space, t.local);
    return a === i ? null : a === r ? o : o = n(r = a, e);
  };
}
function hg(t, n, e) {
  var r, i, o;
  return function() {
    var a, u = e(this), c;
    return u == null ? void this.removeAttribute(t) : (a = this.getAttribute(t), c = u + "", a === c ? null : a === r && c === i ? o : (i = c, o = n(r = a, u)));
  };
}
function pg(t, n, e) {
  var r, i, o;
  return function() {
    var a, u = e(this), c;
    return u == null ? void this.removeAttributeNS(t.space, t.local) : (a = this.getAttributeNS(t.space, t.local), c = u + "", a === c ? null : a === r && c === i ? o : (i = c, o = n(r = a, u)));
  };
}
function dg(t, n) {
  var e = ti(t), r = e === "transform" ? Hd : $c;
  return this.attrTween(t, typeof n == "function" ? (e.local ? pg : hg)(e, r, Jo(this, "attr." + t, n)) : n == null ? (e.local ? cg : sg)(e) : (e.local ? lg : fg)(e, r, n));
}
function gg(t, n) {
  return function(e) {
    this.setAttribute(t, n.call(this, e));
  };
}
function vg(t, n) {
  return function(e) {
    this.setAttributeNS(t.space, t.local, n.call(this, e));
  };
}
function mg(t, n) {
  var e, r;
  function i() {
    var o = n.apply(this, arguments);
    return o !== r && (e = (r = o) && vg(t, o)), e;
  }
  return i._value = n, i;
}
function yg(t, n) {
  var e, r;
  function i() {
    var o = n.apply(this, arguments);
    return o !== r && (e = (r = o) && gg(t, o)), e;
  }
  return i._value = n, i;
}
function xg(t, n) {
  var e = "attr." + t;
  if (arguments.length < 2)
    return (e = this.tween(e)) && e._value;
  if (n == null)
    return this.tween(e, null);
  if (typeof n != "function")
    throw new Error();
  var r = ti(t);
  return this.tween(e, (r.local ? mg : yg)(r, n));
}
function _g(t, n) {
  return function() {
    Ko(this, t).delay = +n.apply(this, arguments);
  };
}
function wg(t, n) {
  return n = +n, function() {
    Ko(this, t).delay = n;
  };
}
function bg(t) {
  var n = this._id;
  return arguments.length ? this.each((typeof t == "function" ? _g : wg)(n, t)) : Wt(this.node(), n).delay;
}
function Eg(t, n) {
  return function() {
    Jt(this, t).duration = +n.apply(this, arguments);
  };
}
function Sg(t, n) {
  return n = +n, function() {
    Jt(this, t).duration = n;
  };
}
function Mg(t) {
  var n = this._id;
  return arguments.length ? this.each((typeof t == "function" ? Eg : Sg)(n, t)) : Wt(this.node(), n).duration;
}
function Ng(t, n) {
  if (typeof n != "function")
    throw new Error();
  return function() {
    Jt(this, t).ease = n;
  };
}
function $g(t) {
  var n = this._id;
  return arguments.length ? this.each(Ng(n, t)) : Wt(this.node(), n).ease;
}
function Pg(t, n) {
  return function() {
    var e = n.apply(this, arguments);
    if (typeof e != "function")
      throw new Error();
    Jt(this, t).ease = e;
  };
}
function Rg(t) {
  if (typeof t != "function")
    throw new Error();
  return this.each(Pg(this._id, t));
}
function kg(t) {
  typeof t != "function" && (t = uc(t));
  for (var n = this._groups, e = n.length, r = new Array(e), i = 0; i < e; ++i)
    for (var o = n[i], a = o.length, u = r[i] = [], c, f = 0; f < a; ++f)
      (c = o[f]) && t.call(c, c.__data__, f, o) && u.push(c);
  return new un(r, this._parents, this._name, this._id);
}
function Cg(t) {
  if (t._id !== this._id)
    throw new Error();
  for (var n = this._groups, e = t._groups, r = n.length, i = e.length, o = Math.min(r, i), a = new Array(r), u = 0; u < o; ++u)
    for (var c = n[u], f = e[u], s = c.length, l = a[u] = new Array(s), h, p = 0; p < s; ++p)
      (h = c[p] || f[p]) && (l[p] = h);
  for (; u < r; ++u)
    a[u] = n[u];
  return new un(a, this._parents, this._name, this._id);
}
function Tg(t) {
  return (t + "").trim().split(/^|\s+/).every(function(n) {
    var e = n.indexOf(".");
    return e >= 0 && (n = n.slice(0, e)), !n || n === "start";
  });
}
function Ag(t, n, e) {
  var r, i, o = Tg(n) ? Ko : Jt;
  return function() {
    var a = o(this, t), u = a.on;
    u !== r && (i = (r = u).copy()).on(n, e), a.on = i;
  };
}
function Og(t, n) {
  var e = this._id;
  return arguments.length < 2 ? Wt(this.node(), e).on.on(t) : this.each(Ag(e, t, n));
}
function jg(t) {
  return function() {
    var n = this.parentNode;
    for (var e in this.__transition)
      if (+e !== t)
        return;
    n && n.removeChild(this);
  };
}
function zg() {
  return this.on("end.remove", jg(this._id));
}
function Fg(t) {
  var n = this._name, e = this._id;
  typeof t != "function" && (t = Xo(t));
  for (var r = this._groups, i = r.length, o = new Array(i), a = 0; a < i; ++a)
    for (var u = r[a], c = u.length, f = o[a] = new Array(c), s, l, h = 0; h < c; ++h)
      (s = u[h]) && (l = t.call(s, s.__data__, h, u)) && ("__data__" in s && (l.__data__ = s.__data__), f[h] = l, ei(f[h], n, e, h, f, Wt(s, e)));
  return new un(o, this._parents, n, e);
}
function Dg(t) {
  var n = this._name, e = this._id;
  typeof t != "function" && (t = ac(t));
  for (var r = this._groups, i = r.length, o = [], a = [], u = 0; u < i; ++u)
    for (var c = r[u], f = c.length, s, l = 0; l < f; ++l)
      if (s = c[l]) {
        for (var h = t.call(s, s.__data__, l, c), p, g = Wt(s, e), w = 0, b = h.length; w < b; ++w)
          (p = h[w]) && ei(p, n, e, w, h, g);
        o.push(h), a.push(s);
      }
  return new un(o, a, n, e);
}
var Ig = je.prototype.constructor;
function Lg() {
  return new Ig(this._groups, this._parents);
}
function qg(t, n) {
  var e, r, i;
  return function() {
    var o = Hn(this, t), a = (this.style.removeProperty(t), Hn(this, t));
    return o === a ? null : o === e && a === r ? i : i = n(e = o, r = a);
  };
}
function Pc(t) {
  return function() {
    this.style.removeProperty(t);
  };
}
function Yg(t, n, e) {
  var r, i = e + "", o;
  return function() {
    var a = Hn(this, t);
    return a === i ? null : a === r ? o : o = n(r = a, e);
  };
}
function Gg(t, n, e) {
  var r, i, o;
  return function() {
    var a = Hn(this, t), u = e(this), c = u + "";
    return u == null && (c = u = (this.style.removeProperty(t), Hn(this, t))), a === c ? null : a === r && c === i ? o : (i = c, o = n(r = a, u));
  };
}
function Wg(t, n) {
  var e, r, i, o = "style." + n, a = "end." + o, u;
  return function() {
    var c = Jt(this, t), f = c.on, s = c.value[o] == null ? u || (u = Pc(n)) : void 0;
    (f !== e || i !== s) && (r = (e = f).copy()).on(a, i = s), c.on = r;
  };
}
function Bg(t, n, e) {
  var r = (t += "") == "transform" ? Bd : $c;
  return n == null ? this.styleTween(t, qg(t, r)).on("end.style." + t, Pc(t)) : typeof n == "function" ? this.styleTween(t, Gg(t, r, Jo(this, "style." + t, n))).each(Wg(this._id, t)) : this.styleTween(t, Yg(t, r, n), e).on("end.style." + t, null);
}
function Hg(t, n, e) {
  return function(r) {
    this.style.setProperty(t, n.call(this, r), e);
  };
}
function Xg(t, n, e) {
  var r, i;
  function o() {
    var a = n.apply(this, arguments);
    return a !== i && (r = (i = a) && Hg(t, a, e)), r;
  }
  return o._value = n, o;
}
function Ug(t, n, e) {
  var r = "style." + (t += "");
  if (arguments.length < 2)
    return (r = this.tween(r)) && r._value;
  if (n == null)
    return this.tween(r, null);
  if (typeof n != "function")
    throw new Error();
  return this.tween(r, Xg(t, n, e ?? ""));
}
function Vg(t) {
  return function() {
    this.textContent = t;
  };
}
function Zg(t) {
  return function() {
    var n = t(this);
    this.textContent = n ?? "";
  };
}
function Kg(t) {
  return this.tween("text", typeof t == "function" ? Zg(Jo(this, "text", t)) : Vg(t == null ? "" : t + ""));
}
function Jg(t) {
  return function(n) {
    this.textContent = t.call(this, n);
  };
}
function Qg(t) {
  var n, e;
  function r() {
    var i = t.apply(this, arguments);
    return i !== e && (n = (e = i) && Jg(i)), n;
  }
  return r._value = t, r;
}
function tv(t) {
  var n = "text";
  if (arguments.length < 1)
    return (n = this.tween(n)) && n._value;
  if (t == null)
    return this.tween(n, null);
  if (typeof t != "function")
    throw new Error();
  return this.tween(n, Qg(t));
}
function nv() {
  for (var t = this._name, n = this._id, e = Rc(), r = this._groups, i = r.length, o = 0; o < i; ++o)
    for (var a = r[o], u = a.length, c, f = 0; f < u; ++f)
      if (c = a[f]) {
        var s = Wt(c, n);
        ei(c, t, e, f, a, {
          time: s.time + s.delay + s.duration,
          delay: 0,
          duration: s.duration,
          ease: s.ease
        });
      }
  return new un(r, this._parents, t, e);
}
function ev() {
  var t, n, e = this, r = e._id, i = e.size();
  return new Promise(function(o, a) {
    var u = { value: a }, c = { value: function() {
      --i === 0 && o();
    } };
    e.each(function() {
      var f = Jt(this, r), s = f.on;
      s !== t && (n = (t = s).copy(), n._.cancel.push(u), n._.interrupt.push(u), n._.end.push(c)), f.on = n;
    }), i === 0 && o();
  });
}
var rv = 0;
function un(t, n, e, r) {
  this._groups = t, this._parents = n, this._name = e, this._id = r;
}
function Rc() {
  return ++rv;
}
var vn = je.prototype;
un.prototype = {
  constructor: un,
  select: Fg,
  selectAll: Dg,
  filter: kg,
  merge: Cg,
  selection: Lg,
  transition: nv,
  call: vn.call,
  nodes: vn.nodes,
  node: vn.node,
  size: vn.size,
  empty: vn.empty,
  each: vn.each,
  on: Og,
  attr: dg,
  attrTween: xg,
  style: Bg,
  styleTween: Ug,
  text: Kg,
  textTween: tv,
  remove: zg,
  tween: ug,
  delay: bg,
  duration: Mg,
  ease: $g,
  easeVarying: Rg,
  end: ev,
  [Symbol.iterator]: vn[Symbol.iterator]
};
function iv(t) {
  return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
}
var ov = {
  time: null,
  // Set on use.
  delay: 0,
  duration: 250,
  ease: iv
};
function av(t, n) {
  for (var e; !(e = t.__transition) || !(e = e[n]); )
    if (!(t = t.parentNode))
      throw new Error(`transition ${n} not found`);
  return e;
}
function uv(t) {
  var n, e;
  t instanceof un ? (n = t._id, t = t._name) : (n = Rc(), (e = ov).time = Zo(), t = t == null ? null : t + "");
  for (var r = this._groups, i = r.length, o = 0; o < i; ++o)
    for (var a = r[o], u = a.length, c, f = 0; f < u; ++f)
      (c = a[f]) && ei(c, t, n, f, a, e || av(c, n));
  return new un(r, this._parents, t, n);
}
je.prototype.interrupt = ig;
je.prototype.transition = uv;
const Qe = (t) => () => t;
function sv(t, {
  sourceEvent: n,
  target: e,
  transform: r,
  dispatch: i
}) {
  Object.defineProperties(this, {
    type: { value: t, enumerable: !0, configurable: !0 },
    sourceEvent: { value: n, enumerable: !0, configurable: !0 },
    target: { value: e, enumerable: !0, configurable: !0 },
    transform: { value: r, enumerable: !0, configurable: !0 },
    _: { value: i }
  });
}
function rn(t, n, e) {
  this.k = t, this.x = n, this.y = e;
}
rn.prototype = {
  constructor: rn,
  scale: function(t) {
    return t === 1 ? this : new rn(this.k * t, this.x, this.y);
  },
  translate: function(t, n) {
    return t === 0 & n === 0 ? this : new rn(this.k, this.x + this.k * t, this.y + this.k * n);
  },
  apply: function(t) {
    return [t[0] * this.k + this.x, t[1] * this.k + this.y];
  },
  applyX: function(t) {
    return t * this.k + this.x;
  },
  applyY: function(t) {
    return t * this.k + this.y;
  },
  invert: function(t) {
    return [(t[0] - this.x) / this.k, (t[1] - this.y) / this.k];
  },
  invertX: function(t) {
    return (t - this.x) / this.k;
  },
  invertY: function(t) {
    return (t - this.y) / this.k;
  },
  rescaleX: function(t) {
    return t.copy().domain(t.range().map(this.invertX, this).map(t.invert, t));
  },
  rescaleY: function(t) {
    return t.copy().domain(t.range().map(this.invertY, this).map(t.invert, t));
  },
  toString: function() {
    return "translate(" + this.x + "," + this.y + ") scale(" + this.k + ")";
  }
};
var Qo = new rn(1, 0, 0);
rn.prototype;
function Ei(t) {
  t.stopImmediatePropagation();
}
function ne(t) {
  t.preventDefault(), t.stopImmediatePropagation();
}
function cv(t) {
  return (!t.ctrlKey || t.type === "wheel") && !t.button;
}
function fv() {
  var t = this;
  return t instanceof SVGElement ? (t = t.ownerSVGElement || t, t.hasAttribute("viewBox") ? (t = t.viewBox.baseVal, [[t.x, t.y], [t.x + t.width, t.y + t.height]]) : [[0, 0], [t.width.baseVal.value, t.height.baseVal.value]]) : [[0, 0], [t.clientWidth, t.clientHeight]];
}
function Du() {
  return this.__zoom || Qo;
}
function lv(t) {
  return -t.deltaY * (t.deltaMode === 1 ? 0.05 : t.deltaMode ? 1 : 2e-3) * (t.ctrlKey ? 10 : 1);
}
function hv() {
  return navigator.maxTouchPoints || "ontouchstart" in this;
}
function pv(t, n, e) {
  var r = t.invertX(n[0][0]) - e[0][0], i = t.invertX(n[1][0]) - e[1][0], o = t.invertY(n[0][1]) - e[0][1], a = t.invertY(n[1][1]) - e[1][1];
  return t.translate(
    i > r ? (r + i) / 2 : Math.min(0, r) || Math.max(0, i),
    a > o ? (o + a) / 2 : Math.min(0, o) || Math.max(0, a)
  );
}
function dv() {
  var t = cv, n = fv, e = pv, r = lv, i = hv, o = [0, 1 / 0], a = [[-1 / 0, -1 / 0], [1 / 0, 1 / 0]], u = 250, c = Zd, f = Ho("start", "zoom", "end"), s, l, h, p = 500, g = 150, w = 0, b = 10;
  function _(v) {
    v.property("__zoom", Du).on("wheel.zoom", I).on("mousedown.zoom", q).on("dblclick.zoom", W).filter(i).on("touchstart.zoom", P).on("touchmove.zoom", B).on("touchend.zoom touchcancel.zoom", L).style("-webkit-tap-highlight-color", "rgba(0,0,0,0)");
  }
  _.transform = function(v, m, x, C) {
    var A = v.selection ? v.selection() : v;
    A.property("__zoom", Du), v !== A ? M(v, m, x, C) : A.interrupt().each(function() {
      R(this, arguments).event(C).start().zoom(null, typeof m == "function" ? m.apply(this, arguments) : m).end();
    });
  }, _.scaleBy = function(v, m, x, C) {
    _.scaleTo(v, function() {
      var A = this.__zoom.k, k = typeof m == "function" ? m.apply(this, arguments) : m;
      return A * k;
    }, x, C);
  }, _.scaleTo = function(v, m, x, C) {
    _.transform(v, function() {
      var A = n.apply(this, arguments), k = this.__zoom, Y = x == null ? E(A) : typeof x == "function" ? x.apply(this, arguments) : x, H = k.invert(Y), V = typeof m == "function" ? m.apply(this, arguments) : m;
      return e(y(S(k, V), Y, H), A, a);
    }, x, C);
  }, _.translateBy = function(v, m, x, C) {
    _.transform(v, function() {
      return e(this.__zoom.translate(
        typeof m == "function" ? m.apply(this, arguments) : m,
        typeof x == "function" ? x.apply(this, arguments) : x
      ), n.apply(this, arguments), a);
    }, null, C);
  }, _.translateTo = function(v, m, x, C, A) {
    _.transform(v, function() {
      var k = n.apply(this, arguments), Y = this.__zoom, H = C == null ? E(k) : typeof C == "function" ? C.apply(this, arguments) : C;
      return e(Qo.translate(H[0], H[1]).scale(Y.k).translate(
        typeof m == "function" ? -m.apply(this, arguments) : -m,
        typeof x == "function" ? -x.apply(this, arguments) : -x
      ), k, a);
    }, C, A);
  };
  function S(v, m) {
    return m = Math.max(o[0], Math.min(o[1], m)), m === v.k ? v : new rn(m, v.x, v.y);
  }
  function y(v, m, x) {
    var C = m[0] - x[0] * v.k, A = m[1] - x[1] * v.k;
    return C === v.x && A === v.y ? v : new rn(v.k, C, A);
  }
  function E(v) {
    return [(+v[0][0] + +v[1][0]) / 2, (+v[0][1] + +v[1][1]) / 2];
  }
  function M(v, m, x, C) {
    v.on("start.zoom", function() {
      R(this, arguments).event(C).start();
    }).on("interrupt.zoom end.zoom", function() {
      R(this, arguments).event(C).end();
    }).tween("zoom", function() {
      var A = this, k = arguments, Y = R(A, k).event(C), H = n.apply(A, k), V = x == null ? E(H) : typeof x == "function" ? x.apply(A, k) : x, nt = Math.max(H[1][0] - H[0][0], H[1][1] - H[0][1]), Q = A.__zoom, it = typeof m == "function" ? m.apply(A, k) : m, dt = c(Q.invert(V).concat(nt / Q.k), it.invert(V).concat(nt / it.k));
      return function(gt) {
        if (gt === 1)
          gt = it;
        else {
          var vt = dt(gt), ot = nt / vt[2];
          gt = new rn(ot, V[0] - vt[0] * ot, V[1] - vt[1] * ot);
        }
        Y.zoom(null, gt);
      };
    });
  }
  function R(v, m, x) {
    return !x && v.__zooming || new j(v, m);
  }
  function j(v, m) {
    this.that = v, this.args = m, this.active = 0, this.sourceEvent = null, this.extent = n.apply(v, m), this.taps = 0;
  }
  j.prototype = {
    event: function(v) {
      return v && (this.sourceEvent = v), this;
    },
    start: function() {
      return ++this.active === 1 && (this.that.__zooming = this, this.emit("start")), this;
    },
    zoom: function(v, m) {
      return this.mouse && v !== "mouse" && (this.mouse[1] = m.invert(this.mouse[0])), this.touch0 && v !== "touch" && (this.touch0[1] = m.invert(this.touch0[0])), this.touch1 && v !== "touch" && (this.touch1[1] = m.invert(this.touch1[0])), this.that.__zoom = m, this.emit("zoom"), this;
    },
    end: function() {
      return --this.active === 0 && (delete this.that.__zooming, this.emit("end")), this;
    },
    emit: function(v) {
      var m = en(this.that).datum();
      f.call(
        v,
        this.that,
        new sv(v, {
          sourceEvent: this.sourceEvent,
          target: _,
          type: v,
          transform: this.that.__zoom,
          dispatch: f
        }),
        m
      );
    }
  };
  function I(v, ...m) {
    if (!t.apply(this, arguments))
      return;
    var x = R(this, m).event(v), C = this.__zoom, A = Math.max(o[0], Math.min(o[1], C.k * Math.pow(2, r.apply(this, arguments)))), k = gn(v);
    if (x.wheel)
      (x.mouse[0][0] !== k[0] || x.mouse[0][1] !== k[1]) && (x.mouse[1] = C.invert(x.mouse[0] = k)), clearTimeout(x.wheel);
    else {
      if (C.k === A)
        return;
      x.mouse = [k, C.invert(k)], ur(this), x.start();
    }
    ne(v), x.wheel = setTimeout(Y, g), x.zoom("mouse", e(y(S(C, A), x.mouse[0], x.mouse[1]), x.extent, a));
    function Y() {
      x.wheel = null, x.end();
    }
  }
  function q(v, ...m) {
    if (h || !t.apply(this, arguments))
      return;
    var x = R(this, m, !0).event(v), C = en(v.view).on("mousemove.zoom", V, !0).on("mouseup.zoom", nt, !0), A = gn(v, k), k = v.currentTarget, Y = v.clientX, H = v.clientY;
    Md(v.view), Ei(v), x.mouse = [A, this.__zoom.invert(A)], ur(this), x.start();
    function V(Q) {
      if (ne(Q), !x.moved) {
        var it = Q.clientX - Y, dt = Q.clientY - H;
        x.moved = it * it + dt * dt > w;
      }
      x.event(Q).zoom("mouse", e(y(x.that.__zoom, x.mouse[0] = gn(Q, k), x.mouse[1]), x.extent, a));
    }
    function nt(Q) {
      C.on("mousemove.zoom mouseup.zoom", null), Nd(Q.view, x.moved), ne(Q), x.event(Q).end();
    }
  }
  function W(v, ...m) {
    if (t.apply(this, arguments)) {
      var x = this.__zoom, C = gn(v.changedTouches ? v.changedTouches[0] : v, this), A = x.invert(C), k = x.k * (v.shiftKey ? 0.5 : 2), Y = e(y(S(x, k), C, A), n.apply(this, m), a);
      ne(v), u > 0 ? en(this).transition().duration(u).call(M, Y, C, v) : en(this).call(_.transform, Y, C, v);
    }
  }
  function P(v, ...m) {
    if (t.apply(this, arguments)) {
      var x = v.touches, C = x.length, A = R(this, m, v.changedTouches.length === C).event(v), k, Y, H, V;
      for (Ei(v), Y = 0; Y < C; ++Y)
        H = x[Y], V = gn(H, this), V = [V, this.__zoom.invert(V), H.identifier], A.touch0 ? !A.touch1 && A.touch0[2] !== V[2] && (A.touch1 = V, A.taps = 0) : (A.touch0 = V, k = !0, A.taps = 1 + !!s);
      s && (s = clearTimeout(s)), k && (A.taps < 2 && (l = V[0], s = setTimeout(function() {
        s = null;
      }, p)), ur(this), A.start());
    }
  }
  function B(v, ...m) {
    if (this.__zooming) {
      var x = R(this, m).event(v), C = v.changedTouches, A = C.length, k, Y, H, V;
      for (ne(v), k = 0; k < A; ++k)
        Y = C[k], H = gn(Y, this), x.touch0 && x.touch0[2] === Y.identifier ? x.touch0[0] = H : x.touch1 && x.touch1[2] === Y.identifier && (x.touch1[0] = H);
      if (Y = x.that.__zoom, x.touch1) {
        var nt = x.touch0[0], Q = x.touch0[1], it = x.touch1[0], dt = x.touch1[1], gt = (gt = it[0] - nt[0]) * gt + (gt = it[1] - nt[1]) * gt, vt = (vt = dt[0] - Q[0]) * vt + (vt = dt[1] - Q[1]) * vt;
        Y = S(Y, Math.sqrt(gt / vt)), H = [(nt[0] + it[0]) / 2, (nt[1] + it[1]) / 2], V = [(Q[0] + dt[0]) / 2, (Q[1] + dt[1]) / 2];
      } else if (x.touch0)
        H = x.touch0[0], V = x.touch0[1];
      else
        return;
      x.zoom("touch", e(y(Y, H, V), x.extent, a));
    }
  }
  function L(v, ...m) {
    if (this.__zooming) {
      var x = R(this, m).event(v), C = v.changedTouches, A = C.length, k, Y;
      for (Ei(v), h && clearTimeout(h), h = setTimeout(function() {
        h = null;
      }, p), k = 0; k < A; ++k)
        Y = C[k], x.touch0 && x.touch0[2] === Y.identifier ? delete x.touch0 : x.touch1 && x.touch1[2] === Y.identifier && delete x.touch1;
      if (x.touch1 && !x.touch0 && (x.touch0 = x.touch1, delete x.touch1), x.touch0)
        x.touch0[1] = this.__zoom.invert(x.touch0[0]);
      else if (x.end(), x.taps === 2 && (Y = gn(Y, this), Math.hypot(l[0] - Y[0], l[1] - Y[1]) < b)) {
        var H = en(this).on("dblclick.zoom");
        H && H.apply(this, arguments);
      }
    }
  }
  return _.wheelDelta = function(v) {
    return arguments.length ? (r = typeof v == "function" ? v : Qe(+v), _) : r;
  }, _.filter = function(v) {
    return arguments.length ? (t = typeof v == "function" ? v : Qe(!!v), _) : t;
  }, _.touchable = function(v) {
    return arguments.length ? (i = typeof v == "function" ? v : Qe(!!v), _) : i;
  }, _.extent = function(v) {
    return arguments.length ? (n = typeof v == "function" ? v : Qe([[+v[0][0], +v[0][1]], [+v[1][0], +v[1][1]]]), _) : n;
  }, _.scaleExtent = function(v) {
    return arguments.length ? (o[0] = +v[0], o[1] = +v[1], _) : [o[0], o[1]];
  }, _.translateExtent = function(v) {
    return arguments.length ? (a[0][0] = +v[0][0], a[1][0] = +v[1][0], a[0][1] = +v[0][1], a[1][1] = +v[1][1], _) : [[a[0][0], a[0][1]], [a[1][0], a[1][1]]];
  }, _.constrain = function(v) {
    return arguments.length ? (e = v, _) : e;
  }, _.duration = function(v) {
    return arguments.length ? (u = +v, _) : u;
  }, _.interpolate = function(v) {
    return arguments.length ? (c = v, _) : c;
  }, _.on = function() {
    var v = f.on.apply(f, arguments);
    return v === f ? _ : v;
  }, _.clickDistance = function(v) {
    return arguments.length ? (w = (v = +v) * v, _) : Math.sqrt(w);
  }, _.tapDistance = function(v) {
    return arguments.length ? (b = +v, _) : b;
  }, _;
}
function Iu(t, n) {
  var e = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    n && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(t, i).enumerable;
    })), e.push.apply(e, r);
  }
  return e;
}
function zn(t) {
  for (var n = 1; n < arguments.length; n++) {
    var e = arguments[n] != null ? arguments[n] : {};
    n % 2 ? Iu(Object(e), !0).forEach(function(r) {
      gv(t, r, e[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(e)) : Iu(Object(e)).forEach(function(r) {
      Object.defineProperty(t, r, Object.getOwnPropertyDescriptor(e, r));
    });
  }
  return t;
}
function mo(t) {
  "@babel/helpers - typeof";
  return mo = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(n) {
    return typeof n;
  } : function(n) {
    return n && typeof Symbol == "function" && n.constructor === Symbol && n !== Symbol.prototype ? "symbol" : typeof n;
  }, mo(t);
}
function gv(t, n, e) {
  return n in t ? Object.defineProperty(t, n, {
    value: e,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[n] = e, t;
}
function kt() {
  return kt = Object.assign ? Object.assign.bind() : function(t) {
    for (var n = 1; n < arguments.length; n++) {
      var e = arguments[n];
      for (var r in e)
        Object.prototype.hasOwnProperty.call(e, r) && (t[r] = e[r]);
    }
    return t;
  }, kt.apply(this, arguments);
}
function vv(t, n) {
  if (t == null)
    return {};
  var e = {}, r = Object.keys(t), i, o;
  for (o = 0; o < r.length; o++)
    i = r[o], !(n.indexOf(i) >= 0) && (e[i] = t[i]);
  return e;
}
function It(t, n) {
  if (t == null)
    return {};
  var e = vv(t, n), r, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(t);
    for (i = 0; i < o.length; i++)
      r = o[i], !(n.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(t, r) && (e[r] = t[r]);
  }
  return e;
}
function mt(t, n) {
  return mv(t) || yv(t, n) || xv(t, n) || _v();
}
function mv(t) {
  if (Array.isArray(t))
    return t;
}
function yv(t, n) {
  var e = t == null ? null : typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (e != null) {
    var r = [], i = !0, o = !1, a, u;
    try {
      for (e = e.call(t); !(i = (a = e.next()).done) && (r.push(a.value), !(n && r.length === n)); i = !0)
        ;
    } catch (c) {
      o = !0, u = c;
    } finally {
      try {
        !i && e.return != null && e.return();
      } finally {
        if (o)
          throw u;
      }
    }
    return r;
  }
}
function xv(t, n) {
  if (t) {
    if (typeof t == "string")
      return Lu(t, n);
    var e = Object.prototype.toString.call(t).slice(8, -1);
    if (e === "Object" && t.constructor && (e = t.constructor.name), e === "Map" || e === "Set")
      return Array.from(t);
    if (e === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(e))
      return Lu(t, n);
  }
}
function Lu(t, n) {
  (n == null || n > t.length) && (n = t.length);
  for (var e = 0, r = new Array(n); e < n; e++)
    r[e] = t[e];
  return r;
}
function _v() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
var wv = ["width", "height", "projection", "projectionConfig"], bv = Zs, Ev = It(F0, ["geoPath"]), Qt = Bu(), Sv = function(n) {
  var e = n.projectionConfig, r = e === void 0 ? {} : e, i = n.projection, o = i === void 0 ? "geoEqualEarth" : i, a = n.width, u = a === void 0 ? 800 : a, c = n.height, f = c === void 0 ? 600 : c, s = typeof o == "function";
  if (s)
    return o;
  var l = Ev[o]().translate([u / 2, f / 2]), h = [l.center ? "center" : null, l.rotate ? "rotate" : null, l.scale ? "scale" : null, l.parallels ? "parallels" : null];
  return h.forEach(function(p) {
    p && (l = l[p](r[p] || l[p]()));
  }), l;
}, kc = function(n) {
  var e = n.width, r = n.height, i = n.projection, o = n.projectionConfig, a = It(n, wv), u = o.center || [], c = mt(u, 2), f = c[0], s = c[1], l = o.rotate || [], h = mt(l, 3), p = h[0], g = h[1], w = h[2], b = o.parallels || [], _ = mt(b, 2), S = _[0], y = _[1], E = o.scale || null, M = sr(function() {
    return Sv({
      projectionConfig: {
        center: f || f === 0 || s || s === 0 ? [f, s] : null,
        rotate: p || p === 0 || g || g === 0 ? [p, g, w] : null,
        parallels: S || S === 0 || y || y === 0 ? [S, y] : null,
        scale: E
      },
      projection: i,
      width: e,
      height: r
    });
  }, [e, r, i, f, s, p, g, w, S, y, E]), R = Tn(M, [M]), j = sr(function() {
    return {
      width: e,
      height: r,
      projection: R,
      path: bv().projection(R)
    };
  }, [e, r, R]);
  return /* @__PURE__ */ ct.createElement(Qt.Provider, kt({
    value: j
  }, a));
};
kc.propTypes = {
  width: $.number,
  height: $.number,
  projection: $.oneOfType([$.string, $.func]),
  projectionConfig: $.object
};
var Mv = ["width", "height", "projection", "projectionConfig", "className"], ta = sn(function(t, n) {
  var e = t.width, r = e === void 0 ? 800 : e, i = t.height, o = i === void 0 ? 600 : i, a = t.projection, u = a === void 0 ? "geoEqualEarth" : a, c = t.projectionConfig, f = c === void 0 ? {} : c, s = t.className, l = s === void 0 ? "" : s, h = It(t, Mv);
  return /* @__PURE__ */ ct.createElement(kc, {
    width: r,
    height: o,
    projection: u,
    projectionConfig: f
  }, /* @__PURE__ */ ct.createElement("svg", kt({
    ref: n,
    viewBox: "0 0 ".concat(r, " ").concat(o),
    className: "rsm-svg ".concat(l)
  }, h)));
});
ta.displayName = "ComposableMap";
ta.propTypes = {
  width: $.number,
  height: $.number,
  projection: $.oneOfType([$.string, $.func]),
  projectionConfig: $.object,
  className: $.string
};
function qu(t, n, e) {
  var r = (t * e.k - t) / 2, i = (n * e.k - n) / 2;
  return [t / 2 - (r + e.x) / e.k, n / 2 - (i + e.y) / e.k];
}
function Nv(t) {
  return fetch(t).then(function(n) {
    if (!n.ok)
      throw Error(n.statusText);
    return n.json();
  }).catch(function(n) {
    console.log("There was a problem when fetching the data: ", n);
  });
}
function Yu(t, n) {
  var e = t.type === "Topology";
  if (!e)
    return n ? n(t.features || t) : t.features || t;
  var r = q0(t, t.objects[Object.keys(t.objects)[0]]).features;
  return n ? n(r) : r;
}
function Gu(t) {
  var n = t.type === "Topology";
  if (!n)
    return null;
  var e = wu(t, t.objects[Object.keys(t.objects)[0]], function(i, o) {
    return i === o;
  }), r = wu(t, t.objects[Object.keys(t.objects)[0]], function(i, o) {
    return i !== o;
  });
  return {
    outline: e,
    borders: r
  };
}
function $v(t, n, e) {
  return t && n ? {
    outline: zn(zn({}, t), {}, {
      rsmKey: "outline",
      svgPath: e(t)
    }),
    borders: zn(zn({}, n), {}, {
      rsmKey: "borders",
      svgPath: e(n)
    })
  } : {};
}
function Pv(t, n) {
  return t ? t.map(function(e, r) {
    return zn(zn({}, e), {}, {
      rsmKey: "geo-".concat(r),
      svgPath: n(e)
    });
  }) : [];
}
function Rv() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 30, n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 30, e = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0.5, r = Array.isArray(e) ? e : [e, e], i = t / 2 * r[0], o = n / 2 * r[1];
  return "M".concat(0, ",", 0, " Q", -t / 2 - i, ",").concat(-n / 2 + o, " ").concat(-t, ",").concat(-n);
}
function kv(t) {
  return typeof t == "string";
}
function Cv(t) {
  var n = t.geography, e = t.parseGeographies, r = cn(Qt), i = r.path, o = on({}), a = mt(o, 2), u = a[0], c = a[1];
  Si(function() {
    (typeof window > "u" ? "undefined" : mo(window)) !== "undefined" && n && (kv(n) ? Nv(n).then(function(p) {
      p && c({
        geographies: Yu(p, e),
        mesh: Gu(p)
      });
    }) : c({
      geographies: Yu(n, e),
      mesh: Gu(n)
    }));
  }, [n, e]);
  var f = sr(function() {
    var p = u.mesh || {}, g = $v(p.outline, p.borders, i);
    return {
      geographies: Pv(u.geographies, i),
      outline: g.outline,
      borders: g.borders
    };
  }, [u, i]), s = f.geographies, l = f.outline, h = f.borders;
  return {
    geographies: s,
    outline: l,
    borders: h
  };
}
var Tv = ["geography", "children", "parseGeographies", "className"], na = sn(function(t, n) {
  var e = t.geography, r = t.children, i = t.parseGeographies, o = t.className, a = o === void 0 ? "" : o, u = It(t, Tv), c = cn(Qt), f = c.path, s = c.projection, l = Cv({
    geography: e,
    parseGeographies: i
  }), h = l.geographies, p = l.outline, g = l.borders;
  return /* @__PURE__ */ ct.createElement("g", kt({
    ref: n,
    className: "rsm-geographies ".concat(a)
  }, u), h && h.length > 0 && r({
    geographies: h,
    outline: p,
    borders: g,
    path: f,
    projection: s
  }));
});
na.displayName = "Geographies";
na.propTypes = {
  geography: $.oneOfType([$.string, $.object, $.array]),
  children: $.func,
  parseGeographies: $.func,
  className: $.string
};
var Av = ["geography", "onMouseEnter", "onMouseLeave", "onMouseDown", "onMouseUp", "onFocus", "onBlur", "style", "className"], ea = sn(function(t, n) {
  var e = t.geography, r = t.onMouseEnter, i = t.onMouseLeave, o = t.onMouseDown, a = t.onMouseUp, u = t.onFocus, c = t.onBlur, f = t.style, s = f === void 0 ? {} : f, l = t.className, h = l === void 0 ? "" : l, p = It(t, Av), g = on(!1), w = mt(g, 2), b = w[0], _ = w[1], S = on(!1), y = mt(S, 2), E = y[0], M = y[1];
  function R(B) {
    M(!0), r && r(B);
  }
  function j(B) {
    M(!1), b && _(!1), i && i(B);
  }
  function I(B) {
    M(!0), u && u(B);
  }
  function q(B) {
    M(!1), b && _(!1), c && c(B);
  }
  function W(B) {
    _(!0), o && o(B);
  }
  function P(B) {
    _(!1), a && a(B);
  }
  return /* @__PURE__ */ ct.createElement("path", kt({
    ref: n,
    tabIndex: "0",
    className: "rsm-geography ".concat(h),
    d: e.svgPath,
    onMouseEnter: R,
    onMouseLeave: j,
    onFocus: I,
    onBlur: q,
    onMouseDown: W,
    onMouseUp: P,
    style: s[b || E ? b ? "pressed" : "hover" : "default"]
  }, p));
});
ea.displayName = "Geography";
ea.propTypes = {
  geography: $.object,
  onMouseEnter: $.func,
  onMouseLeave: $.func,
  onMouseDown: $.func,
  onMouseUp: $.func,
  onFocus: $.func,
  onBlur: $.func,
  style: $.object,
  className: $.string
};
var Ov = Br(ea), jv = ["fill", "stroke", "step", "className"], ra = sn(function(t, n) {
  var e = t.fill, r = e === void 0 ? "transparent" : e, i = t.stroke, o = i === void 0 ? "currentcolor" : i, a = t.step, u = a === void 0 ? [10, 10] : a, c = t.className, f = c === void 0 ? "" : c, s = It(t, jv), l = cn(Qt), h = l.path;
  return /* @__PURE__ */ ct.createElement("path", kt({
    ref: n,
    d: h(Co().step(u)()),
    fill: r,
    stroke: o,
    className: "rsm-graticule ".concat(f)
  }, s));
});
ra.displayName = "Graticule";
ra.propTypes = {
  fill: $.string,
  stroke: $.string,
  step: $.array,
  className: $.string
};
Br(ra);
var zv = ["value"], Fv = Bu(), Dv = {
  x: 0,
  y: 0,
  k: 1,
  transformString: "translate(0 0) scale(1)"
}, Cc = function(n) {
  var e = n.value, r = e === void 0 ? Dv : e, i = It(n, zv);
  return /* @__PURE__ */ ct.createElement(Fv.Provider, kt({
    value: r
  }, i));
};
Cc.propTypes = {
  x: $.number,
  y: $.number,
  k: $.number,
  transformString: $.string
};
function Iv(t) {
  var n = t.center, e = t.filterZoomEvent, r = t.onMoveStart, i = t.onMoveEnd, o = t.onMove, a = t.translateExtent, u = a === void 0 ? [[-1 / 0, -1 / 0], [1 / 0, 1 / 0]] : a, c = t.scaleExtent, f = c === void 0 ? [1, 8] : c, s = t.zoom, l = s === void 0 ? 1 : s, h = cn(Qt), p = h.width, g = h.height, w = h.projection, b = mt(n, 2), _ = b[0], S = b[1], y = on({
    x: 0,
    y: 0,
    k: 1
  }), E = mt(y, 2), M = E[0], R = E[1], j = qe({
    x: 0,
    y: 0,
    k: 1
  }), I = qe(), q = qe(), W = qe(!1), P = mt(u, 2), B = P[0], L = P[1], v = mt(B, 2), m = v[0], x = v[1], C = mt(L, 2), A = C[0], k = C[1], Y = mt(f, 2), H = Y[0], V = Y[1];
  return Si(function() {
    var nt = en(I.current);
    function Q(ot) {
      !r || W.current || r({
        coordinates: w.invert(qu(p, g, ot.transform)),
        zoom: ot.transform.k
      }, ot);
    }
    function it(ot) {
      if (!W.current) {
        var Ct = ot.transform, dn = ot.sourceEvent;
        R({
          x: Ct.x,
          y: Ct.y,
          k: Ct.k,
          dragging: dn
        }), o && o({
          x: Ct.x,
          y: Ct.y,
          zoom: Ct.k,
          dragging: dn
        }, ot);
      }
    }
    function dt(ot) {
      if (W.current) {
        W.current = !1;
        return;
      }
      var Ct = w.invert(qu(p, g, ot.transform)), dn = mt(Ct, 2), Zn = dn[0], Fe = dn[1];
      j.current = {
        x: Zn,
        y: Fe,
        k: ot.transform.k
      }, i && i({
        coordinates: [Zn, Fe],
        zoom: ot.transform.k
      }, ot);
    }
    function gt(ot) {
      return e ? e(ot) : ot ? !ot.ctrlKey && !ot.button : !1;
    }
    var vt = dv().filter(gt).scaleExtent([H, V]).translateExtent([[m, x], [A, k]]).on("start", Q).on("zoom", it).on("end", dt);
    q.current = vt, nt.call(vt);
  }, [p, g, m, x, A, k, H, V, w, r, o, i, e]), Si(function() {
    if (!(_ === j.current.x && S === j.current.y && l === j.current.k)) {
      var nt = w([_, S]), Q = nt[0] * l, it = nt[1] * l, dt = en(I.current);
      W.current = !0, dt.call(q.current.transform, Qo.translate(p / 2 - Q, g / 2 - it).scale(l)), R({
        x: p / 2 - Q,
        y: g / 2 - it,
        k: l
      }), j.current = {
        x: _,
        y: S,
        k: l
      };
    }
  }, [_, S, l, p, g, w]), {
    mapRef: I,
    position: M,
    transformString: "translate(".concat(M.x, " ").concat(M.y, ") scale(").concat(M.k, ")")
  };
}
var Lv = ["center", "zoom", "minZoom", "maxZoom", "translateExtent", "filterZoomEvent", "onMoveStart", "onMove", "onMoveEnd", "className"], ia = sn(function(t, n) {
  var e = t.center, r = e === void 0 ? [0, 0] : e, i = t.zoom, o = i === void 0 ? 1 : i, a = t.minZoom, u = a === void 0 ? 1 : a, c = t.maxZoom, f = c === void 0 ? 8 : c, s = t.translateExtent, l = t.filterZoomEvent, h = t.onMoveStart, p = t.onMove, g = t.onMoveEnd, w = t.className, b = It(t, Lv), _ = cn(Qt), S = _.width, y = _.height, E = Iv({
    center: r,
    filterZoomEvent: l,
    onMoveStart: h,
    onMove: p,
    onMoveEnd: g,
    scaleExtent: [u, f],
    translateExtent: s,
    zoom: o
  }), M = E.mapRef, R = E.transformString, j = E.position;
  return /* @__PURE__ */ ct.createElement(Cc, {
    value: {
      x: j.x,
      y: j.y,
      k: j.k,
      transformString: R
    }
  }, /* @__PURE__ */ ct.createElement("g", {
    ref: M
  }, /* @__PURE__ */ ct.createElement("rect", {
    width: S,
    height: y,
    fill: "transparent"
  }), /* @__PURE__ */ ct.createElement("g", kt({
    ref: n,
    transform: R,
    className: "rsm-zoomable-group ".concat(w)
  }, b))));
});
ia.displayName = "ZoomableGroup";
ia.propTypes = {
  center: $.array,
  zoom: $.number,
  minZoom: $.number,
  maxZoom: $.number,
  translateExtent: $.arrayOf($.array),
  onMoveStart: $.func,
  onMove: $.func,
  onMoveEnd: $.func,
  className: $.string
};
var qv = ["id", "fill", "stroke", "strokeWidth", "className"], oa = sn(function(t, n) {
  var e = t.id, r = e === void 0 ? "rsm-sphere" : e, i = t.fill, o = i === void 0 ? "transparent" : i, a = t.stroke, u = a === void 0 ? "currentcolor" : a, c = t.strokeWidth, f = c === void 0 ? 0.5 : c, s = t.className, l = s === void 0 ? "" : s, h = It(t, qv), p = cn(Qt), g = p.path, w = sr(function() {
    return g({
      type: "Sphere"
    });
  }, [g]);
  return /* @__PURE__ */ ct.createElement(of, null, /* @__PURE__ */ ct.createElement("defs", null, /* @__PURE__ */ ct.createElement("clipPath", {
    id: r
  }, /* @__PURE__ */ ct.createElement("path", {
    d: w
  }))), /* @__PURE__ */ ct.createElement("path", kt({
    ref: n,
    d: w,
    fill: o,
    stroke: u,
    strokeWidth: f,
    style: {
      pointerEvents: "none"
    },
    className: "rsm-sphere ".concat(l)
  }, h)));
});
oa.displayName = "Sphere";
oa.propTypes = {
  id: $.string,
  fill: $.string,
  stroke: $.string,
  strokeWidth: $.number,
  className: $.string
};
Br(oa);
var Yv = ["coordinates", "children", "onMouseEnter", "onMouseLeave", "onMouseDown", "onMouseUp", "onFocus", "onBlur", "style", "className"], Tc = sn(function(t, n) {
  var e = t.coordinates, r = t.children, i = t.onMouseEnter, o = t.onMouseLeave, a = t.onMouseDown, u = t.onMouseUp, c = t.onFocus, f = t.onBlur, s = t.style, l = s === void 0 ? {} : s, h = t.className, p = h === void 0 ? "" : h, g = It(t, Yv), w = cn(Qt), b = w.projection, _ = on(!1), S = mt(_, 2), y = S[0], E = S[1], M = on(!1), R = mt(M, 2), j = R[0], I = R[1], q = b(e), W = mt(q, 2), P = W[0], B = W[1];
  function L(k) {
    I(!0), i && i(k);
  }
  function v(k) {
    I(!1), y && E(!1), o && o(k);
  }
  function m(k) {
    I(!0), c && c(k);
  }
  function x(k) {
    I(!1), y && E(!1), f && f(k);
  }
  function C(k) {
    E(!0), a && a(k);
  }
  function A(k) {
    E(!1), u && u(k);
  }
  return /* @__PURE__ */ ct.createElement("g", kt({
    ref: n,
    transform: "translate(".concat(P, ", ").concat(B, ")"),
    className: "rsm-marker ".concat(p),
    onMouseEnter: L,
    onMouseLeave: v,
    onFocus: m,
    onBlur: x,
    onMouseDown: C,
    onMouseUp: A,
    style: l[y || j ? y ? "pressed" : "hover" : "default"]
  }, g), r);
});
Tc.displayName = "Marker";
Tc.propTypes = {
  coordinates: $.array,
  children: $.oneOfType([$.node, $.arrayOf($.node)]),
  onMouseEnter: $.func,
  onMouseLeave: $.func,
  onMouseDown: $.func,
  onMouseUp: $.func,
  onFocus: $.func,
  onBlur: $.func,
  style: $.object,
  className: $.string
};
var Gv = ["from", "to", "coordinates", "stroke", "strokeWidth", "fill", "className"], Ac = sn(function(t, n) {
  var e = t.from, r = e === void 0 ? [0, 0] : e, i = t.to, o = i === void 0 ? [0, 0] : i, a = t.coordinates, u = t.stroke, c = u === void 0 ? "currentcolor" : u, f = t.strokeWidth, s = f === void 0 ? 3 : f, l = t.fill, h = l === void 0 ? "transparent" : l, p = t.className, g = p === void 0 ? "" : p, w = It(t, Gv), b = cn(Qt), _ = b.path, S = {
    type: "LineString",
    coordinates: a || [r, o]
  };
  return /* @__PURE__ */ ct.createElement("path", kt({
    ref: n,
    d: _(S),
    className: "rsm-line ".concat(g),
    stroke: c,
    strokeWidth: s,
    fill: h
  }, w));
});
Ac.displayName = "Line";
Ac.propTypes = {
  from: $.array,
  to: $.array,
  coordinates: $.array,
  stroke: $.string,
  strokeWidth: $.number,
  fill: $.string,
  className: $.string
};
var Wv = ["subject", "children", "connectorProps", "dx", "dy", "curve", "className"], Oc = sn(function(t, n) {
  var e = t.subject, r = t.children, i = t.connectorProps, o = t.dx, a = o === void 0 ? 30 : o, u = t.dy, c = u === void 0 ? 30 : u, f = t.curve, s = f === void 0 ? 0 : f, l = t.className, h = l === void 0 ? "" : l, p = It(t, Wv), g = cn(Qt), w = g.projection, b = w(e), _ = mt(b, 2), S = _[0], y = _[1], E = Rv(a, c, s);
  return /* @__PURE__ */ ct.createElement("g", kt({
    ref: n,
    transform: "translate(".concat(S + a, ", ").concat(y + c, ")"),
    className: "rsm-annotation ".concat(h)
  }, p), /* @__PURE__ */ ct.createElement("path", kt({
    d: E,
    fill: "transparent",
    stroke: "#000"
  }, i)), r);
});
Oc.displayName = "Annotation";
Oc.propTypes = {
  subject: $.array,
  children: $.oneOfType([$.node, $.arrayOf($.node)]),
  dx: $.number,
  dy: $.number,
  curve: $.number,
  connectorProps: $.object,
  className: $.string
};
const Bv = () => /* @__PURE__ */ tt.jsxs("g", { fill: "none", fillRule: "evenodd", transform: "translate(479 200)", strokeWidth: "2", stroke: "#3af", children: [
  /* @__PURE__ */ tt.jsxs("circle", { cx: "22", cy: "22", r: "6", strokeOpacity: "0", children: [
    /* @__PURE__ */ tt.jsx(
      "animate",
      {
        attributeName: "r",
        begin: "1.5s",
        dur: "3s",
        values: "6;22",
        calcMode: "linear",
        repeatCount: "indefinite"
      }
    ),
    /* @__PURE__ */ tt.jsx(
      "animate",
      {
        attributeName: "stroke-opacity",
        begin: "1.5s",
        dur: "3s",
        values: "1;0",
        calcMode: "linear",
        repeatCount: "indefinite"
      }
    ),
    /* @__PURE__ */ tt.jsx(
      "animate",
      {
        attributeName: "stroke-width",
        begin: "1.5s",
        dur: "3s",
        values: "2;0",
        calcMode: "linear",
        repeatCount: "indefinite"
      }
    )
  ] }),
  /* @__PURE__ */ tt.jsxs("circle", { cx: "22", cy: "22", r: "6", strokeOpacity: "0", children: [
    /* @__PURE__ */ tt.jsx(
      "animate",
      {
        attributeName: "r",
        begin: "3s",
        dur: "3s",
        values: "6;22",
        calcMode: "linear",
        repeatCount: "indefinite"
      }
    ),
    /* @__PURE__ */ tt.jsx(
      "animate",
      {
        attributeName: "stroke-opacity",
        begin: "3s",
        dur: "3s",
        values: "1;0",
        calcMode: "linear",
        repeatCount: "indefinite"
      }
    ),
    /* @__PURE__ */ tt.jsx(
      "animate",
      {
        attributeName: "stroke-width",
        begin: "3s",
        dur: "3s",
        values: "2;0",
        calcMode: "linear",
        repeatCount: "indefinite"
      }
    )
  ] }),
  /* @__PURE__ */ tt.jsx("circle", { cx: "22", cy: "22", r: "8", children: /* @__PURE__ */ tt.jsx(
    "animate",
    {
      attributeName: "r",
      begin: "0s",
      dur: "1.5s",
      values: "6;1;2;3;4;5;6",
      calcMode: "linear",
      repeatCount: "indefinite"
    }
  ) })
] });
function Hv(t, n) {
  return as(t) ? t(n) : t || "auto";
}
function Xv(t) {
  return !Array.isArray(t) || t.length < 1;
}
const Uv = ({ geography: t, onMouseEnter: n, onMouseMove: e, onMouseLeave: r, onClick: i, fillHover: o, fillDefault: a, cursor: u, height: c }) => /* @__PURE__ */ tt.jsx(
  ta,
  {
    projection: "geoEqualEarth",
    projectionConfig: {
      scale: 205,
      rotation: [-11, 0, 0]
    },
    width: 980,
    height: 551,
    style: {
      width: "100%",
      height: `${c - 5}px`
    },
    children: /* @__PURE__ */ tt.jsx(ia, { center: [0, 10], zoom: 1, maxZoom: 1, children: /* @__PURE__ */ tt.jsx(na, { geography: t, children: ({ geographies: f }) => Xv(f) ? /* @__PURE__ */ tt.jsx(Bv, {}) : f.map((s) => /* @__PURE__ */ tt.jsx(
      Ov,
      {
        geography: s,
        onMouseEnter: (l) => n == null ? void 0 : n(l, s),
        onMouseMove: (l) => e == null ? void 0 : e(l, s),
        onMouseLeave: (l) => r == null ? void 0 : r(l, s),
        onClick: (l) => i == null ? void 0 : i(l, s),
        style: {
          default: {
            fill: a == null ? void 0 : a(s),
            stroke: "#DDDDDD",
            strokeWidth: 0.75,
            outline: "none"
          },
          hover: {
            fill: o == null ? void 0 : o(s),
            stroke: "#607D8B",
            strokeWidth: 1,
            outline: "none",
            cursor: Hv(u, s)
          },
          pressed: {
            fill: "#263238",
            stroke: "#607D8B",
            strokeWidth: 0.75,
            outline: "none"
          }
        }
      },
      s.rsmKey
    )) }) })
  }
), Vv = Br(Uv), Zv = Eo((t) => Array.isArray(t) && t.every((n) => n.name && n.iso2 && !Number.isNaN(Number.parseInt(n.value, 10)))), jc = "#F5F5F5", Kv = "#A8DEF2", Jv = "#0A8FC8", Qv = "#1B2049", Wu = Eo((t) => t.filter(({ value: e }) => e > 0).sort((e, r) => e.value - r.value).map(({ iso2: e }) => e)), tm = () => jc, nm = Eo((t) => {
  var i, o;
  if (!t || t.length === 0)
    return tm;
  const n = t.filter(({ value: a }) => a > 0).sort((a, u) => a.value - u.value), e = n.map(({ iso2: a }) => a), r = gs().domain([0, ((i = n[0]) == null ? void 0 : i.value) || 0, ((o = n[n.length - 1]) == null ? void 0 : o.value) || 0]).range([jc, Kv, Jv]);
  return (a) => r(e.includes(a) ? t.find(({ iso2: u }) => a === u).value : 0);
}), zc = ({ geography: t, data: n, formatter: e, onClick: r, selectedCountries: i, height: o }) => {
  const [a, u] = on({
    tooltip: {
      show: !1,
      x: 0,
      y: 0,
      country: null,
      value: null,
      payload: null
    }
  }), c = Tn((p, g) => {
    const w = n.find(({ iso2: b }) => g.properties.ISO_A2 === b);
    w && u(
      fi((b) => {
        b.tooltip.country = w.name, b.tooltip.value = w.value, b.tooltip.payload = w;
      })
    );
  }, [u, n]), f = Tn((p, g) => {
    if (n && Wu(n).includes(g.properties.ISO_A2)) {
      const { clientLeft: w, clientTop: b } = document.documentElement, { scrollX: _, scrollY: S } = window, y = p.clientX + (_ - w), E = p.clientY + (S - b);
      u(
        fi((M) => {
          M.tooltip.show = !0, M.tooltip.x = y, M.tooltip.y = E;
        })
      );
    }
  }, [u, n]), s = Tn(() => {
    u(
      fi((p) => {
        p.tooltip.show = !1;
      })
    );
  }, [u]), l = (p) => as(r) && n && Wu(n).includes(p.properties.ISO_A2) ? "pointer" : "auto", h = Tn((p) => i.includes(p.properties.ISO_A2) ? Qv : nm(n)(p.properties.ISO_A2), [n, i]);
  return t ? Zv(n) ? /* @__PURE__ */ tt.jsxs(tt.Fragment, { children: [
    /* @__PURE__ */ tt.jsx(
      Vv,
      {
        geography: t,
        onClick: r,
        cursor: l,
        fillDefault: h,
        fillHover: h,
        onMouseEnter: c,
        onMouseMove: f,
        onMouseLeave: s,
        height: o
      }
    ),
    a.tooltip.show && /* @__PURE__ */ tt.jsxs(vs, { x: a.tooltip.x, y: a.tooltip.y, children: [
      /* @__PURE__ */ tt.jsx("div", { children: /* @__PURE__ */ tt.jsx("strong", { children: a.tooltip.country }) }),
      /* @__PURE__ */ tt.jsx("div", { children: e(a.tooltip.value, a.tooltip.payload) })
    ] })
  ] }) : /* @__PURE__ */ tt.jsx("div", { style: { height: o }, children: "Bad data format" }) : /* @__PURE__ */ tt.jsx("div", { style: { height: o }, children: "Bad geography" });
};
zc.defaultProps = {
  geography: void 0,
  data: [],
  formatter: ol,
  onClick: void 0,
  selectedCountries: [],
  height: 400
};
zc.propTypes = {
  geography: $.any.isRequired,
  data: $.arrayOf($.object),
  formatter: $.func,
  onClick: $.func,
  selectedCountries: $.arrayOf($.string),
  height: $.number
};
export {
  zc as Map
};
